(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("Tbt6s", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PDPWrapper", function () { return $0a5e088e2945420e$export$2e87323843d02ad4; });
$parcel$export(module.exports, "make", function () { return $0a5e088e2945420e$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $0a5e088e2945420e$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $0a5e088e2945420e$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $9JLuv = parcelRequire("9JLuv");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $hfCPd = parcelRequire("hfCPd");

var $3qnJm = parcelRequire("3qnJm");

var $1xf0g = parcelRequire("1xf0g");

var $8iMy9 = parcelRequire("8iMy9");

var $bBMv4 = parcelRequire("bBMv4");

var $h6rW7 = parcelRequire("h6rW7");

var $2sYBg = parcelRequire("2sYBg");

var $7D5xx = parcelRequire("7D5xx");

var $38gYA = parcelRequire("38gYA");

var $gFKzh = parcelRequire("gFKzh");

var $ePRCc = parcelRequire("ePRCc");

var $dJhID = parcelRequire("dJhID");

var $bbixw = parcelRequire("bbixw");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $hBcYV = parcelRequire("hBcYV");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $hO3nk = parcelRequire("hO3nk");

var $cZrFr = parcelRequire("cZrFr");

var $ja0oJ = parcelRequire("ja0oJ");

var $9pMGg = parcelRequire("9pMGg");

var $2vzQN = parcelRequire("2vzQN");

var $huObo = parcelRequire("huObo");

var $2wB5I = parcelRequire("2wB5I");

var $8E2YL = parcelRequire("8E2YL");

var $1nuZE = parcelRequire("1nuZE");

var $6EwcS = parcelRequire("6EwcS");

var $gUsPc = parcelRequire("gUsPc");
function $0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper(Props) {
    var children = Props.children;
    var product = Props.product;
    var variant = Props.variant;
    var match = $8E2YL.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    return /*#__PURE__*/ $g85JO.createElement($3qnJm.make, $3qnJm.makeProps(product, variant, undefined, match.config.settings.hideOutOfStock, match$1.onProductFormChange, match$1.onProductFormSubmit, /*#__PURE__*/ $g85JO.createElement($1nuZE.Provider.make, {
        product: product,
        variant: variant,
        children: children
    }), undefined, undefined));
}
$0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper.displayName = "ProductDetailsPage.PDPWrapper";
var $0a5e088e2945420e$export$2e87323843d02ad4 = {
    make: $0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper
};
function $0a5e088e2945420e$var$ProductDetailsPage(Props) {
    var viewport = Props.viewport;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var shouldForceMobileOpt = Props.shouldForceMobile;
    var isInsideQuickViewOpt = Props.isInsideQuickView;
    var quickViewConfig = Props.quickViewConfig;
    var productId = Props.productId;
    var showMoreProducts = Props.showMoreProducts;
    var showLauncherOpt = Props.showLauncher;
    var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
    var isInsideQuickView = isInsideQuickViewOpt !== undefined ? isInsideQuickViewOpt : false;
    var showLauncher = showLauncherOpt !== undefined ? showLauncherOpt : false;
    $2wB5I.usePausePageScrolling(undefined);
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var account = match$1.transitiveAccount;
    var storeId = match$1.transitiveStoreId;
    var settings = match$1.settings;
    var configId = match$1.id;
    var scrollToRef = $g85JO.useRef(function(param) {});
    var fallbackScrollableContainerRef = $g85JO.useRef(null);
    var scrollableContainerRef$1 = $2whNH.getWithDefault(scrollableContainerRef, fallbackScrollableContainerRef);
    var fallbackViewportRef = $g85JO.useRef(null);
    var viewport$1 = $2whNH.getWithDefault(viewport, fallbackViewportRef);
    var match$2 = $9pMGg.use(undefined);
    var onBackClick = match$2.onBackClick;
    var trackEvent = match$2.trackEvent;
    var embedType = match$2.embedType;
    var match$3 = $aSJcu.use(undefined);
    var isMobile = match$3.isMobile;
    var match$4 = $6EwcS.use(undefined);
    var addToHistory = match$4.history.add;
    var match$5 = $hBcYV.useRouter(undefined);
    var anyVariantId = match$5.anyVariantId;
    var anyProductId = match$5.anyProductId;
    var listPageType = match$5.listPageType;
    var route = match$5.route;
    var stickyHeaderOffset = $gUsPc.useLenient(undefined);
    var productId$1;
    if (productId !== undefined) productId$1 = productId;
    else if (typeof route === "number") productId$1 = anyProductId;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            productId$1 = isInsideQuickView ? anyProductId : route._0.productId;
            break;
        case /* QuickView */ 3:
            productId$1 = isInsideQuickView ? route._0.productId : anyProductId;
            break;
        default:
            productId$1 = anyProductId;
    }
    var variantId;
    if (typeof route === "number") variantId = anyVariantId;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            variantId = isInsideQuickView ? anyVariantId : route._0.variantId;
            break;
        case /* QuickView */ 3:
            variantId = isInsideQuickView ? route._0.variantId : anyVariantId;
            break;
        default:
            variantId = anyVariantId;
    }
    var pdpCategory = $ja0oJ.useProductCategory(match$2.smartnavApiHost, storeId, productId$1, route, !isInsideQuickView);
    $g85JO.useEffect(function() {
        if (productId$1 !== undefined && $7bjme.notequal(listPageType, /* History */ 1) && $7bjme.notequal($1xf0g.ExternalConnection.getConnection(pdpCategory), /* History */ 0)) $iv6Yc._1(addToHistory, {
            TAG: /* ProductId */ 1,
            _0: productId$1
        });
    }, [
        productId$1
    ]);
    var config = $ja0oJ.usePDPPagination(quickViewConfig, pdpCategory, settings, productId$1, variantId);
    var product = $g85JO.useMemo(function() {
        return $8iMy9.getActiveProduct(config);
    }, [
        $8iMy9.getKey(config)
    ]);
    var variant = $g85JO.useMemo(function() {
        return $8iMy9.getActiveVariant(config);
    }, [
        $8iMy9.getKey(config)
    ]);
    $g85JO.useEffect(function() {
        if (product !== undefined) {
            var tmp;
            tmp = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0.mediaId;
            $iv6Yc.app(trackEvent, [
                "product details:open",
                undefined,
                undefined,
                product,
                variant,
                undefined,
                undefined,
                undefined,
                tmp,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        }
    }, [
        $2whNH.map(product, function(product) {
            return product.id;
        })
    ]);
    $g85JO.useEffect(function() {
        if (product !== undefined && variant !== undefined) $gFKzh.trackRetargeting(account, configId, pdpCategory, product, variant, isMobile, undefined, undefined, 1, undefined, undefined, "view_item");
    }, [
        $2whNH.map(product, function(product) {
            return product.id;
        })
    ]);
    var renderPDPControls = function renderPDPControls(param) {
        var isNewMobileLayout = settings.newMobilePDP;
        var isBuiltinPDP = embedType !== /* ProductDetailsPage */ 5;
        var isOldDesktopLayout = !isMobile && settings.desktopPDPLayout === /* Old */ 0;
        var isQuickViewOldPDPMobile = isMobile && isInsideQuickView && !isNewMobileLayout;
        var isBuiltinPDPDesktop = !isMobile && isBuiltinPDP && !isInsideQuickView;
        var isBuiltinOldPDPMobile = isMobile && isBuiltinPDP && !isNewMobileLayout && !isInsideQuickView;
        var shouldRenderNavbar = isQuickViewOldPDPMobile || isBuiltinPDPDesktop || isBuiltinOldPDPMobile;
        if (shouldRenderNavbar) return /*#__PURE__*/ $g85JO.createElement($2sYBg.make, {
            close: isOldDesktopLayout
        });
        else return null;
    };
    var renderLauncher = !isInsideQuickView && showLauncher ? function renderLauncher(className) {
        return /*#__PURE__*/ $g85JO.createElement($8E2YL.make, {
            embedType: /* Launcher */ 2,
            configId: configId,
            children: /*#__PURE__*/ $g85JO.createElement($efwy1.Provider.make, {
                namespace: $h6rW7.fromString("pl"),
                children: /*#__PURE__*/ $g85JO.createElement($hBcYV.make, {
                    configId: configId,
                    embedType: /* Launcher */ 2,
                    children: /*#__PURE__*/ $g85JO.createElement($gUsPc.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($hO3nk.make, {
                            configId: configId,
                            embedType: /* Launcher */ 2,
                            className: className
                        })
                    })
                })
            }),
            enableTrimmingTreeByReferrer: false
        });
    } : undefined;
    var renderPDP = function renderPDP(param) {
        var match = settings.pdpComponent;
        if (match !== undefined && product !== undefined && variant !== undefined) return /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
            children: /*#__PURE__*/ $g85JO.createElement($hfCPd.ProductRenderer.make, {
                componentId: match.id,
                data: product,
                props: match.props,
                renderFallback: function renderFallback(param) {
                    return null;
                }
            })
        });
        else {
            var match$1 = config.error;
            var match$2 = settings.newMobilePDP;
            var match$3 = settings.desktopPDPLayout;
            if (match$1 !== undefined) return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
                error: $4QdUt.makeError(true, $2whNH.getWithDefault($2whNH.flatMap($bBMv4.as_js_exn(match$1), function(e) {
                    return e.message;
                }), "An unexpected error occurred while loading product.")),
                extraInfo: {
                    requestedStoreId: storeId,
                    requestedProductId: productId$1,
                    requestedVariantId: variantId,
                    gotProductId: $2whNH.map(product, function(product) {
                        return product.id;
                    }),
                    gotVariantId: $2whNH.map(variant, function(variant) {
                        return variant.id;
                    })
                },
                redirect: onBackClick,
                absolute: true
            });
            if (product !== undefined && variant !== undefined) {
                var exit = 0;
                var exit$1 = 0;
                if (match$2) {
                    if (isMobile) {
                        var tmp = {
                            product: product,
                            variant: variant,
                            productCategory: pdpCategory,
                            config: config,
                            shouldForceMobile: shouldForceMobile,
                            settings: settings,
                            isInsideQuickView: isInsideQuickView,
                            scrollableContainerRef: scrollableContainerRef$1,
                            scrollToRef: scrollToRef
                        };
                        if (productId$1 !== undefined) tmp.routeProductId = productId$1;
                        if (variantId !== undefined) tmp.routeVariantId = variantId;
                        if (showMoreProducts !== undefined) tmp.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
                        if (renderLauncher !== undefined) tmp.renderLauncher = $loT9g.valFromOption(renderLauncher);
                        return /*#__PURE__*/ $g85JO.createElement($0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper, {
                            children: /*#__PURE__*/ $g85JO.createElement($cZrFr.make, tmp),
                            product: product,
                            variant: variant
                        });
                    }
                    exit$1 = 3;
                } else exit$1 = 3;
                if (exit$1 === 3) {
                    if (match$3 !== 0 && !(isMobile || isInsideQuickView)) {
                        var tmp$1 = {
                            config: config,
                            product: product,
                            variant: variant,
                            productCategory: pdpCategory,
                            shouldForceMobile: shouldForceMobile,
                            isInsideQuickView: isInsideQuickView,
                            viewport: viewport$1,
                            scrollableContainerRef: scrollableContainerRef$1,
                            scrollToRef: scrollToRef
                        };
                        if (showMoreProducts !== undefined) tmp$1.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
                        if (renderLauncher !== undefined) tmp$1.renderLauncher = $loT9g.valFromOption(renderLauncher);
                        return /*#__PURE__*/ $g85JO.createElement($0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper, {
                            children: /*#__PURE__*/ $g85JO.createElement($2vzQN.make, tmp$1),
                            product: product,
                            variant: variant
                        });
                    }
                    exit = 2;
                }
                if (exit === 2) {
                    var tmp$2 = {
                        product: product,
                        variant: variant,
                        productCategory: pdpCategory,
                        shouldForceMobile: shouldForceMobile,
                        isInsideQuickView: isInsideQuickView,
                        viewport: viewport$1,
                        scrollableContainerRef: scrollableContainerRef$1,
                        scrollToRef: scrollToRef
                    };
                    if (showMoreProducts !== undefined) tmp$2.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
                    if (renderLauncher !== undefined) tmp$2.renderLauncher = $loT9g.valFromOption(renderLauncher);
                    return /*#__PURE__*/ $g85JO.createElement($0a5e088e2945420e$var$ProductDetailsPage$PDPWrapper, {
                        children: /*#__PURE__*/ $g85JO.createElement($7D5xx.make, tmp$2),
                        product: product,
                        variant: variant
                    });
                }
            }
            return /*#__PURE__*/ $g85JO.createElement($huObo.make, {
                productId: productId$1,
                variantId: variantId,
                isInsideQuickView: isInsideQuickView
            });
        }
    };
    var fixedPositionPDP = embedType !== 0 ? !isInsideQuickView : false;
    var zIndex = embedType >= 5 ? "0" : settings.zIndex;
    return /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "PDP",
        redirect: onBackClick,
        children: /*#__PURE__*/ $g85JO.createElement($9JLuv.If, {
            condition: fixedPositionPDP,
            children: null
        }, /*#__PURE__*/ $g85JO.createElement($9JLuv.Then, {
            children: /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
                initiator: "pdp",
                portal: true,
                children: /*#__PURE__*/ $g85JO.createElement("div", {
                    ref: $5bEXW.Ref.domRef(fallbackViewportRef),
                    className: $ezf3v.prefix("fixed left-0 w-full bg-main text-primary overflow-hidden select-none touch-none clip-path-bottom-xl"),
                    style: {
                        height: stickyHeaderOffset > 0 ? "calc(100% - " + $ezf3v.intToPx(stickyHeaderOffset) + ")" : "100%",
                        top: $ezf3v.intToPx(stickyHeaderOffset),
                        zIndex: zIndex,
                        transform: "translate3d(0,0,0)"
                    }
                }, renderPDPControls(undefined), renderPDP(undefined))
            })
        }), /*#__PURE__*/ $g85JO.createElement($9JLuv.Else, {
            children: null
        }, renderPDPControls(undefined), renderPDP(undefined)))
    });
}
$0a5e088e2945420e$var$ProductDetailsPage.displayName = "ProductDetailsPage";
var $0a5e088e2945420e$export$dd44f18ab656f3bb = $0a5e088e2945420e$var$ProductDetailsPage;
var $0a5e088e2945420e$export$aa541d093b11ace2 = $0a5e088e2945420e$var$ProductDetailsPage;
 /* react Not a pure module */ 
});
parcelRegister("8iMy9", function(module, exports) {

$parcel$export(module.exports, "Slide", function () { return $60b5aa24a3f146e8$export$d8dc01b5c85a37b9; });
$parcel$export(module.exports, "Slides", function () { return $60b5aa24a3f146e8$export$f4142d7902b6e656; });
$parcel$export(module.exports, "getKey", function () { return $60b5aa24a3f146e8$export$a47fb462a08de82f; });
$parcel$export(module.exports, "trimTrailingPlaceholders", function () { return $60b5aa24a3f146e8$export$8d47aa473a75864b; });
$parcel$export(module.exports, "getActiveProduct", function () { return $60b5aa24a3f146e8$export$377ae0ee0c9964b3; });
$parcel$export(module.exports, "getActiveVariant", function () { return $60b5aa24a3f146e8$export$6cc9970ef37cfb5b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $7KlbQ = parcelRequire("7KlbQ");

var $eFryz = parcelRequire("eFryz");
function $60b5aa24a3f146e8$var$getOrder(slide) {
    switch(slide.TAG | 0){
        case /* Product */ 0:
            return slide.order;
        case /* Placeholder */ 1:
        case /* UnloadedProduct */ 2:
            return slide.order;
    }
}
function $60b5aa24a3f146e8$var$setOrder(slide, order) {
    switch(slide.TAG | 0){
        case /* Product */ 0:
            return {
                TAG: /* Product */ 0,
                pinned: slide.pinned,
                product: slide.product,
                variant: slide.variant,
                order: order
            };
        case /* Placeholder */ 1:
            return {
                TAG: /* Placeholder */ 1,
                pinned: slide.pinned,
                id: slide.id,
                order: order
            };
        case /* UnloadedProduct */ 2:
            return {
                TAG: /* UnloadedProduct */ 2,
                pinned: slide.pinned,
                id: slide.id,
                order: order
            };
    }
}
function $60b5aa24a3f146e8$var$getId(slide) {
    switch(slide.TAG | 0){
        case /* Product */ 0:
            return slide.product.id;
        case /* Placeholder */ 1:
        case /* UnloadedProduct */ 2:
            return slide.id;
    }
}
function $60b5aa24a3f146e8$var$isPinned(slide) {
    switch(slide.TAG | 0){
        case /* Product */ 0:
        case /* Placeholder */ 1:
        case /* UnloadedProduct */ 2:
            return slide.pinned;
    }
}
function $60b5aa24a3f146e8$var$isPlaceholder(slide) {
    switch(slide.TAG | 0){
        case /* Placeholder */ 1:
            return true;
        case /* Product */ 0:
        case /* UnloadedProduct */ 2:
            return false;
    }
}
function $60b5aa24a3f146e8$var$makeProductSlide(pinnedOpt, variantId, order, product) {
    var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
    var variant = $2whNH.getWithDefault($2whNH.flatMap(variantId, function(variantId) {
        return $7KlbQ.getVariantById(product, variantId);
    }), product.firstVariant);
    return {
        TAG: /* Product */ 0,
        pinned: pinned,
        product: product,
        variant: variant,
        order: order
    };
}
function $60b5aa24a3f146e8$var$makePlaceholderSlide(pinnedOpt, id, order) {
    var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
    return {
        TAG: /* Placeholder */ 1,
        pinned: pinned,
        id: $2whNH.getWithDefault(id, "placeholder-" + String(order)),
        order: order
    };
}
function $60b5aa24a3f146e8$var$makeUnloadedProductSlide(pinnedOpt, id, order) {
    var pinned = pinnedOpt !== undefined ? pinnedOpt : false;
    return {
        TAG: /* UnloadedProduct */ 2,
        pinned: pinned,
        id: $2whNH.getWithDefault(id, "unloaded-" + String(order)),
        order: order
    };
}
function $60b5aa24a3f146e8$var$getKey(slide) {
    switch(slide.TAG | 0){
        case /* Product */ 0:
            return slide.product.id + "-" + slide.variant.id + "-" + String(slide.order);
        case /* Placeholder */ 1:
            return "placeholder-" + slide.id + "-" + String(slide.order);
        case /* UnloadedProduct */ 2:
            return "unloaded-" + slide.id + "-" + String(slide.order);
    }
}
var $60b5aa24a3f146e8$export$d8dc01b5c85a37b9 = {
    getOrder: $60b5aa24a3f146e8$var$getOrder,
    setOrder: $60b5aa24a3f146e8$var$setOrder,
    getId: $60b5aa24a3f146e8$var$getId,
    isPinned: $60b5aa24a3f146e8$var$isPinned,
    isPlaceholder: $60b5aa24a3f146e8$var$isPlaceholder,
    makeProductSlide: $60b5aa24a3f146e8$var$makeProductSlide,
    makePlaceholderSlide: $60b5aa24a3f146e8$var$makePlaceholderSlide,
    makeUnloadedProductSlide: $60b5aa24a3f146e8$var$makeUnloadedProductSlide,
    getKey: $60b5aa24a3f146e8$var$getKey
};
function $60b5aa24a3f146e8$var$dedupById(__x) {
    return $eFryz.getUnique(__x, $60b5aa24a3f146e8$var$getId);
}
var $60b5aa24a3f146e8$export$f4142d7902b6e656 = {
    dedupById: $60b5aa24a3f146e8$var$dedupById
};
function $60b5aa24a3f146e8$export$a47fb462a08de82f(config) {
    return $i7mYY.flatMap([
        $i7mYY.map(config.slides, $60b5aa24a3f146e8$var$getKey),
        [
            String(config.position)
        ],
        [
            String(config.total)
        ]
    ], function(a) {
        return a;
    }).join("-");
}
function $60b5aa24a3f146e8$export$8d47aa473a75864b(slides) {
    var lastValidIdx = $2whNH.keep($i7mYY.map(slides, $60b5aa24a3f146e8$var$isPlaceholder).lastIndexOf(false), function(i) {
        return i >= 0;
    });
    if (lastValidIdx !== undefined) return $i7mYY.slice(slides, 0, lastValidIdx + 2 | 0);
    else return slides;
}
function $60b5aa24a3f146e8$export$377ae0ee0c9964b3(config) {
    return $2whNH.flatMap($i7mYY.get(config.slides, config.position), function(slide) {
        switch(slide.TAG | 0){
            case /* Product */ 0:
                return slide.product;
            case /* Placeholder */ 1:
            case /* UnloadedProduct */ 2:
                return;
        }
    });
}
function $60b5aa24a3f146e8$export$6cc9970ef37cfb5b(config) {
    return $2whNH.flatMap($i7mYY.get(config.slides, config.position), function(slide) {
        switch(slide.TAG | 0){
            case /* Product */ 0:
                return slide.variant;
            case /* Placeholder */ 1:
            case /* UnloadedProduct */ 2:
                return;
        }
    });
}
 /* Product-Showside Not a pure module */ 
});

parcelRegister("2sYBg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $1cbd342ef2815f1a$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $7wIsS = parcelRequire("7wIsS");

var $lhKg5 = parcelRequire("lhKg5");

var $dMhWy = parcelRequire("dMhWy");

var $27XcH = parcelRequire("27XcH");

var $2jMpY = parcelRequire("2jMpY");

var $6Ntmr = parcelRequire("6Ntmr");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $4135i = parcelRequire("4135i");

var $lihS4 = parcelRequire("lihS4");

var $8E2YL = parcelRequire("8E2YL");
function $1cbd342ef2815f1a$var$PDPNavbar(Props) {
    var closeOpt = Props.close;
    var homeOpt = Props.home;
    var backOpt = Props.back;
    var close = closeOpt !== undefined ? closeOpt : true;
    var home = homeOpt !== undefined ? homeOpt : true;
    var back = backOpt !== undefined ? backOpt : true;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $9pMGg.use(undefined);
    var onBackClick = match$2.onBackClick;
    var onCloseNavigation = match$2.onCloseNavigation;
    var onHomeClick = match$2.onHomeClick;
    var embedType = match$2.embedType;
    var match$3 = $lihS4.useCart(undefined);
    var cart = match$3.cart;
    var match$4 = $hBcYV.useRouter(undefined);
    var isSmartbar = settings.smartbarEnabled;
    var isDesktopBar = settings.smartbarEnabled && !isMobile;
    var isDesktopInline = embedType === /* Inline */ 1 && !isMobile;
    var renderBackButton = function renderBackButton(param) {
        return /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                $iv6Yc._1(onBackClick, undefined);
            },
            shadow: true,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
                size: /* Px */ {
                    _0: 26
                }
            }),
            title: "Back",
            dataTestId: "pdp-button-back",
            className: $ezf3v.prefix("ml-0.5 mr-2 -top-px pointer-events-auto")
        });
    };
    var renderHomeButton = function renderHomeButton(param) {
        if (embedType >= 4) return null;
        else return /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                $iv6Yc._1(onHomeClick, undefined);
            },
            shadow: true,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilEstate.make, {
                size: /* Px */ {
                    _0: 21
                }
            }),
            title: "Home",
            dataTestId: "pdp-button-home",
            className: $ezf3v.prefix("-top-px pointer-events-auto")
        });
    };
    var match$5 = $4135i.useCheckoutAction(undefined);
    var checkoutOnClick = match$5.onClick;
    var checkoutHref = match$5.href;
    var renderCheckoutButton = function renderCheckoutButton(param) {
        if (checkoutHref === undefined && checkoutOnClick === undefined) return null;
        var tmp = {
            children: null,
            unstyled: true,
            className: $ezf3v.prefix("relative w-12 h-12"),
            ariaLabel: "Checkout"
        };
        if (checkoutHref !== undefined) tmp.href = $loT9g.valFromOption(checkoutHref);
        if (checkoutOnClick !== undefined) tmp.onClick = $loT9g.valFromOption(checkoutOnClick);
        var tmp$1 = {
            shadow: true,
            icon: /*#__PURE__*/ $g85JO.createElement($lhKg5.make, {
                size: 22
            }),
            title: "Checkout",
            dataTestId: "pdp-button-checkout",
            iconClassName: $ezf3v.prefix("-ml-px -mt-px"),
            className: $ezf3v.prefix("mr-0.5 -top-px")
        };
        var tmp$2 = $2jMpY.fromInt(99, undefined, cart.itemCount);
        if (tmp$2 !== undefined) tmp$1.badge = $loT9g.valFromOption(tmp$2);
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative pointer-events-auto")
        }, /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp, /*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp$1), /*#__PURE__*/ $g85JO.createElement($6Ntmr.make, {
            productDirection: /* Bottom */ 1,
            tooltipDirection: /* Left */ 2,
            addedLabel: settings.pdpAddToCartConfirmation,
            className: $ezf3v.prefix("absolute w-full h-full")
        }))));
    };
    var renderFavoritesButton = function renderFavoritesButton(param) {
        if (embedType >= 4 || !settings.favoritesEnabled) return null;
        else return /*#__PURE__*/ $g85JO.createElement($dMhWy.OpenButton.make, {
            at: /* PDP */ 1
        });
    };
    var renderCloseButton = function renderCloseButton(param) {
        return /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
            onClick: function onClick(param) {
                if (embedType === /* Inline */ 1) return $iv6Yc._1(onBackClick, undefined);
                else return $iv6Yc._1(onCloseNavigation, undefined);
            },
            shadow: true,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
                size: /* Px */ {
                    _0: 28
                }
            }),
            title: "Close",
            dataTestId: "pdp-button-open-close",
            className: $ezf3v.prefix("mr-0.5 ml-2 -top-px pointer-events-auto")
        });
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute",
            "top-0",
            "left-0",
            "px-4",
            "pt-1.5",
            "z-30",
            "flex",
            "flex-row",
            "w-full",
            "pointer-events-none",
            match$4.isQuickView || embedType !== 0 || !(isMobile && isSmartbar) ? "mt-1" : "-mt-4"
        ]))
    }, back ? renderBackButton(undefined) : null, (isDesktopBar || isDesktopInline) && home ? renderHomeButton(undefined) : null, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow flex justify-end")
    }, renderFavoritesButton(undefined), isDesktopBar || isMobile || isDesktopInline ? renderCheckoutButton(undefined) : null), close && (isDesktopBar || isDesktopInline) ? renderCloseButton(undefined) : null);
}
$1cbd342ef2815f1a$var$PDPNavbar.displayName = "PDPNavbar";
var $1cbd342ef2815f1a$export$dd44f18ab656f3bb = $1cbd342ef2815f1a$var$PDPNavbar;
 /* react Not a pure module */ 
});

parcelRegister("7D5xx", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $58e0790ce2025c0b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $38gYA = parcelRequire("38gYA");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");

var $fsiJD = parcelRequire("fsiJD");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $5yRbv = parcelRequire("5yRbv");

var $sK0FX = parcelRequire("sK0FX");

var $1M10O = parcelRequire("1M10O");

var $8E2YL = parcelRequire("8E2YL");
function $58e0790ce2025c0b$var$PDPContent(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var productCategory = Props.productCategory;
    var shouldForceMobile = Props.shouldForceMobile;
    var isInsideQuickView = Props.isInsideQuickView;
    var viewport = Props.viewport;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var scrollToRef = Props.scrollToRef;
    var showMoreProducts = Props.showMoreProducts;
    var renderLauncher = Props.renderLauncher;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var breakpoint = match$1.breakpoint;
    var entrypointContext = $9pMGg.use(undefined);
    var trackEvent = entrypointContext.trackEvent;
    var embedType = entrypointContext.embedType;
    var match$2 = $hBcYV.useRouter(undefined);
    var productCategoryId = match$2.productCategoryId;
    var variantId = match$2.anyVariantId;
    var goTo = match$2.goTo;
    var route = match$2.route;
    var isMobile = match$1.isMobile || shouldForceMobile;
    var selectedVariant = $2whNH.flatMap(variantId, function(param) {
        return $7KlbQ.getVariantById(product, param);
    });
    var hideMediaFromOtherVariants = $2whNH.mapWithDefault(match.transitiveAccount, false, function(account) {
        return account.pdpHideMediaFromOtherVariants;
    });
    var allVariantMedia = $g85JO.useMemo(function() {
        var variant = $2whNH.getWithDefault(selectedVariant, product.firstVariant);
        return $7KlbQ.getAllVariantMedia(hideMediaFromOtherVariants, product, variant);
    }, [
        $2whNH.map(selectedVariant, function(v) {
            return v.id;
        }),
        product.id
    ]);
    var photoSliderVisibleRef = $g85JO.useRef(true);
    var ctaVisibleRef = $g85JO.useRef(/* Visible */ 3);
    var stickyDetailsRef = $g85JO.useRef(function(visible) {});
    var onPhotoSliderVisibilityChange = $g85JO.useCallback(function(visible) {
        photoSliderVisibleRef.current = visible;
        $iv6Yc._1(stickyDetailsRef.current, ctaVisibleRef.current !== /* Visible */ 3 && !photoSliderVisibleRef.current);
    }, [
        photoSliderVisibleRef,
        ctaVisibleRef
    ]);
    var onCTAButtonVisibilityChange = $g85JO.useCallback(function(visible) {
        ctaVisibleRef.current = visible;
        $iv6Yc._1(stickyDetailsRef.current, ctaVisibleRef.current !== /* Visible */ 3 && !photoSliderVisibleRef.current);
    }, [
        photoSliderVisibleRef,
        ctaVisibleRef
    ]);
    var onPhotoZoomed = $g85JO.useCallback(function(index) {
        if (typeof route !== "number") switch(route.TAG | 0){
            case /* PDP */ 2:
                var match = route._0;
                return $iv6Yc._3(goTo, undefined, true, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: match.categoryId,
                        productCategoryId: productCategoryId,
                        productId: match.productId,
                        variantId: variantId,
                        zoomedPhotoIndex: index
                    }
                });
            case /* QuickView */ 3:
                var payload = route._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* QuickView */ 3,
                    _0: {
                        mediaId: payload.mediaId,
                        mediaParentId: payload.mediaParentId,
                        albumId: payload.albumId,
                        productId: payload.productId,
                        relatedMediaProductIds: payload.relatedMediaProductIds,
                        relatedMediaCategoryId: payload.relatedMediaCategoryId,
                        variantId: payload.variantId,
                        panelClosed: payload.panelClosed,
                        zoomedPhotoIndex: index,
                        time: payload.time
                    }
                });
            default:
        }
        $iv6Yc._3(goTo, undefined, true, {
            TAG: /* PDP */ 2,
            _0: {
                categoryId: productCategory.id,
                productCategoryId: productCategoryId,
                productId: product.id,
                variantId: variant.id,
                zoomedPhotoIndex: index
            }
        });
    }, [
        $hBcYV.toString(route),
        productCategoryId
    ]);
    var onSlideChange = function onSlideChange(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image scroll",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var onClickThumbnail = function onClickThumbnail(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image select",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var variant$1 = $2whNH.getWithDefault(selectedVariant, product.firstVariant);
    var desktopPhotoContent = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !isMobile,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("all w-full relative")
        }, /*#__PURE__*/ $g85JO.createElement($1M10O.make, {
            product: product,
            variantId: variant$1.id,
            medias: allVariantMedia,
            viewport: viewport,
            onPhotoZoomed: onPhotoZoomed,
            onSlideChange: onSlideChange,
            onClickThumbnail: onClickThumbnail
        }))
    });
    var variant$2 = $2whNH.getWithDefault(selectedVariant, product.firstVariant);
    var onSlideChange$1 = $g85JO.useCallback(function(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image scroll",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    }, [
        product.id,
        trackEvent
    ]);
    var onClickImage = $g85JO.useCallback(function(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image select",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    }, [
        product.id,
        trackEvent
    ]);
    var mobilePhotoContent = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: isMobile,
        children: /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
            partialVisibility: true,
            onChange: onPhotoSliderVisibilityChange,
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex-shrink-0")
            }, /*#__PURE__*/ $g85JO.createElement($5yRbv.make, {
                product: product,
                productId: product.id,
                variantId: variant$2.id,
                medias: allVariantMedia,
                fitToContainer: settings.productCardFitToContainer,
                onPhotoZoomed: onPhotoZoomed,
                onClickImage: onClickImage,
                onSlideChange: onSlideChange$1,
                onClickThumbnail: onClickThumbnail,
                viewport: viewport,
                settings: settings,
                productCategory: productCategory
            }))
        })
    });
    var scrollableCn = isMobile && embedType === /* Bottombar */ 0 ? $ezf3v.prefix("-mt-5") : "";
    var scrollableStyle = isMobile && embedType === /* Bottombar */ 0 ? {
        height: "calc(100% + 14px)"
    } : undefined;
    var widthCn = breakpoint !== 2 ? breakpoint >= 3 ? "w-146" : "" : "w-120";
    var scrollToDetailsRef = $g85JO.useRef(function(param) {
        $iv6Yc._1(scrollToRef.current, /* Top */ 0);
    });
    var tmp = {
        restorationId: isInsideQuickView ? "qv-pdp" : "nav-pdp",
        scrollToRef: scrollToRef,
        children: null,
        fwdRef: scrollableContainerRef,
        className: scrollableCn,
        rememberScrollPosition: false
    };
    if (scrollableStyle !== undefined) tmp.style = $loT9g.valFromOption(scrollableStyle);
    var tmp$1 = {
        product: product,
        variant: variant,
        productCategory: productCategory,
        shouldForceMobile: shouldForceMobile,
        isInsideQuickView: isInsideQuickView,
        scrollableContainerRef: scrollableContainerRef,
        scrollToDetailsRef: scrollToDetailsRef,
        stickyDetailsRef: stickyDetailsRef,
        descriptionLayout: /* Accordion */ 1,
        onCTAButtonVisibilityChange: onCTAButtonVisibilityChange,
        stickyCTA: !isMobile
    };
    if (showMoreProducts !== undefined) tmp$1.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
    var rightColumn = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            isMobile ? "" : "relative flex-shrink-0",
            widthCn
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($38gYA.make, tmp, $2whNH.mapWithDefault(renderLauncher, null, function(fn) {
        return $iv6Yc._1(fn, $ezf3v.prefix("py-4"));
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex",
            isMobile ? "flex-col relative" : "flex-row w-full"
        ]))
    }, mobilePhotoContent, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex flex-col flex-grow w-full")
    }, /*#__PURE__*/ $g85JO.createElement($sK0FX.make, tmp$1)))));
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute inset-0 bg-main")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col h-full")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow flex")
        }, desktopPhotoContent, rightColumn)))
    });
}
$58e0790ce2025c0b$var$PDPContent.displayName = "PDPContent";
var $58e0790ce2025c0b$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($58e0790ce2025c0b$var$PDPContent);
 /* make Not a pure module */ 
});
parcelRegister("38gYA", function(module, exports) {

$parcel$export(module.exports, "useScrollableContext", function () { return $247f49975e2c6903$export$c8bd6c217b070147; });
$parcel$export(module.exports, "make", function () { return $247f49975e2c6903$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $3tS2g = parcelRequire("3tS2g");

var $gWwbb = parcelRequire("gWwbb");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $2XXXw = parcelRequire("2XXXw");
$gWwbb.polyfill();
var $247f49975e2c6903$var$context = /*#__PURE__*/ $g85JO.createContext({
    element: undefined
});
var $247f49975e2c6903$var$provider = $247f49975e2c6903$var$context.Provider;
function $247f49975e2c6903$var$Scrollable$Provider(Props) {
    var children = Props.children;
    var element = Props.element;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$provider, {
        value: {
            element: element
        },
        children: children
    });
}
$247f49975e2c6903$var$Scrollable$Provider.displayName = "Scrollable.Provider";
var $247f49975e2c6903$export$2881499e37b75b9a = {
    context: $247f49975e2c6903$var$context,
    provider: $247f49975e2c6903$var$provider,
    make: $247f49975e2c6903$var$Scrollable$Provider
};
function $247f49975e2c6903$export$c8bd6c217b070147(param) {
    return $g85JO.useContext($247f49975e2c6903$var$context);
}
function $247f49975e2c6903$var$Scrollable(Props) {
    var restorationId = Props.restorationId;
    var scrollToRef = Props.scrollToRef;
    var onScrollOpt = Props.onScroll;
    var childrenOpt = Props.children;
    var lockedOpt = Props.locked;
    var fwdRef = Props.fwdRef;
    var classNameOpt = Props.className;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var onTouchEnd = Props.onTouchEnd;
    var scrollOffsetOpt = Props.scrollOffset;
    var defaultRestorationPosition = Props.defaultRestorationPosition;
    var inlineOpt = Props.inline;
    var styleOpt = Props.style;
    var stopPropagationOpt = Props.stopPropagation;
    var rememberScrollPositionOpt = Props.rememberScrollPosition;
    var onScroll = onScrollOpt !== undefined ? onScrollOpt : function onScroll(e, wasAutoScroll) {};
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var locked = lockedOpt !== undefined ? lockedOpt : false;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var scrollOffset = scrollOffsetOpt !== undefined ? scrollOffsetOpt : 0.0;
    var inline = inlineOpt !== undefined ? inlineOpt : false;
    var style = styleOpt !== undefined ? $loT9g.valFromOption(styleOpt) : {};
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var rememberScrollPosition = rememberScrollPositionOpt !== undefined ? rememberScrollPositionOpt : true;
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var scrollRef = $g85JO.useRef(null);
    var isAutoScroll = $g85JO.useRef(false);
    var previousScroll = $g85JO.useRef(0);
    var match$1 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollToTimeout = match$1.setTimeout;
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useRestoreFromPositionTimeout = match$2.setTimeout;
    var match$3 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useAutoScrollTimeout = match$3.setTimeout;
    var match$4 = $kQvlq.useSafeTimeout(undefined, undefined);
    var useScrollLockTimeout = match$4.setTimeout;
    var mergedRef = fwdRef !== undefined ? (0, $iXXhl.default)(scrollRef, fwdRef) : scrollRef;
    var restoration = $2XXXw.useScrollRestoration(restorationId);
    $2whNH.forEach(scrollToRef, function(scrollTo) {
        scrollTo.current = function(el0) {
            useScrollToTimeout(function(param) {
                var el = scrollRef.current;
                if (el == null) return;
                var scrollTop;
                scrollTop = typeof el0 === "number" ? $2whNH.getWithDefault(defaultRestorationPosition, 0.0) : el0.TAG === /* Element */ 0 ? el0._0.offsetTop : el0._0;
                var el$1 = scrollRef.current;
                var options = {
                    top: scrollTop + scrollOffset,
                    left: 0.0,
                    behavior: "smooth"
                };
                if (!(el$1 == null)) el$1.scrollTo(options);
                if (restorationId !== undefined && rememberScrollPosition) {
                    previousScroll.current = scrollTop | 0;
                    return $2XXXw.setCurrentScroll(namespace, restorationId, {
                        TAG: /* Pixels */ 0,
                        _0: scrollTop | 0
                    });
                }
            }, 0);
        };
    });
    var onScroll$1 = function onScroll$1(param) {
        window.dispatchEvent(new Event("scroll"));
        $2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(el) {
            var scrollTop = el.scrollTop | 0;
            var isBlocking = $2XXXw.isBlockingOnScrollEvent(undefined);
            var isGreaterThanStart = $2whNH.mapWithDefault($2whNH.keep(defaultRestorationPosition, function(a) {
                return a > 0.0;
            }), true, function(start) {
                return scrollTop > start;
            });
            var isEnabled = !isBlocking && isGreaterThanStart;
            if (restorationId !== undefined && rememberScrollPosition && isEnabled) {
                previousScroll.current = scrollTop;
                return $2XXXw.setCurrentScroll(namespace, restorationId, {
                    TAG: /* Pixels */ 0,
                    _0: scrollTop
                });
            }
        });
    };
    var restoreFromLock = function restoreFromLock(lock) {
        return $2whNH.getWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollRef.current), function(scrollEl) {
            var lockEl = lock.element;
            if ($3tS2g.isDescendent(scrollEl, lockEl)) {
                useScrollLockTimeout(function(param) {
                    var currentScrollPosition = scrollEl.scrollTop;
                    var currentElementTop = lockEl.getBoundingClientRect().top;
                    var originalElementTop = lock.boundingClientRect.top;
                    var amountToScroll = currentElementTop - originalElementTop;
                    var newScrollPosition = currentScrollPosition + amountToScroll;
                    scrollEl.scrollTop = newScrollPosition;
                    onScroll$1(undefined);
                }, 0);
                return true;
            } else return false;
        }), false);
    };
    var restoreFromPosition = function restoreFromPosition1(retryOpt, el, position) {
        var retry = retryOpt !== undefined ? retryOpt : 0;
        if (typeof position === "number") {
            var targetScroll = Math.max(scrollOffset, $2whNH.getWithDefault(defaultRestorationPosition, 0.0)) | 0;
            var scrollTop = $2XXXw.getClosestBreakingPoint(previousScroll.current, targetScroll);
            el.scrollTop = scrollTop;
            return;
        }
        if (position.TAG !== /* Pixels */ 0) return;
        var scrollTop$1 = Math.max(scrollOffset, position._0);
        var height = $2whNH.getWithDefault($2whNH.map($2whNH.map($i7mYY.get(Array.prototype.slice.call(el.children), 0), function(prim) {
            return prim.getBoundingClientRect();
        }), function(prim) {
            return prim.height;
        }), 100000);
        if (scrollTop$1 === 0 || scrollTop$1 <= height || retry > 4) {
            el.scrollTop = scrollTop$1;
            return;
        } else return useRestoreFromPositionTimeout(function(param) {
            restoreFromPosition(retry + 1 | 0, el, position);
        }, 16);
    };
    var setisAutoScroll = function setisAutoScroll(param) {
        isAutoScroll.current = true;
        useAutoScrollTimeout(function(param) {
            isAutoScroll.current = false;
        }, 100);
    };
    $g85JO.useLayoutEffect(function() {
        var el = scrollRef.current;
        if (!(el == null)) {
            var lock = restoration.lock;
            if (lock !== undefined) {
                if (!restoreFromLock(lock)) restoreFromPosition(undefined, el, restoration.position);
            } else {
                setisAutoScroll(undefined);
                restoreFromPosition(undefined, el, restoration.position);
            }
        }
    }, [
        restoration
    ]);
    var positionClassName = inline ? "" : "absolute top-0 left-0";
    var tmp = {
        ref: $5bEXW.Ref.domRef(mergedRef),
        "aria-label": "scrollable content",
        className: $1TRFX.make([
            className,
            $ezf3v.prefix(positionClassName),
            $ezf3v.prefix("w-full h-full overflow-x-hidden no-overflow-anchoring overscroll-none"),
            locked ? $ezf3v.prefix("overflow-y-hidden touch-none") : $ezf3v.prefix("overflow-y-scroll touch-pan-y")
        ]),
        role: "region",
        style: style,
        onScroll: function onScroll1(e) {
            if (stopPropagation) {
                e.preventDefault();
                e.stopPropagation();
            }
            onScroll$1(undefined);
            $iv6Yc._2(onScroll, e, isAutoScroll.current);
        }
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    var tmp$1 = {
        dataTestId: "scrollable",
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp, children)
    };
    if (restorationId !== undefined) tmp$1.dataId = restorationId;
    return /*#__PURE__*/ $g85JO.createElement($247f49975e2c6903$var$Scrollable$Provider, {
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$1),
        element: $loT9g.nullable_to_opt(scrollRef.current)
    });
}
$247f49975e2c6903$var$Scrollable.displayName = "Scrollable";
var $247f49975e2c6903$export$dd44f18ab656f3bb = $247f49975e2c6903$var$Scrollable;
 /*  Not a pure module */ 
});
parcelRegister("3tS2g", function(module, exports) {

$parcel$export(module.exports, "isDescendent", function () { return $288dfedeedc2f681$export$965a0cda204ba1d7; });
// Generated by ReScript, PLEASE EDIT WITH CARE
function $288dfedeedc2f681$export$965a0cda204ba1d7(ancestor, _descendent) {
    while(true){
        var descendent = _descendent;
        var parent = descendent.parentElement;
        if (parent == null) return false;
        if (parent === ancestor) return true;
        _descendent = parent;
        continue;
    }
}
function $288dfedeedc2f681$export$ec70bc1e11cea5ad(options, element) {
    element.scrollIntoView(options);
}
 /* No side effect */ 
});


parcelRegister("5yRbv", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $40c962123b0adf15$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $9lCOf = parcelRequire("9lCOf");

var $c0njb = parcelRequire("c0njb");

var $55MCT = parcelRequire("55MCT");

var $90LTg = parcelRequire("90LTg");

var $IFWJb = parcelRequire("IFWJb");

var $dJcSN = parcelRequire("dJcSN");

var $8dLtV = parcelRequire("8dLtV");

var $insiF = parcelRequire("insiF");

var $4IRro = parcelRequire("4IRro");

var $ePRCc = parcelRequire("ePRCc");

var $gCzsf = parcelRequire("gCzsf");

var $fdM5o = parcelRequire("fdM5o");

var $gpCTg = parcelRequire("gpCTg");

var $5bEXW = parcelRequire("5bEXW");

var $1t9ha = parcelRequire("1t9ha");

var $e2Ecw = parcelRequire("e2Ecw");

var $hBcYV = parcelRequire("hBcYV");

var $jBcRb = parcelRequire("jBcRb");

var $9EMq4 = parcelRequire("9EMq4");

var $aSJcu = parcelRequire("aSJcu");

var $9JqU1 = parcelRequire("9JqU1");

var $9pMGg = parcelRequire("9pMGg");

var $kPwXH = parcelRequire("kPwXH");

var $8E2YL = parcelRequire("8E2YL");
function $40c962123b0adf15$var$MobilePhotoSlider$MiniSlider$Slide(Props) {
    var rect = Props.rect;
    var item = Props.item;
    var index = Props.index;
    var visible = Props.visible;
    var durationCn = Props.durationCn;
    var phaseDuration = Props.phaseDuration;
    var fitToContainer = Props.fitToContainer;
    var containerWidth = Props.containerWidth;
    var containerHeight = Props.containerHeight;
    var getMediaSize = Props.getMediaSize;
    var onClick = Props.onClick;
    var onMainImageRendered = Props.onMainImageRendered;
    var settings = Props.settings;
    var match = $g85JO.useState(function() {
        return $iv6Yc._2(getMediaSize, containerHeight, item);
    });
    var size = match[0];
    var mediaHeight = size[1];
    var mediaWidth = size[0];
    var setSize = match[1];
    var mediaWidth$1 = fitToContainer ? Math.min(mediaWidth, containerWidth) : mediaWidth;
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setGrabbingImage = match$1[1];
    var cursor = match$1[0] ? "cursor-grab" : "cursor-zoom-in";
    var largeContainer = {
        x: 0,
        y: 0,
        width: mediaWidth$1,
        height: mediaHeight
    };
    var naturalSize = {
        width: mediaWidth$1,
        height: mediaHeight
    };
    var onLoad = function onLoad(param) {
        var completeFit = $55MCT.calcObjectFit(param.width, param.height, undefined, containerHeight, /* Contain */ 2);
        $iv6Yc._1(setSize, function(param) {
            return [
                completeFit.width,
                completeFit.height
            ];
        });
    };
    var tmp = {
        largeContainer: largeContainer,
        naturalSize: naturalSize,
        smallFitRule: "cover",
        largeFitRule: "contain",
        duration: phaseDuration,
        render: function render(param) {
            switch(item.TAG | 0){
                case /* Image */ 0:
                    return /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                        src: item._0.url,
                        containerWidth: mediaWidth$1,
                        containerHeight: mediaHeight,
                        fit: /* Contain */ 2,
                        priority: 0,
                        onLoad: onLoad,
                        onRender: function onRender(param) {
                            if (index === 0) return $iv6Yc._1(onMainImageRendered, undefined);
                        },
                        noFlicker: true
                    });
                case /* Video */ 1:
                    var video = item._0;
                    var src = $2whNH.map($7KlbQ.getVideoSource(video), function(source) {
                        return source.url;
                    });
                    if (src === undefined) return null;
                    var tmp = {
                        src: src,
                        prioritize: true,
                        autoplay: settings.videoAutoPlay,
                        loop: settings.videoLoop,
                        muted: settings.videoMute,
                        controls: settings.videoControls,
                        key: src
                    };
                    if (video.posterUrl !== undefined) tmp.poster = video.posterUrl;
                    return /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp);
                case /* IframeEmbed */ 2:
                    return /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                        url: item._0.url
                    });
            }
        }
    };
    if (rect !== undefined) tmp.smallContainer = $loT9g.valFromOption(rect);
    return /*#__PURE__*/ $g85JO.createElement($dJcSN.make, {
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-photo",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "select-none relative transition-opacity",
                    cursor,
                    visible ? "opacity-100" : "opacity-0",
                    "product-photo-" + String(index),
                    durationCn
                ])),
                style: {
                    height: $ezf3v.intToPx(mediaHeight),
                    width: $ezf3v.intToPx(mediaWidth$1)
                },
                onClick: function onClick1(param) {
                    $iv6Yc._1(onClick, undefined);
                },
                onMouseDown: function onMouseDown(param) {
                    $iv6Yc._1(setGrabbingImage, function(param) {
                        return true;
                    });
                },
                onMouseUp: function onMouseUp(param) {
                    $iv6Yc._1(setGrabbingImage, function(param) {
                        return false;
                    });
                }
            }, /*#__PURE__*/ $g85JO.createElement($9lCOf.make, {
                logs: [
                    {
                        TAG: /* Log */ 0,
                        _0: "containerWidth: " + String(containerWidth)
                    },
                    {
                        TAG: /* Log */ 0,
                        _0: "containerHeight: " + String(containerHeight)
                    },
                    {
                        TAG: /* Log */ 0,
                        _0: ">> mediaWidth: " + String(mediaWidth$1)
                    },
                    {
                        TAG: /* Log */ 0,
                        _0: "mediaHeight: " + String(mediaHeight)
                    }
                ],
                enabled: false,
                children: /*#__PURE__*/ $g85JO.createElement($kPwXH.make, tmp)
            }))
        })
    });
}
$40c962123b0adf15$var$MobilePhotoSlider$MiniSlider$Slide.displayName = "MobilePhotoSlider.MiniSlider.Slide";
var $40c962123b0adf15$var$Slide = {
    make: $40c962123b0adf15$var$MobilePhotoSlider$MiniSlider$Slide
};
function $40c962123b0adf15$var$MobilePhotoSlider$MiniSlider(Props) {
    var product = Props.product;
    var variantId = Props.variantId;
    var productId = Props.productId;
    var phase = Props.phase;
    var phaseDuration = Props.phaseDuration;
    var productCategory = Props.productCategory;
    var windowWidth = Props.windowWidth;
    var windowHeight = Props.windowHeight;
    var fitToContainer = Props.fitToContainer;
    var containerWidth = Props.containerWidth;
    var containerRef = Props.containerRef;
    var zoomedIndex = Props.zoomedIndex;
    var medias = Props.medias;
    var getMediaSize = Props.getMediaSize;
    var onClick = Props.onClick;
    var onMainImageRendered = Props.onMainImageRendered;
    var onSlideChange = Props.onSlideChange;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var cardShape = $1xf0g.CategoryCard.getCardShape(settings.productCardShape, [
        /* Square */ 1,
        /* Portrait */ 3,
        /* Landscape */ 2
    ], productCategory.card);
    var minHeight = cardShape === 1 ? windowWidth : 450;
    var containerHeight = $81N94.int_min(minHeight, windowHeight * 0.65 | 0);
    var durationCn = $ezf3v.duration(phaseDuration);
    var minimal = phase !== /* CompleteFullscreen */ 2;
    var slides = $i7mYY.mapWithIndex(medias, function(i, item) {
        var rect = i === 0 && typeof phase !== "number" ? phase._0 : undefined;
        return /*#__PURE__*/ $g85JO.createElement($40c962123b0adf15$var$MobilePhotoSlider$MiniSlider$Slide, {
            rect: rect,
            item: item,
            index: i,
            visible: i === 0 || !minimal,
            durationCn: durationCn,
            phaseDuration: phaseDuration,
            fitToContainer: fitToContainer,
            containerWidth: containerWidth,
            containerHeight: containerHeight,
            getMediaSize: getMediaSize,
            onClick: function onClick1(param) {
                $iv6Yc._1(onClick, i);
            },
            onMainImageRendered: onMainImageRendered,
            settings: settings
        });
    });
    var stopTouchPropagation = function stopTouchPropagation(prim) {
        prim.stopPropagation();
    };
    var tmp = {
        items: slides,
        spaceBetween: 2,
        enableFreeMode: true,
        freeModeSticky: true,
        freeModeMomentumVelocityRatio: 0.2,
        centeredSlides: true,
        centeredSlidesBounds: true,
        autoHeight: false,
        enableScrollbar: slides.length > 1,
        enableMousewheel: true,
        className: $1TRFX.make([
            $ezf3v.prefix("h-full w-full"),
            "swiper-overflow-visible",
            minimal ? "swiper-hide-scrollbar" : ""
        ]),
        onSlideChange: function onSlideChange1(param) {
            $iv6Yc._1(onSlideChange, undefined);
        },
        key: "mobile-photo-slider-" + productId + ""
    };
    if (zoomedIndex !== undefined) tmp.slideToIndex = $loT9g.valFromOption(zoomedIndex);
    var tmp$1 = minimal ? undefined : "pdp-photo-slider";
    if (tmp$1 !== undefined) tmp.restorationId = $loT9g.valFromOption(tmp$1);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(containerRef),
        className: $ezf3v.prefix("relative flex-shrink-0"),
        style: {
            backgroundColor: settings.pdpGalleryBGColor,
            height: $ezf3v.intToPx(containerHeight)
        },
        onTouchEnd: stopTouchPropagation,
        onTouchMove: stopTouchPropagation,
        onTouchStart: stopTouchPropagation
    }, /*#__PURE__*/ $g85JO.createElement($insiF.make, tmp), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute bottom-4 right-4")
    }, /*#__PURE__*/ $g85JO.createElement($fdM5o.make, {
        product: product,
        variantId: variantId
    })));
}
$40c962123b0adf15$var$MobilePhotoSlider$MiniSlider.displayName = "MobilePhotoSlider.MiniSlider";
var $40c962123b0adf15$export$7a3a1bedb9e0eb42 = {
    Slide: $40c962123b0adf15$var$Slide,
    make: $40c962123b0adf15$var$MobilePhotoSlider$MiniSlider
};
function $40c962123b0adf15$export$6353f655434817c5(height, windowWidth, windowHeight, item) {
    var link;
    switch(item.TAG | 0){
        case /* Image */ 0:
            link = item._0.url;
            break;
        case /* Video */ 1:
            link = item._0.posterUrl;
            break;
        case /* IframeEmbed */ 2:
            link = undefined;
            break;
    }
    var cached = $2whNH.flatMap(link, $55MCT.getCached);
    var mediaSize;
    switch(item.TAG | 0){
        case /* Image */ 0:
            var match = item._0;
            var height$1 = match.height;
            var width = match.width;
            mediaSize = width > 0 && height$1 > 0 ? {
                src: $2whNH.getWithDefault(link, ""),
                naturalWidth: width,
                naturalHeight: height$1,
                color: undefined
            } : undefined;
            break;
        case /* Video */ 1:
            var match$1 = $7KlbQ.Media.getVideoSource(item._0);
            if (match$1 !== undefined) {
                var height$2 = match$1.height;
                var width$1 = match$1.width;
                mediaSize = width$1 > 0 && height$2 > 0 ? {
                    src: $2whNH.getWithDefault(link, ""),
                    naturalWidth: width$1,
                    naturalHeight: height$2,
                    color: undefined
                } : undefined;
            } else mediaSize = undefined;
            break;
        case /* IframeEmbed */ 2:
            mediaSize = undefined;
            break;
    }
    var cached$1 = mediaSize !== undefined ? mediaSize : cached !== undefined ? cached : undefined;
    var match$2;
    if (cached$1 !== undefined) {
        var completeFit = $55MCT.calcObjectFit(cached$1.naturalWidth, cached$1.naturalHeight, undefined, height, /* Contain */ 2);
        match$2 = [
            completeFit.width,
            completeFit.height
        ];
    } else match$2 = [
        windowWidth,
        $2whNH.getWithDefault(height, windowHeight)
    ];
    return [
        match$2[0],
        match$2[1]
    ];
}
function $40c962123b0adf15$var$MobilePhotoSlider(Props) {
    var product = Props.product;
    var productId = Props.productId;
    var variantId = Props.variantId;
    var medias = Props.medias;
    var phaseOpt = Props.phase;
    var phaseDurationOpt = Props.phaseDuration;
    var fitToContainerOpt = Props.fitToContainer;
    var onPhotoZoomed = Props.onPhotoZoomed;
    var onClickImage = Props.onClickImage;
    var onSlideChange = Props.onSlideChange;
    var onClickThumbnail = Props.onClickThumbnail;
    var viewport = Props.viewport;
    var settings = Props.settings;
    var productCategory = Props.productCategory;
    var phase = phaseOpt !== undefined ? phaseOpt : /* CompleteFullscreen */ 2;
    var phaseDuration = phaseDurationOpt !== undefined ? phaseDurationOpt : 0;
    var fitToContainer = fitToContainerOpt !== undefined ? fitToContainerOpt : true;
    var match = $hBcYV.useRouter(undefined);
    var route = match.route;
    var match$1 = $IFWJb.use(undefined);
    var match$2 = $aSJcu.use(undefined);
    var match$3 = match$2.windowSize;
    var windowHeight = match$3.height;
    var windowWidth = match$3.width;
    var isMobile = match$2.isMobile;
    var match$4 = $9pMGg.use(undefined);
    var trackEvent = match$4.trackEvent;
    var match$5 = $kQvlq.useSafeTimeout(undefined, undefined);
    var clearSlideChangeTimeout = match$5.clearTimeout;
    var setSlideChangeTimeout = match$5.setTimeout;
    var zoomedIndex;
    if (typeof route === "number") zoomedIndex = undefined;
    else switch(route.TAG | 0){
        case /* PDP */ 2:
            zoomedIndex = route._0.zoomedPhotoIndex;
            break;
        case /* QuickView */ 3:
            zoomedIndex = route._0.zoomedPhotoIndex;
            break;
        default:
            zoomedIndex = undefined;
    }
    var containerRef = $g85JO.useRef(null);
    var match$6 = $2whNH.mapWithDefault($9EMq4.useResizeObserver(containerRef), [
        windowWidth,
        windowHeight
    ], function(size) {
        return [
            size.width,
            size.height
        ];
    });
    var goToSlide = function goToSlide(index) {
        $iv6Yc._1(clearSlideChangeTimeout, undefined);
        setSlideChangeTimeout(function(param) {
            $iv6Yc._1(onPhotoZoomed, index);
        }, 30);
    };
    var enterZoom = $g85JO.useCallback(function(index) {
        goToSlide(index);
        $iv6Yc.app(trackEvent, [
            "Clicked PDP Photo",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    }, [
        goToSlide,
        trackEvent
    ]);
    var exitZoom = function exitZoom(param) {
        $iv6Yc._1(onPhotoZoomed, undefined);
    };
    var images = $i7mYY.keepMap(medias, function(item) {
        switch(item.TAG | 0){
            case /* Image */ 0:
                return item._0.url;
            case /* Video */ 1:
                return item._0.posterUrl;
            case /* IframeEmbed */ 2:
                return;
        }
    });
    var total = images.length;
    var match$7 = $g85JO.useState(function() {
        return false;
    });
    var setZoomed = match$7[1];
    var zoomed = match$7[0];
    var handleZoom = function handleZoom(ref, $$event) {
        $iv6Yc._1(setZoomed, function(param) {
            return ref.state.scale > 1;
        });
    };
    var isOpen = $2whNH.isSome(zoomedIndex);
    var onClick = function onClick(index) {
        $iv6Yc._1(onClickImage, undefined);
        $iv6Yc._1(enterZoom, index);
    };
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($40c962123b0adf15$var$MobilePhotoSlider$MiniSlider, {
        product: product,
        variantId: variantId,
        productId: productId,
        phase: phase,
        phaseDuration: phaseDuration,
        productCategory: productCategory,
        windowWidth: windowWidth,
        windowHeight: windowHeight,
        fitToContainer: fitToContainer,
        containerWidth: match$6[0],
        containerRef: containerRef,
        zoomedIndex: zoomedIndex,
        medias: medias,
        getMediaSize: function getMediaSize1(param) {
            return function(param$1) {
                return $40c962123b0adf15$export$6353f655434817c5(param, windowWidth, windowHeight, param$1);
            };
        },
        onClick: onClick,
        onMainImageRendered: match$1.onMainImageRendered,
        onSlideChange: onSlideChange
    }), /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "mobile-photo-slider",
        portal: true,
        children: /*#__PURE__*/ $g85JO.createElement($e2Ecw.make, {
            isOpen: isOpen,
            getSourceEl: function getSourceEl(param) {
                return $2whNH.flatMap($2whNH.map(zoomedIndex, function(index) {
                    return ".QVTW__product-photo-" + String(index);
                }), function(qs) {
                    var doc = document;
                    return $loT9g.nullable_to_opt(doc.querySelector(qs));
                });
            },
            renderForeground: function renderForeground(phase, duration) {
                if (zoomedIndex !== undefined) {
                    if (isMobile) {
                        var renderSlide = function renderSlide(duration, item, index, rect) {
                            var active = index === zoomedIndex;
                            var match = $40c962123b0adf15$export$6353f655434817c5(undefined, windowWidth, windowHeight, item);
                            var mediaHeight = match[1];
                            var mediaWidth = match[0];
                            var naturalSize = rect !== undefined ? {
                                width: rect.width,
                                height: rect.height
                            } : mediaWidth !== 0 && mediaHeight !== 0 ? {
                                width: mediaWidth,
                                height: mediaHeight
                            } : undefined;
                            if (naturalSize === undefined) return null;
                            var largeContainer = {
                                x: 0,
                                y: 0,
                                width: windowWidth,
                                height: windowHeight
                            };
                            var tmp = {
                                largeContainer: largeContainer,
                                naturalSize: naturalSize,
                                smallFitRule: "contain",
                                largeFitRule: "contain",
                                duration: duration,
                                render: function render(param) {
                                    switch(item.TAG | 0){
                                        case /* Image */ 0:
                                            return /*#__PURE__*/ $g85JO.createElement("span", {
                                                className: $ezf3v.prefix("bg-white")
                                            }, /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                                                src: item._0.url,
                                                containerWidth: windowWidth,
                                                containerHeight: windowHeight,
                                                fit: /* Contain */ 2,
                                                priority: active ? 0 : 1
                                            }));
                                        case /* Video */ 1:
                                            var video = item._0;
                                            var src = $2whNH.map($7KlbQ.getVideoSource(video), function(source) {
                                                return source.url;
                                            });
                                            if (src === undefined) return null;
                                            var tmp = {
                                                src: src,
                                                prioritize: true,
                                                autoplay: settings.videoAutoPlay,
                                                loop: settings.videoLoop,
                                                muted: settings.videoMute,
                                                controls: settings.videoControls,
                                                key: variantId
                                            };
                                            if (video.posterUrl !== undefined) tmp.poster = video.posterUrl;
                                            return /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp);
                                        case /* IframeEmbed */ 2:
                                            return /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                                                url: item._0.url
                                            });
                                    }
                                }
                            };
                            if (rect !== undefined) tmp.smallContainer = $loT9g.valFromOption(rect);
                            return /*#__PURE__*/ $g85JO.createElement($c0njb.make, {
                                onPullDown: exitZoom,
                                children: /*#__PURE__*/ $g85JO.createElement($4IRro.TransformWrapper, {
                                    panning: {
                                        disabled: !zoomed
                                    },
                                    doubleClick: {
                                        disabled: true
                                    },
                                    onZoom: handleZoom,
                                    children: /*#__PURE__*/ $g85JO.createElement($4IRro.TransformComponent, {
                                        wrapperClass: $ezf3v.prefix("absolute inset-0 w-full h-full"),
                                        contentClass: $ezf3v.prefix("absolute inset-0 w-full h-full"),
                                        children: /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
                                            className: $ezf3v.prefix("absolute inset-0 no-flicker"),
                                            onClick: function onClick(param) {
                                                $iv6Yc._1(onPhotoZoomed, undefined);
                                            }
                                        }), /*#__PURE__*/ $g85JO.createElement($kPwXH.make, tmp))
                                    })
                                })
                            });
                        };
                        var closeButton = /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
                            color: /* Light */ 1,
                            className: $ezf3v.prefix("inline-block rounded-full p-4"),
                            onClick: function onClick(param) {
                                $iv6Yc._1(onPhotoZoomed, undefined);
                                $iv6Yc.app(trackEvent, [
                                    "Clicked PDP Carousel Close Button",
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined
                                ]);
                            },
                            children: /*#__PURE__*/ $g85JO.createElement($90LTg.make, {
                                className: $ezf3v.prefix("w-5 h-5")
                            }),
                            dataTestId: "photo-zoom-close-button"
                        });
                        var renderBlur = function renderBlur(phase) {
                            var show = phase !== 0;
                            return /*#__PURE__*/ $g85JO.createElement("div", {
                                className: $ezf3v.prefix($1TRFX.make([
                                    "absolute inset-0 backdrop-blur transition-opacity no-flicker",
                                    show ? "duration-0 opacity-100" : "duration-0 opacity-0"
                                ]))
                            });
                        };
                        var renderSlider = function renderSlider(phase, duration) {
                            var minimal = phase !== /* CompleteFullscreen */ 2;
                            var slides = $i7mYY.mapWithIndex(medias, function(i, item) {
                                if (!(!minimal || i === zoomedIndex)) return renderSlide(duration, item, i, undefined);
                                var rect = typeof phase === "number" ? undefined : phase._0;
                                return renderSlide(duration, item, i, rect);
                            });
                            return /*#__PURE__*/ $g85JO.createElement("div", {
                                className: $ezf3v.prefix("absolute inset-0 no-flicker")
                            }, /*#__PURE__*/ $g85JO.createElement($insiF.make, {
                                items: slides,
                                initialSlide: zoomedIndex,
                                slidesPerView: /* Float */ {
                                    _0: 1
                                },
                                autoHeight: false,
                                slideToIndex: zoomedIndex,
                                enableKeyboard: true,
                                enableNavigation: !isMobile,
                                className: $ezf3v.prefix("absolute inset-0 no-flicker"),
                                onSlideChange: function onSlideChange(e) {
                                    goToSlide(e.activeIndex);
                                },
                                keepDisabledButtonsVisible: true
                            }), /*#__PURE__*/ $g85JO.createElement($gpCTg.make, {
                                index: zoomedIndex,
                                total: total,
                                onClick: function onClick(i) {
                                    goToSlide(i);
                                },
                                isMobile: isMobile,
                                dataTestId: "photo-zoom-tabs"
                            }));
                        };
                        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, renderBlur(phase), renderSlider(phase, duration), /*#__PURE__*/ $g85JO.createElement("div", {
                            className: $ezf3v.prefix("p-5 absolute top-0 right-0")
                        }, closeButton));
                    } else return /*#__PURE__*/ $g85JO.createElement($9JqU1.make, {
                        product: product,
                        variantId: variantId,
                        medias: medias,
                        viewport: viewport,
                        onSlideChange: function onSlideChange1(param) {
                            $iv6Yc._1(onSlideChange, undefined);
                        },
                        onClickThumbnail: onClickThumbnail,
                        bgBlur: false,
                        thumbnailsPosition: "center",
                        selectedIndex: zoomedIndex,
                        onClose: function onClose(param) {
                            $iv6Yc._1(onPhotoZoomed, undefined);
                        },
                        onPhotoZoomed: onPhotoZoomed
                    });
                } else return null;
            }
        })
    }));
}
$40c962123b0adf15$var$MobilePhotoSlider.displayName = "MobilePhotoSlider";
var $40c962123b0adf15$export$dd44f18ab656f3bb = $40c962123b0adf15$var$MobilePhotoSlider;
 /* react Not a pure module */ 
});
parcelRegister("90LTg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $68f9432b3e47641f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $68f9432b3e47641f$var$IconClose(Props) {
    var className = Props.className;
    var tmp = {
        height: "12",
        width: "12",
        viewBox: "0 0 12 12",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M 6.877 6.142 L 11.332 1.687 C 11.372 1.647 11.372 1.581 11.332 1.541 L 10.744 0.954 C 10.704 0.913 10.638 0.913 10.597 0.954 L 6.142 5.408 L 1.688 0.954 C 1.647 0.913 1.582 0.913 1.541 0.954 L 0.953 1.541 C 0.913 1.581 0.913 1.647 0.953 1.687 L 5.408 6.142 L 0.953 10.597 C 0.913 10.638 0.913 10.703 0.953 10.744 L 1.541 11.332 C 1.582 11.372 1.647 11.372 1.688 11.332 L 6.142 6.877 L 10.597 11.332 C 10.638 11.372 10.704 11.372 10.744 11.332 L 11.332 10.744 C 11.372 10.703 11.372 10.638 11.332 10.597 Z",
        fill: "currentColor"
    }));
}
$68f9432b3e47641f$var$IconClose.displayName = "IconClose";
var $68f9432b3e47641f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($68f9432b3e47641f$var$IconClose);
 /* make Not a pure module */ 
});

parcelRegister("4IRro", function(module, exports) {

$parcel$export(module.exports, "TransformWrapper", function () { return $3704b9b8b7d6768a$export$51cb649375dcd655; });
$parcel$export(module.exports, "TransformComponent", function () { return $3704b9b8b7d6768a$export$1def2aa75b7c7fe0; });

var $g85JO = parcelRequire("g85JO");
/**
 * Rounds number to given decimal
 * eg. roundNumber(2.34343, 1) => 2.3
 */ var $3704b9b8b7d6768a$var$roundNumber = function roundNumber(num, decimal) {
    return Number(num.toFixed(decimal));
};
/**
 * Checks if value is number, if not it returns default value
 * 1# eg. checkIsNumber(2, 30) => 2
 * 2# eg. checkIsNumber(null, 30) => 30
 */ var $3704b9b8b7d6768a$var$checkIsNumber = function checkIsNumber(num, defaultValue) {
    return typeof num === "number" ? num : defaultValue;
};
var $3704b9b8b7d6768a$var$handleCallback = function handleCallback(context, event, callback) {
    if (callback && typeof callback === "function") callback(context, event);
};
/* eslint-disable no-plusplus */ /* eslint-disable no-param-reassign */ /**
 * Functions should return denominator of the target value, which is the next animation step.
 * t is a value from 0 to 1, reflecting the percentage of animation status.
 */ var $3704b9b8b7d6768a$var$easeOut = function easeOut(t) {
    return -Math.cos(t * Math.PI) / 2 + 0.5;
};
// linear
var $3704b9b8b7d6768a$var$linear = function linear(t) {
    return t;
};
// accelerating from zero velocity
var $3704b9b8b7d6768a$var$easeInQuad = function easeInQuad(t) {
    return t * t;
};
// decelerating to zero velocity
var $3704b9b8b7d6768a$var$easeOutQuad = function easeOutQuad(t) {
    return t * (2 - t);
};
// acceleration until halfway, then deceleration
var $3704b9b8b7d6768a$var$easeInOutQuad = function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
};
// accelerating from zero velocity
var $3704b9b8b7d6768a$var$easeInCubic = function easeInCubic(t) {
    return t * t * t;
};
// decelerating to zero velocity
var $3704b9b8b7d6768a$var$easeOutCubic = function easeOutCubic(t) {
    return --t * t * t + 1;
};
// acceleration until halfway, then deceleration
var $3704b9b8b7d6768a$var$easeInOutCubic = function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
};
// accelerating from zero velocity
var $3704b9b8b7d6768a$var$easeInQuart = function easeInQuart(t) {
    return t * t * t * t;
};
// decelerating to zero velocity
var $3704b9b8b7d6768a$var$easeOutQuart = function easeOutQuart(t) {
    return 1 - --t * t * t * t;
};
// acceleration until halfway, then deceleration
var $3704b9b8b7d6768a$var$easeInOutQuart = function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
};
// accelerating from zero velocity
var $3704b9b8b7d6768a$var$easeInQuint = function easeInQuint(t) {
    return t * t * t * t * t;
};
// decelerating to zero velocity
var $3704b9b8b7d6768a$var$easeOutQuint = function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
};
// acceleration until halfway, then deceleration
var $3704b9b8b7d6768a$var$easeInOutQuint = function easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
};
var $3704b9b8b7d6768a$var$animations = {
    easeOut: $3704b9b8b7d6768a$var$easeOut,
    linear: $3704b9b8b7d6768a$var$linear,
    easeInQuad: $3704b9b8b7d6768a$var$easeInQuad,
    easeOutQuad: $3704b9b8b7d6768a$var$easeOutQuad,
    easeInOutQuad: $3704b9b8b7d6768a$var$easeInOutQuad,
    easeInCubic: $3704b9b8b7d6768a$var$easeInCubic,
    easeOutCubic: $3704b9b8b7d6768a$var$easeOutCubic,
    easeInOutCubic: $3704b9b8b7d6768a$var$easeInOutCubic,
    easeInQuart: $3704b9b8b7d6768a$var$easeInQuart,
    easeOutQuart: $3704b9b8b7d6768a$var$easeOutQuart,
    easeInOutQuart: $3704b9b8b7d6768a$var$easeInOutQuart,
    easeInQuint: $3704b9b8b7d6768a$var$easeInQuint,
    easeOutQuint: $3704b9b8b7d6768a$var$easeOutQuint,
    easeInOutQuint: $3704b9b8b7d6768a$var$easeInOutQuint
};
/* eslint-disable no-param-reassign */ var $3704b9b8b7d6768a$var$handleCancelAnimationFrame = function handleCancelAnimationFrame(animation) {
    if (typeof animation === "number") cancelAnimationFrame(animation);
};
var $3704b9b8b7d6768a$var$handleCancelAnimation = function handleCancelAnimation(contextInstance) {
    if (!contextInstance.mounted) return;
    $3704b9b8b7d6768a$var$handleCancelAnimationFrame(contextInstance.animation);
    // Clear animation state
    contextInstance.animate = false;
    contextInstance.animation = null;
    contextInstance.velocity = null;
};
function $3704b9b8b7d6768a$var$handleSetupAnimation(contextInstance, animationName, animationTime, callback) {
    if (!contextInstance.mounted) return;
    var startTime = new Date().getTime();
    var lastStep = 1;
    // if another animation is active
    $3704b9b8b7d6768a$var$handleCancelAnimation(contextInstance);
    // new animation
    contextInstance.animation = function() {
        if (!contextInstance.mounted) return $3704b9b8b7d6768a$var$handleCancelAnimationFrame(contextInstance.animation);
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / animationTime;
        var animationType = $3704b9b8b7d6768a$var$animations[animationName];
        var step = animationType(animationProgress);
        if (frameTime >= animationTime) {
            callback(lastStep);
            contextInstance.animation = null;
        } else if (contextInstance.animation) {
            callback(step);
            requestAnimationFrame(contextInstance.animation);
        }
    };
    requestAnimationFrame(contextInstance.animation);
}
function $3704b9b8b7d6768a$var$isValidTargetState(targetState) {
    var scale = targetState.scale, positionX = targetState.positionX, positionY = targetState.positionY;
    if (Number.isNaN(scale) || Number.isNaN(positionX) || Number.isNaN(positionY)) return false;
    return true;
}
function $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationName) {
    var isValid = $3704b9b8b7d6768a$var$isValidTargetState(targetState);
    if (!contextInstance.mounted || !isValid) return;
    var setTransformState = contextInstance.setTransformState;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDiff = targetState.scale - scale;
    var positionXDiff = targetState.positionX - positionX;
    var positionYDiff = targetState.positionY - positionY;
    if (animationTime === 0) setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
    else // animation start timestamp
    $3704b9b8b7d6768a$var$handleSetupAnimation(contextInstance, animationName, animationTime, function(step) {
        var newScale = scale + scaleDiff * step;
        var newPositionX = positionX + positionXDiff * step;
        var newPositionY = positionY + positionYDiff * step;
        setTransformState(newScale, newPositionX, newPositionY);
    });
}
/* eslint-disable no-param-reassign */ function $3704b9b8b7d6768a$var$getComponentsSizes(wrapperComponent, contentComponent, newScale) {
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var contentWidth = contentComponent.offsetWidth;
    var contentHeight = contentComponent.offsetHeight;
    var newContentWidth = contentWidth * newScale;
    var newContentHeight = contentHeight * newScale;
    var newDiffWidth = wrapperWidth - newContentWidth;
    var newDiffHeight = wrapperHeight - newContentHeight;
    return {
        wrapperWidth: wrapperWidth,
        wrapperHeight: wrapperHeight,
        newContentWidth: newContentWidth,
        newDiffWidth: newDiffWidth,
        newContentHeight: newContentHeight,
        newDiffHeight: newDiffHeight
    };
}
var $3704b9b8b7d6768a$var$getBounds = function getBounds(wrapperWidth, newContentWidth, diffWidth, wrapperHeight, newContentHeight, diffHeight, centerZoomedOut) {
    var scaleWidthFactor = wrapperWidth > newContentWidth ? diffWidth * (centerZoomedOut ? 1 : 0.5) : 0;
    var scaleHeightFactor = wrapperHeight > newContentHeight ? diffHeight * (centerZoomedOut ? 1 : 0.5) : 0;
    var minPositionX = wrapperWidth - newContentWidth - scaleWidthFactor;
    var maxPositionX = scaleWidthFactor;
    var minPositionY = wrapperHeight - newContentHeight - scaleHeightFactor;
    var maxPositionY = scaleHeightFactor;
    return {
        minPositionX: minPositionX,
        maxPositionX: maxPositionX,
        minPositionY: minPositionY,
        maxPositionY: maxPositionY
    };
};
var $3704b9b8b7d6768a$var$calculateBounds = function calculateBounds(contextInstance, newScale) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
    var centerZoomedOut = contextInstance.setup.centerZoomedOut;
    if (!wrapperComponent || !contentComponent) throw new Error("Components are not mounted");
    var _a = $3704b9b8b7d6768a$var$getComponentsSizes(wrapperComponent, contentComponent, newScale), wrapperWidth = _a.wrapperWidth, wrapperHeight = _a.wrapperHeight, newContentWidth = _a.newContentWidth, newDiffWidth = _a.newDiffWidth, newContentHeight = _a.newContentHeight, newDiffHeight = _a.newDiffHeight;
    var bounds = $3704b9b8b7d6768a$var$getBounds(wrapperWidth, newContentWidth, newDiffWidth, wrapperHeight, newContentHeight, newDiffHeight, Boolean(centerZoomedOut));
    return bounds;
};
/**
 * Keeps value between given bounds, used for limiting view to given boundaries
 * 1# eg. boundLimiter(2, 0, 3, true) => 2
 * 2# eg. boundLimiter(4, 0, 3, true) => 3
 * 3# eg. boundLimiter(-2, 0, 3, true) => 0
 * 4# eg. boundLimiter(10, 0, 3, false) => 10
 */ var $3704b9b8b7d6768a$var$boundLimiter = function boundLimiter(value, minBound, maxBound, isActive) {
    if (!isActive) return $3704b9b8b7d6768a$var$roundNumber(value, 2);
    if (value < minBound) return $3704b9b8b7d6768a$var$roundNumber(minBound, 2);
    if (value > maxBound) return $3704b9b8b7d6768a$var$roundNumber(maxBound, 2);
    return $3704b9b8b7d6768a$var$roundNumber(value, 2);
};
var $3704b9b8b7d6768a$var$handleCalculateBounds = function handleCalculateBounds(contextInstance, newScale) {
    var bounds = $3704b9b8b7d6768a$var$calculateBounds(contextInstance, newScale);
    // Save bounds
    contextInstance.bounds = bounds;
    return bounds;
};
function $3704b9b8b7d6768a$var$getMouseBoundedPosition(positionX, positionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent) {
    var minPositionX = bounds.minPositionX, minPositionY = bounds.minPositionY, maxPositionX = bounds.maxPositionX, maxPositionY = bounds.maxPositionY;
    var paddingX = 0;
    var paddingY = 0;
    if (wrapperComponent) {
        paddingX = paddingValueX;
        paddingY = paddingValueY;
    }
    var x = $3704b9b8b7d6768a$var$boundLimiter(positionX, minPositionX - paddingX, maxPositionX + paddingX, limitToBounds);
    var y = $3704b9b8b7d6768a$var$boundLimiter(positionY, minPositionY - paddingY, maxPositionY + paddingY, limitToBounds);
    return {
        x: x,
        y: y
    };
}
function $3704b9b8b7d6768a$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds) {
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    var scaleDifference = newScale - scale;
    if (typeof mouseX !== "number" || typeof mouseY !== "number") {
        console.error("Mouse X and Y position were not provided!");
        return {
            x: positionX,
            y: positionY
        };
    }
    var calculatedPositionX = positionX - mouseX * scaleDifference;
    var calculatedPositionY = positionY - mouseY * scaleDifference;
    // do not limit to bounds when there is padding animation,
    // it causes animation strange behaviour
    var newPositions = $3704b9b8b7d6768a$var$getMouseBoundedPosition(calculatedPositionX, calculatedPositionY, bounds, limitToBounds, 0, 0, null);
    return newPositions;
}
function $3704b9b8b7d6768a$var$checkZoomBounds(zoom, minScale, maxScale, zoomPadding, enablePadding) {
    var scalePadding = enablePadding ? zoomPadding : 0;
    var minScaleWithPadding = minScale - scalePadding;
    if (!Number.isNaN(maxScale) && zoom >= maxScale) return maxScale;
    if (!Number.isNaN(minScale) && zoom <= minScaleWithPadding) return minScaleWithPadding;
    return zoom;
}
var $3704b9b8b7d6768a$var$isPanningStartAllowed = function isPanningStartAllowed(contextInstance, event) {
    var excluded = contextInstance.setup.panning.excluded;
    var isInitialized = contextInstance.isInitialized, wrapperComponent = contextInstance.wrapperComponent;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild;
    if (!isAllowed) return false;
    var isExcluded = $3704b9b8b7d6768a$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $3704b9b8b7d6768a$var$isPanningAllowed = function isPanningAllowed(contextInstance) {
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning, setup = contextInstance.setup;
    var disabled = setup.panning.disabled;
    var isAllowed = isInitialized && isPanning && !disabled;
    if (!isAllowed) return false;
    return true;
};
var $3704b9b8b7d6768a$var$handlePanningSetup = function handlePanningSetup(contextInstance, event) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with mouse
    var x = event.clientX;
    var y = event.clientY;
    contextInstance.startCoords = {
        x: x - positionX,
        y: y - positionY
    };
};
var $3704b9b8b7d6768a$var$handleTouchPanningSetup = function handleTouchPanningSetup(contextInstance, event) {
    var touches = event.touches;
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY;
    contextInstance.isPanning = true;
    // Panning with touch
    var oneFingerTouch = touches.length === 1;
    if (oneFingerTouch) {
        var x = touches[0].clientX;
        var y = touches[0].clientY;
        contextInstance.startCoords = {
            x: x - positionX,
            y: y - positionY
        };
    }
};
function $3704b9b8b7d6768a$var$handlePanToBounds(contextInstance) {
    var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
    var _b = contextInstance.setup, disabled = _b.disabled, limitToBounds = _b.limitToBounds, centerZoomedOut = _b.centerZoomedOut;
    var wrapperComponent = contextInstance.wrapperComponent;
    if (disabled || !wrapperComponent || !contextInstance.bounds) return;
    var _c = contextInstance.bounds, maxPositionX = _c.maxPositionX, minPositionX = _c.minPositionX, maxPositionY = _c.maxPositionY, minPositionY = _c.minPositionY;
    var xChanged = positionX > maxPositionX || positionX < minPositionX;
    var yChanged = positionY > maxPositionY || positionY < minPositionY;
    var mousePosX = positionX > maxPositionX ? wrapperComponent.offsetWidth : contextInstance.setup.minPositionX || 0;
    var mousePosY = positionY > maxPositionY ? wrapperComponent.offsetHeight : contextInstance.setup.minPositionY || 0;
    var _d = $3704b9b8b7d6768a$var$handleCalculateZoomPositions(contextInstance, mousePosX, mousePosY, scale, contextInstance.bounds, limitToBounds || centerZoomedOut), x = _d.x, y = _d.y;
    return {
        scale: scale,
        positionX: xChanged ? x : positionX,
        positionY: yChanged ? y : positionY
    };
}
function $3704b9b8b7d6768a$var$handleNewPosition(contextInstance, newPositionX, newPositionY, paddingValueX, paddingValueY) {
    var limitToBounds = contextInstance.setup.limitToBounds;
    var wrapperComponent = contextInstance.wrapperComponent, bounds = contextInstance.bounds;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (wrapperComponent === null || bounds === null || newPositionX === positionX && newPositionY === positionY) return;
    var _b = $3704b9b8b7d6768a$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, paddingValueX, paddingValueY, wrapperComponent), x = _b.x, y = _b.y;
    contextInstance.setTransformState(scale, x, y);
}
var $3704b9b8b7d6768a$var$getPanningClientPosition = function getPanningClientPosition(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, transformState = contextInstance.transformState;
    var panning = contextInstance.setup.panning;
    var lockAxisX = panning.lockAxisX, lockAxisY = panning.lockAxisY;
    var positionX = transformState.positionX, positionY = transformState.positionY;
    if (!startCoords) return {
        x: positionX,
        y: positionY
    };
    var mouseX = clientX - startCoords.x;
    var mouseY = clientY - startCoords.y;
    var newPositionX = lockAxisX ? positionX : mouseX;
    var newPositionY = lockAxisY ? positionY : mouseY;
    return {
        x: newPositionX,
        y: newPositionY
    };
};
var $3704b9b8b7d6768a$var$getPaddingValue = function getPaddingValue(contextInstance, size) {
    var setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var minScale = setup.minScale, disablePadding = setup.disablePadding;
    if (size > 0 && scale >= minScale && !disablePadding) return size;
    return 0;
};
var $3704b9b8b7d6768a$var$isVelocityCalculationAllowed = function isVelocityCalculationAllowed(contextInstance) {
    var mounted = contextInstance.mounted;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    return true;
};
var $3704b9b8b7d6768a$var$isVelocityAllowed = function isVelocityAllowed(contextInstance) {
    var mounted = contextInstance.mounted, velocity = contextInstance.velocity, bounds = contextInstance.bounds;
    var _a = contextInstance.setup, disabled = _a.disabled, velocityAnimation = _a.velocityAnimation;
    var scale = contextInstance.transformState.scale;
    var disabledVelocity = velocityAnimation.disabled;
    var isAllowed = !disabledVelocity || scale > 1 || !disabled || mounted;
    if (!isAllowed) return false;
    if (!velocity || !bounds) return false;
    return true;
};
function $3704b9b8b7d6768a$var$getVelocityMoveTime(contextInstance, velocity) {
    var velocityAnimation = contextInstance.setup.velocityAnimation;
    var equalToMove = velocityAnimation.equalToMove, animationTime = velocityAnimation.animationTime, sensitivity = velocityAnimation.sensitivity;
    if (equalToMove) return animationTime * velocity * sensitivity;
    return animationTime;
}
function $3704b9b8b7d6768a$var$getVelocityPosition(newPosition, startPosition, currentPosition, isLocked, limitToBounds, minPosition, maxPosition, minTarget, maxTarget, step) {
    if (limitToBounds) {
        if (startPosition > maxPosition && currentPosition > maxPosition) {
            var calculatedPosition = maxPosition + (newPosition - maxPosition) * step;
            if (calculatedPosition > maxTarget) return maxTarget;
            if (calculatedPosition < maxPosition) return maxPosition;
            return calculatedPosition;
        }
        if (startPosition < minPosition && currentPosition < minPosition) {
            var calculatedPosition = minPosition + (newPosition - minPosition) * step;
            if (calculatedPosition < minTarget) return minTarget;
            if (calculatedPosition > minPosition) return minPosition;
            return calculatedPosition;
        }
    }
    if (isLocked) return startPosition;
    return $3704b9b8b7d6768a$var$boundLimiter(newPosition, minPosition, maxPosition, limitToBounds);
}
function $3704b9b8b7d6768a$var$getSizeMultiplier(wrapperComponent, equalToMove) {
    var defaultMultiplier = 1;
    if (equalToMove) return Math.min(defaultMultiplier, wrapperComponent.offsetWidth / window.innerWidth);
    return defaultMultiplier;
}
function $3704b9b8b7d6768a$var$handleCalculateVelocity(contextInstance, position) {
    var isAllowed = $3704b9b8b7d6768a$var$isVelocityCalculationAllowed(contextInstance);
    if (!isAllowed) return;
    var lastMousePosition = contextInstance.lastMousePosition, velocityTime = contextInstance.velocityTime, setup = contextInstance.setup;
    var wrapperComponent = contextInstance.wrapperComponent;
    var equalToMove = setup.velocityAnimation.equalToMove;
    var now = Date.now();
    if (lastMousePosition && velocityTime && wrapperComponent) {
        var sizeMultiplier = $3704b9b8b7d6768a$var$getSizeMultiplier(wrapperComponent, equalToMove);
        var distanceX = position.x - lastMousePosition.x;
        var distanceY = position.y - lastMousePosition.y;
        var velocityX = distanceX / sizeMultiplier;
        var velocityY = distanceY / sizeMultiplier;
        var interval = now - velocityTime;
        var speed = distanceX * distanceX + distanceY * distanceY;
        var velocity = Math.sqrt(speed) / interval;
        contextInstance.velocity = {
            velocityX: velocityX,
            velocityY: velocityY,
            total: velocity
        };
    }
    contextInstance.lastMousePosition = position;
    contextInstance.velocityTime = now;
}
function $3704b9b8b7d6768a$var$handleVelocityPanning(contextInstance) {
    var velocity = contextInstance.velocity, bounds = contextInstance.bounds, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var isAllowed = $3704b9b8b7d6768a$var$isVelocityAllowed(contextInstance);
    if (!isAllowed || !velocity || !bounds || !wrapperComponent) return;
    var velocityX = velocity.velocityX, velocityY = velocity.velocityY, total = velocity.total;
    var maxPositionX = bounds.maxPositionX, minPositionX = bounds.minPositionX, maxPositionY = bounds.maxPositionY, minPositionY = bounds.minPositionY;
    var limitToBounds = setup.limitToBounds, alignmentAnimation = setup.alignmentAnimation;
    var zoomAnimation = setup.zoomAnimation, panning = setup.panning;
    var lockAxisY = panning.lockAxisY, lockAxisX = panning.lockAxisX;
    var animationType = zoomAnimation.animationType;
    var sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, velocityAlignmentTime = alignmentAnimation.velocityAlignmentTime;
    var alignAnimationTime = velocityAlignmentTime;
    var moveAnimationTime = $3704b9b8b7d6768a$var$getVelocityMoveTime(contextInstance, total);
    var finalAnimationTime = Math.max(moveAnimationTime, alignAnimationTime);
    var paddingValueX = $3704b9b8b7d6768a$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $3704b9b8b7d6768a$var$getPaddingValue(contextInstance, sizeY);
    var paddingX = paddingValueX * wrapperComponent.offsetWidth / 100;
    var paddingY = paddingValueY * wrapperComponent.offsetHeight / 100;
    var maxTargetX = maxPositionX + paddingX;
    var minTargetX = minPositionX - paddingX;
    var maxTargetY = maxPositionY + paddingY;
    var minTargetY = minPositionY - paddingY;
    var startState = contextInstance.transformState;
    var startTime = new Date().getTime();
    $3704b9b8b7d6768a$var$handleSetupAnimation(contextInstance, animationType, finalAnimationTime, function(step) {
        var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
        var frameTime = new Date().getTime() - startTime;
        var animationProgress = frameTime / alignAnimationTime;
        var alignAnimation = $3704b9b8b7d6768a$var$animations[alignmentAnimation.animationType];
        var alignStep = 1 - alignAnimation(Math.min(1, animationProgress));
        var customStep = 1 - step;
        var newPositionX = positionX + velocityX * customStep;
        var newPositionY = positionY + velocityY * customStep;
        var currentPositionX = $3704b9b8b7d6768a$var$getVelocityPosition(newPositionX, startState.positionX, positionX, lockAxisX, limitToBounds, minPositionX, maxPositionX, minTargetX, maxTargetX, alignStep);
        var currentPositionY = $3704b9b8b7d6768a$var$getVelocityPosition(newPositionY, startState.positionY, positionY, lockAxisY, limitToBounds, minPositionY, maxPositionY, minTargetY, maxTargetY, alignStep);
        if (positionX !== newPositionX || positionY !== newPositionY) contextInstance.setTransformState(scale, currentPositionX, currentPositionY);
    });
}
function $3704b9b8b7d6768a$var$handlePanningStart(contextInstance, event) {
    var scale = contextInstance.transformState.scale;
    $3704b9b8b7d6768a$var$handleCancelAnimation(contextInstance);
    $3704b9b8b7d6768a$var$handleCalculateBounds(contextInstance, scale);
    if (window.TouchEvent !== undefined && event instanceof TouchEvent) $3704b9b8b7d6768a$var$handleTouchPanningSetup(contextInstance, event);
    else $3704b9b8b7d6768a$var$handlePanningSetup(contextInstance, event);
}
function $3704b9b8b7d6768a$var$handleAlignToBounds(contextInstance) {
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, minScale = _a.minScale, alignmentAnimation = _a.alignmentAnimation;
    var disabled = alignmentAnimation.disabled, sizeX = alignmentAnimation.sizeX, sizeY = alignmentAnimation.sizeY, animationTime = alignmentAnimation.animationTime, animationType = alignmentAnimation.animationType;
    var isDisabled = disabled || scale < minScale || !sizeX && !sizeY;
    if (isDisabled) return;
    var targetState = $3704b9b8b7d6768a$var$handlePanToBounds(contextInstance);
    if (targetState) $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $3704b9b8b7d6768a$var$handlePanning(contextInstance, clientX, clientY) {
    var startCoords = contextInstance.startCoords, setup = contextInstance.setup;
    var _a = setup.alignmentAnimation, sizeX = _a.sizeX, sizeY = _a.sizeY;
    if (!startCoords) return;
    var _b = $3704b9b8b7d6768a$var$getPanningClientPosition(contextInstance, clientX, clientY), x = _b.x, y = _b.y;
    var paddingValueX = $3704b9b8b7d6768a$var$getPaddingValue(contextInstance, sizeX);
    var paddingValueY = $3704b9b8b7d6768a$var$getPaddingValue(contextInstance, sizeY);
    $3704b9b8b7d6768a$var$handleCalculateVelocity(contextInstance, {
        x: x,
        y: y
    });
    $3704b9b8b7d6768a$var$handleNewPosition(contextInstance, x, y, paddingValueX, paddingValueY);
}
function $3704b9b8b7d6768a$var$handlePanningEnd(contextInstance) {
    if (contextInstance.isPanning) {
        var velocityDisabled = contextInstance.setup.panning.velocityDisabled;
        var velocity = contextInstance.velocity, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        contextInstance.isPanning = false;
        contextInstance.animate = false;
        contextInstance.animation = null;
        var wrapperRect = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.getBoundingClientRect();
        var contentRect = contentComponent === null || contentComponent === void 0 ? void 0 : contentComponent.getBoundingClientRect();
        var wrapperWidth = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.width) || 0;
        var wrapperHeight = (wrapperRect === null || wrapperRect === void 0 ? void 0 : wrapperRect.height) || 0;
        var contentWidth = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.width) || 0;
        var contentHeight = (contentRect === null || contentRect === void 0 ? void 0 : contentRect.height) || 0;
        var isZoomed = wrapperWidth < contentWidth || wrapperHeight < contentHeight;
        var shouldAnimate = !velocityDisabled && velocity && (velocity === null || velocity === void 0 ? void 0 : velocity.total) > 0.1 && isZoomed;
        if (shouldAnimate) $3704b9b8b7d6768a$var$handleVelocityPanning(contextInstance);
        else $3704b9b8b7d6768a$var$handleAlignToBounds(contextInstance);
    }
}
function $3704b9b8b7d6768a$var$handleZoomToPoint(contextInstance, scale, mouseX, mouseY) {
    var _a = contextInstance.setup, minScale = _a.minScale, maxScale = _a.maxScale, limitToBounds = _a.limitToBounds;
    var newScale = $3704b9b8b7d6768a$var$checkZoomBounds($3704b9b8b7d6768a$var$roundNumber(scale, 2), minScale, maxScale, 0, false);
    var bounds = $3704b9b8b7d6768a$var$handleCalculateBounds(contextInstance, newScale);
    var _b = $3704b9b8b7d6768a$var$handleCalculateZoomPositions(contextInstance, mouseX, mouseY, newScale, bounds, limitToBounds), x = _b.x, y = _b.y;
    return {
        scale: newScale,
        positionX: x,
        positionY: y
    };
}
function $3704b9b8b7d6768a$var$handleAlignToScaleBounds(contextInstance, mousePositionX, mousePositionY) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.setup, minScale = _a.minScale, limitToBounds = _a.limitToBounds, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, animationTime = zoomAnimation.animationTime, animationType = zoomAnimation.animationType;
    var isDisabled = disabled || scale >= minScale;
    if (scale >= 1 || limitToBounds) // fire fit to bounds animation
    $3704b9b8b7d6768a$var$handleAlignToBounds(contextInstance);
    if (isDisabled || !wrapperComponent || !contextInstance.mounted) return;
    var mouseX = mousePositionX || wrapperComponent.offsetWidth / 2;
    var mouseY = mousePositionY || wrapperComponent.offsetHeight / 2;
    var targetState = $3704b9b8b7d6768a$var$handleZoomToPoint(contextInstance, minScale, mouseX, mouseY);
    if (targetState) $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $3704b9b8b7d6768a$var$__assign = function __assign1() {
    $3704b9b8b7d6768a$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3704b9b8b7d6768a$var$__assign.apply(this, arguments);
};
function $3704b9b8b7d6768a$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $3704b9b8b7d6768a$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
var $3704b9b8b7d6768a$var$initialState = {
    previousScale: 1,
    scale: 1,
    positionX: 0,
    positionY: 0
};
var $3704b9b8b7d6768a$var$initialSetup = {
    disabled: false,
    minPositionX: null,
    maxPositionX: null,
    minPositionY: null,
    maxPositionY: null,
    minScale: 1,
    maxScale: 8,
    limitToBounds: true,
    centerZoomedOut: false,
    centerOnInit: false,
    disablePadding: false,
    smooth: true,
    wheel: {
        step: 0.2,
        disabled: false,
        smoothStep: 0.001,
        wheelDisabled: false,
        touchPadDisabled: false,
        activationKeys: [],
        excluded: []
    },
    panning: {
        disabled: false,
        velocityDisabled: false,
        lockAxisX: false,
        lockAxisY: false,
        allowLeftClickPan: true,
        allowMiddleClickPan: true,
        allowRightClickPan: true,
        activationKeys: [],
        excluded: []
    },
    pinch: {
        step: 5,
        disabled: false,
        excluded: []
    },
    doubleClick: {
        disabled: false,
        step: 0.7,
        mode: "zoomIn",
        animationType: "easeOut",
        animationTime: 200,
        excluded: []
    },
    zoomAnimation: {
        disabled: false,
        size: 0.4,
        animationTime: 200,
        animationType: "easeOut"
    },
    alignmentAnimation: {
        disabled: false,
        sizeX: 100,
        sizeY: 100,
        animationTime: 200,
        velocityAlignmentTime: 400,
        animationType: "easeOut"
    },
    velocityAnimation: {
        disabled: false,
        sensitivity: 1,
        animationTime: 400,
        animationType: "easeOut",
        equalToMove: true
    }
};
var $3704b9b8b7d6768a$var$createState = function createState(props) {
    var _a, _b, _c, _d;
    return {
        previousScale: (_a = props.initialScale) !== null && _a !== void 0 ? _a : $3704b9b8b7d6768a$var$initialState.scale,
        scale: (_b = props.initialScale) !== null && _b !== void 0 ? _b : $3704b9b8b7d6768a$var$initialState.scale,
        positionX: (_c = props.initialPositionX) !== null && _c !== void 0 ? _c : $3704b9b8b7d6768a$var$initialState.positionX,
        positionY: (_d = props.initialPositionY) !== null && _d !== void 0 ? _d : $3704b9b8b7d6768a$var$initialState.positionY
    };
};
var $3704b9b8b7d6768a$var$createSetup = function createSetup(props) {
    var newSetup = $3704b9b8b7d6768a$var$__assign({}, $3704b9b8b7d6768a$var$initialSetup);
    Object.keys(props).forEach(function(key) {
        var validValue = typeof props[key] !== "undefined";
        var validParameter = typeof $3704b9b8b7d6768a$var$initialSetup[key] !== "undefined";
        if (validParameter && validValue) {
            var dataType = Object.prototype.toString.call($3704b9b8b7d6768a$var$initialSetup[key]);
            var isObject = dataType === "[object Object]";
            var isArray = dataType === "[object Array]";
            if (isObject) newSetup[key] = $3704b9b8b7d6768a$var$__assign($3704b9b8b7d6768a$var$__assign({}, $3704b9b8b7d6768a$var$initialSetup[key]), props[key]);
            else if (isArray) newSetup[key] = $3704b9b8b7d6768a$var$__spreadArray($3704b9b8b7d6768a$var$__spreadArray([], $3704b9b8b7d6768a$var$initialSetup[key], true), props[key], true);
            else newSetup[key] = props[key];
        }
    });
    return newSetup;
};
var $3704b9b8b7d6768a$var$handleCalculateButtonZoom = function handleCalculateButtonZoom(contextInstance, delta, step) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, smooth = setup.smooth;
    var size = zoomAnimation.size;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = smooth ? scale * Math.exp(delta * step) : scale + delta * step;
    var newScale = $3704b9b8b7d6768a$var$checkZoomBounds($3704b9b8b7d6768a$var$roundNumber(targetScale, 3), minScale, maxScale, size, false);
    return newScale;
};
function $3704b9b8b7d6768a$var$handleZoomToViewCenter(contextInstance, delta, step, animationTime, animationType) {
    var wrapperComponent = contextInstance.wrapperComponent;
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return console.error("No WrapperComponent found");
    var wrapperWidth = wrapperComponent.offsetWidth;
    var wrapperHeight = wrapperComponent.offsetHeight;
    var mouseX = (wrapperWidth / 2 - positionX) / scale;
    var mouseY = (wrapperHeight / 2 - positionY) / scale;
    var newScale = $3704b9b8b7d6768a$var$handleCalculateButtonZoom(contextInstance, delta, step);
    var targetState = $3704b9b8b7d6768a$var$handleZoomToPoint(contextInstance, newScale, mouseX, mouseY);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
}
function $3704b9b8b7d6768a$var$resetTransformations(contextInstance, animationTime, animationType, onResetTransformation) {
    var setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var limitToBounds = setup.limitToBounds;
    var initialTransformation = $3704b9b8b7d6768a$var$createState(contextInstance.props);
    var _a = contextInstance.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
    if (!wrapperComponent) return;
    var newBounds = $3704b9b8b7d6768a$var$calculateBounds(contextInstance, initialTransformation.scale);
    var boundedPositions = $3704b9b8b7d6768a$var$getMouseBoundedPosition(initialTransformation.positionX, initialTransformation.positionY, newBounds, limitToBounds, 0, 0, wrapperComponent);
    var newState = {
        scale: initialTransformation.scale,
        positionX: boundedPositions.x,
        positionY: boundedPositions.y
    };
    if (scale === initialTransformation.scale && positionX === initialTransformation.positionX && positionY === initialTransformation.positionY) return;
    onResetTransformation === null || onResetTransformation === void 0 || onResetTransformation();
    $3704b9b8b7d6768a$var$animate(contextInstance, newState, animationTime, animationType);
}
function $3704b9b8b7d6768a$var$getOffset(element, wrapper, content, state) {
    var offset = element.getBoundingClientRect();
    var wrapperOffset = wrapper.getBoundingClientRect();
    var contentOffset = content.getBoundingClientRect();
    var xOff = wrapperOffset.x * state.scale;
    var yOff = wrapperOffset.y * state.scale;
    return {
        x: (offset.x - contentOffset.x + xOff) / state.scale,
        y: (offset.y - contentOffset.y + yOff) / state.scale
    };
}
function $3704b9b8b7d6768a$var$calculateZoomToNode(contextInstance, node, customZoom) {
    var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent, transformState = contextInstance.transformState;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, minScale = _a.minScale, maxScale = _a.maxScale;
    if (!wrapperComponent || !contentComponent) return transformState;
    var wrapperRect = wrapperComponent.getBoundingClientRect();
    var nodeRect = node.getBoundingClientRect();
    var nodeOffset = $3704b9b8b7d6768a$var$getOffset(node, wrapperComponent, contentComponent, transformState);
    var nodeLeft = nodeOffset.x;
    var nodeTop = nodeOffset.y;
    var nodeWidth = nodeRect.width / transformState.scale;
    var nodeHeight = nodeRect.height / transformState.scale;
    var scaleX = wrapperComponent.offsetWidth / nodeWidth;
    var scaleY = wrapperComponent.offsetHeight / nodeHeight;
    var newScale = $3704b9b8b7d6768a$var$checkZoomBounds(customZoom || Math.min(scaleX, scaleY), minScale, maxScale, 0, false);
    var offsetX = (wrapperRect.width - nodeWidth * newScale) / 2;
    var offsetY = (wrapperRect.height - nodeHeight * newScale) / 2;
    var newPositionX = (wrapperRect.left - nodeLeft) * newScale + offsetX;
    var newPositionY = (wrapperRect.top - nodeTop) * newScale + offsetY;
    var bounds = $3704b9b8b7d6768a$var$calculateBounds(contextInstance, newScale);
    var _b = $3704b9b8b7d6768a$var$getMouseBoundedPosition(newPositionX, newPositionY, bounds, limitToBounds, 0, 0, wrapperComponent), x = _b.x, y = _b.y;
    return {
        positionX: x,
        positionY: y,
        scale: newScale
    };
}
var $3704b9b8b7d6768a$var$zoomIn = function zoomIn(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $3704b9b8b7d6768a$var$handleZoomToViewCenter(contextInstance, 1, step, animationTime, animationType);
    };
};
var $3704b9b8b7d6768a$var$zoomOut = function zoomOut(contextInstance) {
    return function(step, animationTime, animationType) {
        if (step === void 0) step = 0.5;
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        $3704b9b8b7d6768a$var$handleZoomToViewCenter(contextInstance, -1, step, animationTime, animationType);
    };
};
var $3704b9b8b7d6768a$var$setTransform = function setTransform(contextInstance) {
    return function(newPositionX, newPositionY, newScale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 300;
        if (animationType === void 0) animationType = "easeOut";
        var _a = contextInstance.transformState, positionX = _a.positionX, positionY = _a.positionY, scale = _a.scale;
        var wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        var disabled = contextInstance.setup.disabled;
        if (disabled || !wrapperComponent || !contentComponent) return;
        var targetState = {
            positionX: Number.isNaN(newPositionX) ? positionX : newPositionX,
            positionY: Number.isNaN(newPositionY) ? positionY : newPositionY,
            scale: Number.isNaN(newScale) ? scale : newScale
        };
        $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
    };
};
var $3704b9b8b7d6768a$var$resetTransform = function resetTransform(contextInstance) {
    return function(animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        $3704b9b8b7d6768a$var$resetTransformations(contextInstance, animationTime, animationType);
    };
};
var $3704b9b8b7d6768a$var$centerView = function centerView(contextInstance) {
    return function(scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 200;
        if (animationType === void 0) animationType = "easeOut";
        var transformState = contextInstance.transformState, wrapperComponent = contextInstance.wrapperComponent, contentComponent = contextInstance.contentComponent;
        if (wrapperComponent && contentComponent) {
            var targetState = $3704b9b8b7d6768a$export$a51b33620579dad4(scale || transformState.scale, wrapperComponent, contentComponent);
            $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $3704b9b8b7d6768a$var$zoomToElement = function zoomToElement(contextInstance) {
    return function(node, scale, animationTime, animationType) {
        if (animationTime === void 0) animationTime = 600;
        if (animationType === void 0) animationType = "easeOut";
        $3704b9b8b7d6768a$var$handleCancelAnimation(contextInstance);
        var wrapperComponent = contextInstance.wrapperComponent;
        var target = typeof node === "string" ? document.getElementById(node) : node;
        if (wrapperComponent && target && wrapperComponent.contains(target)) {
            var targetState = $3704b9b8b7d6768a$var$calculateZoomToNode(contextInstance, target, scale);
            $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
        }
    };
};
var $3704b9b8b7d6768a$var$getControls = function getControls(contextInstance) {
    return {
        instance: contextInstance,
        zoomIn: $3704b9b8b7d6768a$var$zoomIn(contextInstance),
        zoomOut: $3704b9b8b7d6768a$var$zoomOut(contextInstance),
        setTransform: $3704b9b8b7d6768a$var$setTransform(contextInstance),
        resetTransform: $3704b9b8b7d6768a$var$resetTransform(contextInstance),
        centerView: $3704b9b8b7d6768a$var$centerView(contextInstance),
        zoomToElement: $3704b9b8b7d6768a$var$zoomToElement(contextInstance)
    };
};
var $3704b9b8b7d6768a$var$getState = function getState(contextInstance) {
    return {
        instance: contextInstance,
        state: contextInstance.transformState
    };
};
var $3704b9b8b7d6768a$var$getContext = function getContext(contextInstance) {
    var ref = {};
    Object.assign(ref, $3704b9b8b7d6768a$var$getState(contextInstance));
    Object.assign(ref, $3704b9b8b7d6768a$var$getControls(contextInstance));
    return ref;
};
// We want to make event listeners non-passive, and to do so have to check
// that browsers support EventListenerOptions in the first place.
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
var $3704b9b8b7d6768a$var$passiveSupported = false;
function $3704b9b8b7d6768a$var$makePassiveEventOption() {
    try {
        var options = {
            get passive () {
                // This function will be called when the browser
                //   attempts to access the passive property.
                $3704b9b8b7d6768a$var$passiveSupported = true;
                return false;
            }
        };
        return options;
    } catch (err) {
        $3704b9b8b7d6768a$var$passiveSupported = false;
        return $3704b9b8b7d6768a$var$passiveSupported;
    }
}
var $3704b9b8b7d6768a$var$isExcludedNode = function isExcludedNode(node, excluded) {
    var targetTagName = node.tagName.toUpperCase();
    var isExcludedTag = excluded.find(function(tag) {
        return tag.toUpperCase() === targetTagName;
    });
    if (isExcludedTag) return true;
    var isExcludedClassName = excluded.find(function(className) {
        return node.classList.contains(className);
    });
    if (isExcludedClassName) return true;
    return false;
};
var $3704b9b8b7d6768a$var$cancelTimeout = function cancelTimeout(timeout) {
    if (timeout) clearTimeout(timeout);
};
var $3704b9b8b7d6768a$export$c15ec262effbd456 = function getTransformStyles(x, y, scale) {
    // Standard translate prevents blurry svg on the safari
    return "translate(".concat(x, "px, ").concat(y, "px) scale(").concat(scale, ")");
};
var $3704b9b8b7d6768a$export$3b94f66093db6f05 = function getMatrixTransformStyles(x, y, scale) {
    // The shorthand for matrix does not work for Safari hence the need to explicitly use matrix3d
    // Refer to https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix
    var a = scale;
    var b = 0;
    var c = 0;
    var d = scale;
    var tx = x;
    var ty = y;
    return "matrix3d(".concat(a, ", ").concat(b, ", 0, 0, ").concat(c, ", ").concat(d, ", 0, 0, 0, 0, 1, 0, ").concat(tx, ", ").concat(ty, ", 0, 1)");
};
var $3704b9b8b7d6768a$export$a51b33620579dad4 = function getCenterPosition(scale, wrapperComponent, contentComponent) {
    var contentWidth = contentComponent.offsetWidth * scale;
    var contentHeight = contentComponent.offsetHeight * scale;
    var centerPositionX = (wrapperComponent.offsetWidth - contentWidth) / 2;
    var centerPositionY = (wrapperComponent.offsetHeight - contentHeight) / 2;
    return {
        scale: scale,
        positionX: centerPositionX,
        positionY: centerPositionY
    };
};
function $3704b9b8b7d6768a$var$mergeRefs(refs) {
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
var $3704b9b8b7d6768a$var$isWheelAllowed = function isWheelAllowed(contextInstance, event) {
    var _a = contextInstance.setup.wheel, disabled = _a.disabled, wheelDisabled = _a.wheelDisabled, touchPadDisabled = _a.touchPadDisabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized, isPanning = contextInstance.isPanning;
    var target = event.target;
    var isAllowed = isInitialized && !isPanning && !disabled && target;
    if (!isAllowed) return false;
    // Event ctrlKey detects if touchpad action is executing wheel or pinch gesture
    if (wheelDisabled && !event.ctrlKey) return false;
    if (touchPadDisabled && event.ctrlKey) return false;
    var isExcluded = $3704b9b8b7d6768a$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $3704b9b8b7d6768a$var$getDeltaY = function getDeltaY(event) {
    if (event) return event.deltaY < 0 ? 1 : -1;
    return 0;
};
function $3704b9b8b7d6768a$var$getDelta(event, customDelta) {
    var deltaY = $3704b9b8b7d6768a$var$getDeltaY(event);
    var delta = $3704b9b8b7d6768a$var$checkIsNumber(customDelta, deltaY);
    return delta;
}
function $3704b9b8b7d6768a$var$getMousePosition(event, contentComponent, scale) {
    var contentRect = contentComponent.getBoundingClientRect();
    var mouseX = 0;
    var mouseY = 0;
    if ("clientX" in event) {
        // mouse position x, y over wrapper component
        mouseX = (event.clientX - contentRect.left) / scale;
        mouseY = (event.clientY - contentRect.top) / scale;
    } else {
        var touch = event.touches[0];
        mouseX = (touch.clientX - contentRect.left) / scale;
        mouseY = (touch.clientY - contentRect.top) / scale;
    }
    if (Number.isNaN(mouseX) || Number.isNaN(mouseY)) console.error("No mouse or touch offset found");
    return {
        x: mouseX,
        y: mouseY
    };
}
var $3704b9b8b7d6768a$var$handleCalculateWheelZoom = function handleCalculateWheelZoom(contextInstance, delta, step, disable, getTarget) {
    var scale = contextInstance.transformState.scale;
    var wrapperComponent = contextInstance.wrapperComponent, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!wrapperComponent) throw new Error("Wrapper is not mounted");
    var targetScale = scale + delta * step;
    if (getTarget) return targetScale;
    var paddingEnabled = disable ? false : !disabled;
    var newScale = $3704b9b8b7d6768a$var$checkZoomBounds($3704b9b8b7d6768a$var$roundNumber(targetScale, 3), minScale, maxScale, size, paddingEnabled && !disablePadding);
    return newScale;
};
var $3704b9b8b7d6768a$var$handleWheelZoomStop = function handleWheelZoomStop(contextInstance, event) {
    var previousWheelEvent = contextInstance.previousWheelEvent;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, maxScale = _a.maxScale, minScale = _a.minScale;
    if (!previousWheelEvent) return false;
    if (scale < maxScale || scale > minScale) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    if (previousWheelEvent.deltaY > 0 && previousWheelEvent.deltaY < event.deltaY) return true;
    if (previousWheelEvent.deltaY < 0 && previousWheelEvent.deltaY > event.deltaY) return true;
    if (Math.sign(previousWheelEvent.deltaY) !== Math.sign(event.deltaY)) return true;
    return false;
};
var $3704b9b8b7d6768a$var$isPinchStartAllowed = function isPinchStartAllowed(contextInstance, event) {
    var _a = contextInstance.setup.pinch, disabled = _a.disabled, excluded = _a.excluded;
    var isInitialized = contextInstance.isInitialized;
    var target = event.target;
    var isAllowed = isInitialized && !disabled && target;
    if (!isAllowed) return false;
    var isExcluded = $3704b9b8b7d6768a$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $3704b9b8b7d6768a$var$isPinchAllowed = function isPinchAllowed(contextInstance) {
    var disabled = contextInstance.setup.pinch.disabled;
    var isInitialized = contextInstance.isInitialized, pinchStartDistance = contextInstance.pinchStartDistance;
    var isAllowed = isInitialized && !disabled && pinchStartDistance;
    if (!isAllowed) return false;
    return true;
};
var $3704b9b8b7d6768a$var$calculateTouchMidPoint = function calculateTouchMidPoint(event, scale, contentComponent) {
    var contentRect = contentComponent.getBoundingClientRect();
    var touches = event.touches;
    var firstPointX = $3704b9b8b7d6768a$var$roundNumber(touches[0].clientX - contentRect.left, 5);
    var firstPointY = $3704b9b8b7d6768a$var$roundNumber(touches[0].clientY - contentRect.top, 5);
    var secondPointX = $3704b9b8b7d6768a$var$roundNumber(touches[1].clientX - contentRect.left, 5);
    var secondPointY = $3704b9b8b7d6768a$var$roundNumber(touches[1].clientY - contentRect.top, 5);
    return {
        x: (firstPointX + secondPointX) / 2 / scale,
        y: (firstPointY + secondPointY) / 2 / scale
    };
};
var $3704b9b8b7d6768a$var$getTouchDistance = function getTouchDistance(event) {
    return Math.sqrt(Math.pow(event.touches[0].pageX - event.touches[1].pageX, 2) + Math.pow(event.touches[0].pageY - event.touches[1].pageY, 2));
};
var $3704b9b8b7d6768a$var$calculatePinchZoom = function calculatePinchZoom(contextInstance, currentDistance) {
    var pinchStartScale = contextInstance.pinchStartScale, pinchStartDistance = contextInstance.pinchStartDistance, setup = contextInstance.setup;
    var maxScale = setup.maxScale, minScale = setup.minScale, zoomAnimation = setup.zoomAnimation, disablePadding = setup.disablePadding;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    if (!pinchStartScale || pinchStartDistance === null || !currentDistance) throw new Error("Pinch touches distance was not provided");
    if (currentDistance < 0) return contextInstance.transformState.scale;
    var touchProportion = currentDistance / pinchStartDistance;
    var scaleDifference = touchProportion * pinchStartScale;
    return $3704b9b8b7d6768a$var$checkZoomBounds($3704b9b8b7d6768a$var$roundNumber(scaleDifference, 2), minScale, maxScale, size, !disabled && !disablePadding);
};
var $3704b9b8b7d6768a$var$wheelStopEventTime = 160;
var $3704b9b8b7d6768a$var$wheelAnimationTime = 100;
var $3704b9b8b7d6768a$var$handleWheelStart = function handleWheelStart(contextInstance, event) {
    var _a = contextInstance.props, onWheelStart = _a.onWheelStart, onZoomStart = _a.onZoomStart;
    if (!contextInstance.wheelStopEventTimer) {
        $3704b9b8b7d6768a$var$handleCancelAnimation(contextInstance);
        $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onWheelStart);
        $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoomStart);
    }
};
var $3704b9b8b7d6768a$var$handleWheelZoom = function handleWheelZoom(contextInstance, event) {
    var _a = contextInstance.props, onWheel = _a.onWheel, onZoom = _a.onZoom;
    var contentComponent = contextInstance.contentComponent, setup = contextInstance.setup, transformState = contextInstance.transformState;
    var scale = transformState.scale;
    var limitToBounds = setup.limitToBounds, centerZoomedOut = setup.centerZoomedOut, zoomAnimation = setup.zoomAnimation, wheel = setup.wheel, disablePadding = setup.disablePadding, smooth = setup.smooth;
    var size = zoomAnimation.size, disabled = zoomAnimation.disabled;
    var step = wheel.step, smoothStep = wheel.smoothStep;
    if (!contentComponent) throw new Error("Component not mounted");
    event.preventDefault();
    event.stopPropagation();
    var delta = $3704b9b8b7d6768a$var$getDelta(event, null);
    var zoomStep = smooth ? smoothStep * Math.abs(event.deltaY) : step;
    var newScale = $3704b9b8b7d6768a$var$handleCalculateWheelZoom(contextInstance, delta, zoomStep, !event.ctrlKey);
    // if scale not change
    if (scale === newScale) return;
    var bounds = $3704b9b8b7d6768a$var$handleCalculateBounds(contextInstance, newScale);
    var mousePosition = $3704b9b8b7d6768a$var$getMousePosition(event, contentComponent, scale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut || disablePadding;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $3704b9b8b7d6768a$var$handleCalculateZoomPositions(contextInstance, mousePosition.x, mousePosition.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.previousWheelEvent = event;
    contextInstance.setTransformState(newScale, x, y);
    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onWheel);
    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoom);
};
var $3704b9b8b7d6768a$var$handleWheelStop = function handleWheelStop(contextInstance, event) {
    var _a = contextInstance.props, onWheelStop = _a.onWheelStop, onZoomStop = _a.onZoomStop;
    // fire animation
    $3704b9b8b7d6768a$var$cancelTimeout(contextInstance.wheelAnimationTimer);
    contextInstance.wheelAnimationTimer = setTimeout(function() {
        if (!contextInstance.mounted) return;
        $3704b9b8b7d6768a$var$handleAlignToScaleBounds(contextInstance, event.x, event.y);
        contextInstance.wheelAnimationTimer = null;
    }, $3704b9b8b7d6768a$var$wheelAnimationTime);
    // Wheel stop event
    var hasStoppedZooming = $3704b9b8b7d6768a$var$handleWheelZoomStop(contextInstance, event);
    if (hasStoppedZooming) {
        $3704b9b8b7d6768a$var$cancelTimeout(contextInstance.wheelStopEventTimer);
        contextInstance.wheelStopEventTimer = setTimeout(function() {
            if (!contextInstance.mounted) return;
            contextInstance.wheelStopEventTimer = null;
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onWheelStop);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoomStop);
        }, $3704b9b8b7d6768a$var$wheelStopEventTime);
    }
};
var $3704b9b8b7d6768a$var$handlePinchStart = function handlePinchStart(contextInstance, event) {
    var distance = $3704b9b8b7d6768a$var$getTouchDistance(event);
    contextInstance.pinchStartDistance = distance;
    contextInstance.lastDistance = distance;
    contextInstance.pinchStartScale = contextInstance.transformState.scale;
    contextInstance.isPanning = false;
    $3704b9b8b7d6768a$var$handleCancelAnimation(contextInstance);
};
var $3704b9b8b7d6768a$var$handlePinchZoom = function handlePinchZoom(contextInstance, event) {
    var contentComponent = contextInstance.contentComponent, pinchStartDistance = contextInstance.pinchStartDistance;
    var scale = contextInstance.transformState.scale;
    var _a = contextInstance.setup, limitToBounds = _a.limitToBounds, centerZoomedOut = _a.centerZoomedOut, zoomAnimation = _a.zoomAnimation;
    var disabled = zoomAnimation.disabled, size = zoomAnimation.size;
    // if one finger starts from outside of wrapper
    if (pinchStartDistance === null || !contentComponent) return;
    var midPoint = $3704b9b8b7d6768a$var$calculateTouchMidPoint(event, scale, contentComponent);
    // if touches goes off of the wrapper element
    if (!Number.isFinite(midPoint.x) || !Number.isFinite(midPoint.y)) return;
    var currentDistance = $3704b9b8b7d6768a$var$getTouchDistance(event);
    var newScale = $3704b9b8b7d6768a$var$calculatePinchZoom(contextInstance, currentDistance);
    if (newScale === scale) return;
    var bounds = $3704b9b8b7d6768a$var$handleCalculateBounds(contextInstance, newScale);
    var isPaddingDisabled = disabled || size === 0 || centerZoomedOut;
    var isLimitedToBounds = limitToBounds && isPaddingDisabled;
    var _b = $3704b9b8b7d6768a$var$handleCalculateZoomPositions(contextInstance, midPoint.x, midPoint.y, newScale, bounds, isLimitedToBounds), x = _b.x, y = _b.y;
    contextInstance.pinchMidpoint = midPoint;
    contextInstance.lastDistance = currentDistance;
    contextInstance.setTransformState(newScale, x, y);
};
var $3704b9b8b7d6768a$var$handlePinchStop = function handlePinchStop(contextInstance) {
    var pinchMidpoint = contextInstance.pinchMidpoint;
    contextInstance.velocity = null;
    contextInstance.lastDistance = null;
    contextInstance.pinchMidpoint = null;
    contextInstance.pinchStartScale = null;
    contextInstance.pinchStartDistance = null;
    $3704b9b8b7d6768a$var$handleAlignToScaleBounds(contextInstance, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.x, pinchMidpoint === null || pinchMidpoint === void 0 ? void 0 : pinchMidpoint.y);
};
var $3704b9b8b7d6768a$var$handleDoubleClickStop = function handleDoubleClickStop(contextInstance, event) {
    var onZoomStop = contextInstance.props.onZoomStop;
    var animationTime = contextInstance.setup.doubleClick.animationTime;
    $3704b9b8b7d6768a$var$cancelTimeout(contextInstance.doubleClickStopEventTimer);
    contextInstance.doubleClickStopEventTimer = setTimeout(function() {
        contextInstance.doubleClickStopEventTimer = null;
        $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoomStop);
    }, animationTime);
};
var $3704b9b8b7d6768a$var$handleDoubleClickResetMode = function handleDoubleClickResetMode(contextInstance, event) {
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = contextInstance.setup.doubleClick, animationTime = _b.animationTime, animationType = _b.animationType;
    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoomStart);
    $3704b9b8b7d6768a$var$resetTransformations(contextInstance, animationTime, animationType, function() {
        return $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoom);
    });
    $3704b9b8b7d6768a$var$handleDoubleClickStop(contextInstance, event);
};
function $3704b9b8b7d6768a$var$handleDoubleClick(contextInstance, event) {
    var setup = contextInstance.setup, doubleClickStopEventTimer = contextInstance.doubleClickStopEventTimer, transformState = contextInstance.transformState, contentComponent = contextInstance.contentComponent;
    var scale = transformState.scale;
    var _a = contextInstance.props, onZoomStart = _a.onZoomStart, onZoom = _a.onZoom;
    var _b = setup.doubleClick, disabled = _b.disabled, mode = _b.mode, step = _b.step, animationTime = _b.animationTime, animationType = _b.animationType;
    if (disabled) return;
    if (doubleClickStopEventTimer) return;
    if (mode === "reset") return $3704b9b8b7d6768a$var$handleDoubleClickResetMode(contextInstance, event);
    if (!contentComponent) return console.error("No ContentComponent found");
    var delta = mode === "zoomOut" ? -1 : 1;
    var newScale = $3704b9b8b7d6768a$var$handleCalculateButtonZoom(contextInstance, delta, step);
    // stop execution when scale didn't change
    if (scale === newScale) return;
    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoomStart);
    var mousePosition = $3704b9b8b7d6768a$var$getMousePosition(event, contentComponent, scale);
    var targetState = $3704b9b8b7d6768a$var$handleZoomToPoint(contextInstance, newScale, mousePosition.x, mousePosition.y);
    if (!targetState) return console.error("Error during zoom event. New transformation state was not calculated.");
    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(contextInstance), event, onZoom);
    $3704b9b8b7d6768a$var$animate(contextInstance, targetState, animationTime, animationType);
    $3704b9b8b7d6768a$var$handleDoubleClickStop(contextInstance, event);
}
var $3704b9b8b7d6768a$var$isDoubleClickAllowed = function isDoubleClickAllowed(contextInstance, event) {
    var isInitialized = contextInstance.isInitialized, setup = contextInstance.setup, wrapperComponent = contextInstance.wrapperComponent;
    var _a = setup.doubleClick, disabled = _a.disabled, excluded = _a.excluded;
    var target = event.target;
    var isWrapperChild = wrapperComponent === null || wrapperComponent === void 0 ? void 0 : wrapperComponent.contains(target);
    var isAllowed = isInitialized && target && isWrapperChild && !disabled;
    if (!isAllowed) return false;
    var isExcluded = $3704b9b8b7d6768a$var$isExcludedNode(target, excluded);
    if (isExcluded) return false;
    return true;
};
var $3704b9b8b7d6768a$var$ZoomPanPinch = /** @class */ function() {
    function ZoomPanPinch(props) {
        var _this = this;
        this.mounted = true;
        this.onChangeCallbacks = new Set();
        this.onInitCallbacks = new Set();
        // Components
        this.wrapperComponent = null;
        this.contentComponent = null;
        // Initialization
        this.isInitialized = false;
        this.bounds = null;
        // wheel helpers
        this.previousWheelEvent = null;
        this.wheelStopEventTimer = null;
        this.wheelAnimationTimer = null;
        // panning helpers
        this.isPanning = false;
        this.startCoords = null;
        this.lastTouch = null;
        // pinch helpers
        this.distance = null;
        this.lastDistance = null;
        this.pinchStartDistance = null;
        this.pinchStartScale = null;
        this.pinchMidpoint = null;
        // double click helpers
        this.doubleClickStopEventTimer = null;
        // velocity helpers
        this.velocity = null;
        this.velocityTime = null;
        this.lastMousePosition = null;
        // animations helpers
        this.animate = false;
        this.animation = null;
        this.maxBounds = null;
        // key press
        this.pressedKeys = {};
        this.mount = function() {
            _this.initializeWindowEvents();
        };
        this.unmount = function() {
            _this.cleanupWindowEvents();
        };
        this.update = function(newProps) {
            $3704b9b8b7d6768a$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.setup = $3704b9b8b7d6768a$var$createSetup(newProps);
        };
        this.initializeWindowEvents = function() {
            var _a;
            var passive = $3704b9b8b7d6768a$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            // Panning on window to allow panning when mouse is out of component wrapper
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.addEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.addEventListener("keydown", _this.setKeyPressed, passive);
        };
        this.cleanupWindowEvents = function() {
            var _a, _b;
            var passive = $3704b9b8b7d6768a$var$makePassiveEventOption();
            var currentDocument = (_a = _this.wrapperComponent) === null || _a === void 0 ? void 0 : _a.ownerDocument;
            var currentWindow = currentDocument === null || currentDocument === void 0 ? void 0 : currentDocument.defaultView;
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousedown", _this.onPanningStart, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mousemove", _this.onPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("mouseup", _this.onPanningStop, passive);
            currentDocument === null || currentDocument === void 0 || currentDocument.removeEventListener("mouseleave", _this.clearPanning, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keyup", _this.setKeyUnPressed, passive);
            currentWindow === null || currentWindow === void 0 || currentWindow.removeEventListener("keydown", _this.setKeyPressed, passive);
            document.removeEventListener("mouseleave", _this.clearPanning, passive);
            $3704b9b8b7d6768a$var$handleCancelAnimation(_this);
            (_b = _this.observer) === null || _b === void 0 || _b.disconnect();
        };
        this.handleInitializeWrapperEvents = function(wrapper) {
            // Zooming events on wrapper
            var passive = $3704b9b8b7d6768a$var$makePassiveEventOption();
            wrapper.addEventListener("wheel", _this.onWheelZoom, passive);
            wrapper.addEventListener("dblclick", _this.onDoubleClick, passive);
            wrapper.addEventListener("touchstart", _this.onTouchPanningStart, passive);
            wrapper.addEventListener("touchmove", _this.onTouchPanning, passive);
            wrapper.addEventListener("touchend", _this.onTouchPanningStop, passive);
        };
        this.handleInitialize = function(contentComponent) {
            var centerOnInit = _this.setup.centerOnInit;
            _this.applyTransformation();
            _this.onInitCallbacks.forEach(function(callback) {
                return callback($3704b9b8b7d6768a$var$getContext(_this));
            });
            if (centerOnInit) {
                _this.setCenter();
                _this.observer = new ResizeObserver(function() {
                    var _a;
                    _this.onInitCallbacks.forEach(function(callback) {
                        return callback($3704b9b8b7d6768a$var$getContext(_this));
                    });
                    _this.setCenter();
                    (_a = _this.observer) === null || _a === void 0 || _a.disconnect();
                });
                // Start observing the target node for configured mutations
                _this.observer.observe(contentComponent);
            }
        };
        /// ///////
        // Zoom
        /// ///////
        this.onWheelZoom = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isWheelAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.wheel.activationKeys);
            if (!keysPressed) return;
            $3704b9b8b7d6768a$var$handleWheelStart(_this, event);
            $3704b9b8b7d6768a$var$handleWheelZoom(_this, event);
            $3704b9b8b7d6768a$var$handleWheelStop(_this, event);
        };
        /// ///////
        // Pan
        /// ///////
        this.onPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            if (event.button === 0 && !_this.setup.panning.allowLeftClickPan) return;
            if (event.button === 1 && !_this.setup.panning.allowMiddleClickPan) return;
            if (event.button === 2 && !_this.setup.panning.allowRightClickPan) return;
            event.preventDefault();
            event.stopPropagation();
            $3704b9b8b7d6768a$var$handleCancelAnimation(_this);
            $3704b9b8b7d6768a$var$handlePanningStart(_this, event);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPanningStart);
        };
        this.onPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isPanningAllowed(_this);
            if (!isAllowed) return;
            var keysPressed = _this.isPressingKeys(_this.setup.panning.activationKeys);
            if (!keysPressed) return;
            event.preventDefault();
            event.stopPropagation();
            $3704b9b8b7d6768a$var$handlePanning(_this, event.clientX, event.clientY);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPanning);
        };
        this.onPanningStop = function(event) {
            var onPanningStop = _this.props.onPanningStop;
            if (_this.isPanning) {
                $3704b9b8b7d6768a$var$handlePanningEnd(_this);
                $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPanningStop);
            }
        };
        /// ///////
        // Pinch
        /// ///////
        this.onPinchStart = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinchingStart = _a.onPinchingStart, onZoomStart = _a.onZoomStart;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isPinchStartAllowed(_this, event);
            if (!isAllowed) return;
            $3704b9b8b7d6768a$var$handlePinchStart(_this, event);
            $3704b9b8b7d6768a$var$handleCancelAnimation(_this);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPinchingStart);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onZoomStart);
        };
        this.onPinch = function(event) {
            var disabled = _this.setup.disabled;
            var _a = _this.props, onPinching = _a.onPinching, onZoom = _a.onZoom;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isPinchAllowed(_this);
            if (!isAllowed) return;
            event.preventDefault();
            event.stopPropagation();
            $3704b9b8b7d6768a$var$handlePinchZoom(_this, event);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPinching);
            $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onZoom);
        };
        this.onPinchStop = function(event) {
            var _a = _this.props, onPinchingStop = _a.onPinchingStop, onZoomStop = _a.onZoomStop;
            if (_this.pinchStartScale) {
                $3704b9b8b7d6768a$var$handlePinchStop(_this);
                $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPinchingStop);
                $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onZoomStop);
            }
        };
        /// ///////
        // Touch
        /// ///////
        this.onTouchPanningStart = function(event) {
            var disabled = _this.setup.disabled;
            var onPanningStart = _this.props.onPanningStart;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isPanningStartAllowed(_this, event);
            if (!isAllowed) return;
            var isDoubleTap = _this.lastTouch && +new Date() - _this.lastTouch < 200;
            if (isDoubleTap && event.touches.length === 1) _this.onDoubleClick(event);
            else {
                _this.lastTouch = +new Date();
                $3704b9b8b7d6768a$var$handleCancelAnimation(_this);
                var touches = event.touches;
                var isPanningAction = touches.length === 1;
                var isPinchAction = touches.length === 2;
                if (isPanningAction) {
                    $3704b9b8b7d6768a$var$handleCancelAnimation(_this);
                    $3704b9b8b7d6768a$var$handlePanningStart(_this, event);
                    $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPanningStart);
                }
                if (isPinchAction) _this.onPinchStart(event);
            }
        };
        this.onTouchPanning = function(event) {
            var disabled = _this.setup.disabled;
            var onPanning = _this.props.onPanning;
            if (_this.isPanning && event.touches.length === 1) {
                if (disabled) return;
                var isAllowed = $3704b9b8b7d6768a$var$isPanningAllowed(_this);
                if (!isAllowed) return;
                event.preventDefault();
                event.stopPropagation();
                var touch = event.touches[0];
                $3704b9b8b7d6768a$var$handlePanning(_this, touch.clientX, touch.clientY);
                $3704b9b8b7d6768a$var$handleCallback($3704b9b8b7d6768a$var$getContext(_this), event, onPanning);
            } else if (event.touches.length > 1) _this.onPinch(event);
        };
        this.onTouchPanningStop = function(event) {
            _this.onPanningStop(event);
            _this.onPinchStop(event);
        };
        /// ///////
        // Double Click
        /// ///////
        this.onDoubleClick = function(event) {
            var disabled = _this.setup.disabled;
            if (disabled) return;
            var isAllowed = $3704b9b8b7d6768a$var$isDoubleClickAllowed(_this, event);
            if (!isAllowed) return;
            $3704b9b8b7d6768a$var$handleDoubleClick(_this, event);
        };
        /// ///////
        // Helpers
        /// ///////
        this.clearPanning = function(event) {
            if (_this.isPanning) _this.onPanningStop(event);
        };
        this.setKeyPressed = function(e) {
            _this.pressedKeys[e.key] = true;
        };
        this.setKeyUnPressed = function(e) {
            _this.pressedKeys[e.key] = false;
        };
        this.isPressingKeys = function(keys) {
            if (!keys.length) return true;
            return Boolean(keys.find(function(key) {
                return _this.pressedKeys[key];
            }));
        };
        this.setTransformState = function(scale, positionX, positionY) {
            var onTransformed = _this.props.onTransformed;
            if (!Number.isNaN(scale) && !Number.isNaN(positionX) && !Number.isNaN(positionY)) {
                if (scale !== _this.transformState.scale) {
                    _this.transformState.previousScale = _this.transformState.scale;
                    _this.transformState.scale = scale;
                }
                _this.transformState.positionX = positionX;
                _this.transformState.positionY = positionY;
                _this.applyTransformation();
                var ctx_1 = $3704b9b8b7d6768a$var$getContext(_this);
                _this.onChangeCallbacks.forEach(function(callback) {
                    return callback(ctx_1);
                });
                $3704b9b8b7d6768a$var$handleCallback(ctx_1, {
                    scale: scale,
                    positionX: positionX,
                    positionY: positionY
                }, onTransformed);
            } else console.error("Detected NaN set state values");
        };
        this.setCenter = function() {
            if (_this.wrapperComponent && _this.contentComponent) {
                var targetState = $3704b9b8b7d6768a$export$a51b33620579dad4(_this.transformState.scale, _this.wrapperComponent, _this.contentComponent);
                _this.setTransformState(targetState.scale, targetState.positionX, targetState.positionY);
            }
        };
        this.handleTransformStyles = function(x, y, scale) {
            if (_this.props.customTransform) return _this.props.customTransform(x, y, scale);
            return $3704b9b8b7d6768a$export$c15ec262effbd456(x, y, scale);
        };
        this.applyTransformation = function() {
            if (!_this.mounted || !_this.contentComponent) return;
            var _a = _this.transformState, scale = _a.scale, positionX = _a.positionX, positionY = _a.positionY;
            var transform = _this.handleTransformStyles(positionX, positionY, scale);
            _this.contentComponent.style.transform = transform;
        };
        this.getContext = function() {
            return $3704b9b8b7d6768a$var$getContext(_this);
        };
        /**
         * Hooks
         */ this.onChange = function(callback) {
            if (!_this.onChangeCallbacks.has(callback)) _this.onChangeCallbacks.add(callback);
            return function() {
                _this.onChangeCallbacks.delete(callback);
            };
        };
        this.onInit = function(callback) {
            if (!_this.onInitCallbacks.has(callback)) _this.onInitCallbacks.add(callback);
            return function() {
                _this.onInitCallbacks.delete(callback);
            };
        };
        /**
         * Initialization
         */ this.init = function(wrapperComponent, contentComponent) {
            _this.cleanupWindowEvents();
            _this.wrapperComponent = wrapperComponent;
            _this.contentComponent = contentComponent;
            $3704b9b8b7d6768a$var$handleCalculateBounds(_this, _this.transformState.scale);
            _this.handleInitializeWrapperEvents(wrapperComponent);
            _this.handleInitialize(contentComponent);
            _this.initializeWindowEvents();
            _this.isInitialized = true;
            var ctx = $3704b9b8b7d6768a$var$getContext(_this);
            $3704b9b8b7d6768a$var$handleCallback(ctx, undefined, _this.props.onInit);
        };
        this.props = props;
        this.setup = $3704b9b8b7d6768a$var$createSetup(this.props);
        this.transformState = $3704b9b8b7d6768a$var$createState(this.props);
    }
    return ZoomPanPinch;
}();
var $3704b9b8b7d6768a$export$841858b892ce1f4c = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createContext(null);
var $3704b9b8b7d6768a$var$getContent = function getContent(children, ctx) {
    if (typeof children === "function") return children(ctx);
    return children;
};
var $3704b9b8b7d6768a$export$51cb649375dcd655 = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).forwardRef(function(props, ref) {
    var instance = (0, $g85JO.useRef)(new $3704b9b8b7d6768a$var$ZoomPanPinch(props)).current;
    var content = $3704b9b8b7d6768a$var$getContent(props.children, $3704b9b8b7d6768a$var$getControls(instance));
    (0, $g85JO.useImperativeHandle)(ref, function() {
        return $3704b9b8b7d6768a$var$getControls(instance);
    }, [
        instance
    ]);
    (0, $g85JO.useEffect)(function() {
        instance.update(props);
    }, [
        instance,
        props
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement($3704b9b8b7d6768a$export$841858b892ce1f4c.Provider, {
        value: instance
    }, content);
});
var $3704b9b8b7d6768a$export$cbc53e226f857b23 = (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).forwardRef(function(props, ref) {
    var localRef = (0, $g85JO.useRef)(null);
    var instance = (0, $g85JO.useContext)($3704b9b8b7d6768a$export$841858b892ce1f4c);
    (0, $g85JO.useEffect)(function() {
        return instance.onChange(function(ctx) {
            if (localRef.current) {
                var positionX = 0;
                var positionY = 0;
                localRef.current.style.transform = instance.handleTransformStyles(positionX, positionY, 1 / ctx.instance.transformState.scale);
            }
        });
    }, [
        instance
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", $3704b9b8b7d6768a$var$__assign({}, props, {
        ref: $3704b9b8b7d6768a$var$mergeRefs([
            localRef,
            ref
        ])
    }));
});
var $3704b9b8b7d6768a$var$initialElementRect = {
    width: 0,
    height: 0,
    y: 0,
    x: 0,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
};
var $3704b9b8b7d6768a$var$useResize = function useResize(ref, onResize, dependencies) {
    var resizeObserverRef = (0, $g85JO.useRef)();
    var rectRef = (0, $g85JO.useRef)($3704b9b8b7d6768a$var$initialElementRect);
    var didUnmount = (0, $g85JO.useRef)(false);
    (0, $g85JO.useLayoutEffect)(function() {
        var _a;
        didUnmount.current = false;
        if (ref) {
            resizeObserverRef.current = new ResizeObserver(function(entries) {
                var newSize = ref.getBoundingClientRect();
                if (!Array.isArray(entries) || !entries.length || didUnmount.current || newSize.width === rectRef.current.width && newSize.height === rectRef.current.height) return;
                onResize(newSize, ref);
                rectRef.current = newSize;
            });
            (_a = resizeObserverRef.current) === null || _a === void 0 || _a.observe(ref);
        }
        return function() {
            var _a;
            didUnmount.current = true;
            if (ref) (_a = resizeObserverRef.current) === null || _a === void 0 || _a.unobserve(ref);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $3704b9b8b7d6768a$var$__spreadArray([
        onResize,
        ref
    ], dependencies, true));
};
var $3704b9b8b7d6768a$var$previewStyles = {
    position: "absolute",
    zIndex: 2,
    top: "0px",
    left: "0px",
    boxSizing: "border-box",
    border: "3px solid red",
    transformOrigin: "0% 0%",
    boxShadow: "rgba(0,0,0,0.2) 0 0 0 10000000px"
};
var $3704b9b8b7d6768a$export$a97dd8f3835953ef = function MiniMap(_a) {
    var _b = _a.width, width = _b === void 0 ? 200 : _b, _c = _a.height, height = _c === void 0 ? 200 : _c, _d = _a.borderColor, borderColor = _d === void 0 ? "red" : _d, children = _a.children, rest = $3704b9b8b7d6768a$var$__rest(_a, [
        "width",
        "height",
        "borderColor",
        "children"
    ]);
    var _e = (0, $g85JO.useState)(false), initialized = _e[0], setInitialized = _e[1];
    var instance = $3704b9b8b7d6768a$export$1708b11af87412f8();
    var miniMapInstance = (0, $g85JO.useRef)(null);
    var mainRef = (0, $g85JO.useRef)(null);
    var wrapperRef = (0, $g85JO.useRef)(null);
    var previewRef = (0, $g85JO.useRef)(null);
    var getContentSize = (0, $g85JO.useCallback)(function() {
        if (instance.contentComponent) {
            var rect = instance.contentComponent.getBoundingClientRect();
            return {
                width: rect.width / instance.transformState.scale,
                height: rect.height / instance.transformState.scale
            };
        }
        return {
            width: 0,
            height: 0
        };
    }, [
        instance.contentComponent,
        instance.transformState.scale
    ]);
    var computeMiniMapScale = (0, $g85JO.useCallback)(function() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        var scale = scaleY > scaleX ? scaleX : scaleY;
        return scale;
    }, [
        getContentSize,
        height,
        width
    ]);
    var computeMiniMapSize = function computeMiniMapSize() {
        var contentSize = getContentSize();
        var scaleX = width / contentSize.width;
        var scaleY = height / contentSize.height;
        if (scaleY > scaleX) return {
            width: width,
            height: contentSize.height * scaleX
        };
        return {
            width: contentSize.width * scaleY,
            height: height
        };
    };
    var computeMiniMapStyle = function computeMiniMapStyle() {
        var scale = computeMiniMapScale();
        var style = {
            transform: "scale(".concat(scale || 1, ")"),
            transformOrigin: "0% 0%",
            position: "absolute",
            boxSizing: "border-box",
            zIndex: 1,
            overflow: "hidden"
        };
        Object.keys(style).forEach(function(key) {
            if (wrapperRef.current) wrapperRef.current.style[key] = style[key];
        });
    };
    var transformMiniMap = function transformMiniMap() {
        computeMiniMapStyle();
        var miniSize = computeMiniMapSize();
        var wrapSize = getContentSize();
        if (wrapperRef.current) {
            wrapperRef.current.style.width = "".concat(wrapSize.width, "px");
            wrapperRef.current.style.height = "".concat(wrapSize.height, "px");
        }
        if (mainRef.current) {
            mainRef.current.style.width = "".concat(miniSize.width, "px");
            mainRef.current.style.height = "".concat(miniSize.height, "px");
        }
        if (previewRef.current) {
            var size = getContentSize();
            var scale = computeMiniMapScale();
            var previewScale = scale * (1 / instance.transformState.scale);
            var transform = instance.handleTransformStyles(-instance.transformState.positionX * previewScale, -instance.transformState.positionY * previewScale, 1);
            previewRef.current.style.transform = transform;
            previewRef.current.style.width = "".concat(size.width * previewScale, "px");
            previewRef.current.style.height = "".concat(size.height * previewScale, "px");
        }
    };
    var initialize = function initialize() {
        transformMiniMap();
    };
    $3704b9b8b7d6768a$export$769cca75086a299c(function() {
        transformMiniMap();
    });
    $3704b9b8b7d6768a$export$e14839139473133b(function() {
        initialize();
        setInitialized(true);
    });
    $3704b9b8b7d6768a$var$useResize(instance.contentComponent, initialize, [
        initialized
    ]);
    (0, $g85JO.useEffect)(function() {
        return instance.onChange(function(zpp) {
            var scale = computeMiniMapScale();
            if (miniMapInstance.current) {
                miniMapInstance.current.instance.transformState.scale = zpp.instance.transformState.scale;
                miniMapInstance.current.instance.transformState.positionX = zpp.instance.transformState.positionX * scale;
                miniMapInstance.current.instance.transformState.positionY = zpp.instance.transformState.positionY * scale;
            }
        });
    }, [
        computeMiniMapScale,
        instance,
        miniMapInstance
    ]);
    var wrapperStyle = (0, $g85JO.useMemo)(function() {
        return {
            position: "relative",
            zIndex: 2,
            overflow: "hidden"
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", $3704b9b8b7d6768a$var$__assign({}, rest, {
        ref: mainRef,
        style: wrapperStyle,
        className: "rzpp-mini-map ".concat(rest.className || "")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", $3704b9b8b7d6768a$var$__assign({}, rest, {
        ref: wrapperRef,
        className: "rzpp-wrapper"
    }), children), (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", {
        className: "rzpp-preview",
        ref: previewRef,
        style: $3704b9b8b7d6768a$var$__assign($3704b9b8b7d6768a$var$__assign({}, $3704b9b8b7d6768a$var$previewStyles), {
            borderColor: borderColor
        })
    }));
};
function $3704b9b8b7d6768a$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $3704b9b8b7d6768a$var$css_248z = ".transform-component-module_wrapper__SPB86 {\n  position: relative;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  overflow: hidden;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n  margin: 0;\n  padding: 0;\n}\n.transform-component-module_content__FBWxo {\n  display: flex;\n  flex-wrap: wrap;\n  width: -moz-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  margin: 0;\n  padding: 0;\n  transform-origin: 0% 0%;\n}\n.transform-component-module_content__FBWxo img {\n  pointer-events: none;\n}\n";
var $3704b9b8b7d6768a$var$styles = {
    "wrapper": "transform-component-module_wrapper__SPB86",
    "content": "transform-component-module_content__FBWxo"
};
$3704b9b8b7d6768a$var$styleInject($3704b9b8b7d6768a$var$css_248z);
var $3704b9b8b7d6768a$export$1def2aa75b7c7fe0 = function TransformComponent(_a) {
    var children = _a.children, _b = _a.wrapperClass, wrapperClass = _b === void 0 ? "" : _b, _c = _a.contentClass, contentClass = _c === void 0 ? "" : _c, wrapperStyle = _a.wrapperStyle, contentStyle = _a.contentStyle, _d = _a.wrapperProps, wrapperProps = _d === void 0 ? {} : _d, _e = _a.contentProps, contentProps = _e === void 0 ? {} : _e;
    var _f = (0, $g85JO.useContext)($3704b9b8b7d6768a$export$841858b892ce1f4c), init = _f.init, cleanupWindowEvents = _f.cleanupWindowEvents;
    var wrapperRef = (0, $g85JO.useRef)(null);
    var contentRef = (0, $g85JO.useRef)(null);
    (0, $g85JO.useEffect)(function() {
        var wrapper = wrapperRef.current;
        var content = contentRef.current;
        if (wrapper !== null && content !== null && init) init === null || init === void 0 || init(wrapper, content);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return function() {
            cleanupWindowEvents === null || cleanupWindowEvents === void 0 || cleanupWindowEvents();
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", $3704b9b8b7d6768a$var$__assign({}, wrapperProps, {
        ref: wrapperRef,
        className: "react-transform-wrapper ".concat($3704b9b8b7d6768a$var$styles.wrapper, " ").concat(wrapperClass),
        style: wrapperStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($g85JO))).createElement("div", $3704b9b8b7d6768a$var$__assign({}, contentProps, {
        ref: contentRef,
        className: "react-transform-component ".concat($3704b9b8b7d6768a$var$styles.content, " ").concat(contentClass),
        style: contentStyle
    }), children));
};
var $3704b9b8b7d6768a$export$1708b11af87412f8 = function useTransformContext() {
    var libraryContext = (0, $g85JO.useContext)($3704b9b8b7d6768a$export$841858b892ce1f4c);
    if (!libraryContext) throw new Error("Transform context must be placed inside TransformWrapper");
    return libraryContext;
};
var $3704b9b8b7d6768a$export$8a75c83865bcf9dd = function useControls() {
    var libraryContext = $3704b9b8b7d6768a$export$1708b11af87412f8();
    return $3704b9b8b7d6768a$var$getControls(libraryContext);
};
var $3704b9b8b7d6768a$export$e14839139473133b = function useTransformInit(callback) {
    var libraryContext = $3704b9b8b7d6768a$export$1708b11af87412f8();
    (0, $g85JO.useEffect)(function() {
        var unmountCallback;
        var unmount;
        if (libraryContext.contentComponent && libraryContext.wrapperComponent) unmountCallback = callback($3704b9b8b7d6768a$var$getState(libraryContext));
        else unmount = libraryContext.onInit(function(ref) {
            unmountCallback = callback($3704b9b8b7d6768a$var$getState(ref.instance));
        });
        return function() {
            unmount === null || unmount === void 0 || unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, []);
};
var $3704b9b8b7d6768a$export$769cca75086a299c = function useTransformEffect(callback) {
    var libraryContext = $3704b9b8b7d6768a$export$1708b11af87412f8();
    (0, $g85JO.useEffect)(function() {
        var unmountCallback;
        var unmount = libraryContext.onChange(function(ref) {
            unmountCallback = callback($3704b9b8b7d6768a$var$getState(ref.instance));
        });
        return function() {
            unmount();
            unmountCallback === null || unmountCallback === void 0 || unmountCallback();
        };
    }, [
        callback,
        libraryContext
    ]);
};

});

parcelRegister("fdM5o", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $b14d5ec35d94097b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $dzlIC = parcelRequire("dzlIC");

var $9pMGg = parcelRequire("9pMGg");

var $edu9N = parcelRequire("edu9N");

var $8E2YL = parcelRequire("8E2YL");
function $b14d5ec35d94097b$var$GalleryButton(Props) {
    var product = Props.product;
    var variantId = Props.variantId;
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var transitiveAccount = match$1.transitiveAccount;
    var settings = match$1.settings;
    var match$2 = $9pMGg.use(undefined);
    var getLinkerParam = match$2.getLinkerParam;
    var customAction = $2whNH.flatMap($2whNH.flatMap(settings.pdpGalleryCustomAction, function(action) {
        return action.id;
    }), function(id) {
        return $i7mYY.getBy($2whNH.mapWithDefault(transitiveAccount, [], function(account) {
            return account.customActions;
        }), function(action) {
            return $7bjme.equal(action.id, id);
        });
    });
    var variant = $i7mYY.getBy($i7mYY.concat(product.otherVariants, [
        product.firstVariant
    ]), function(variant) {
        return variant.id === variantId;
    });
    var html = $2whNH.flatMap($2whNH.flatMap(customAction, function(action) {
        return action.renderFn;
    }), function(code) {
        return $dzlIC.triggerCustomFunctionReturningString(code, product, variant, "gallery button", undefined, undefined);
    });
    var handleClick = function handleClick(param) {
        $iv6Yc._1(getLinkerParam, undefined).then(function(linkerParam) {
            return $dzlIC.triggerCustomFunction($2whNH.getWithDefault($2whNH.flatMap(customAction, function(action) {
                return action.onClickFn;
            }), ""), product, variant, undefined, "gallery button", linkerParam, undefined);
        });
    };
    if (customAction === undefined) return null;
    if (html !== undefined) {
        if (html === "") return null;
        else return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("inline-block cursor-pointer select-none flex flex-grow"),
            onClick: function onClick($$event) {
                $$event.stopPropagation();
                handleClick(undefined);
            },
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
    var textColor = $2whNH.flatMap(settings.pdpGalleryCustomAction, function(action) {
        return action.textColor;
    });
    var bgColor = $2whNH.flatMap(settings.pdpGalleryCustomAction, function(action) {
        return action.bgColor;
    });
    var tmp = {};
    if (bgColor !== undefined) tmp.backgroundColor = bgColor;
    if (textColor !== undefined) tmp.color = textColor;
    var tmp$1 = {
        size: /* Md */ 2,
        style: tmp,
        onClick: handleClick,
        preventDefault: true,
        outline: true
    };
    var tmp$2 = $2whNH.flatMap(settings.pdpGalleryCustomAction, function(action) {
        return action.label;
    });
    if (tmp$2 !== undefined) tmp$1.label = tmp$2;
    return /*#__PURE__*/ $g85JO.createElement($edu9N.make, tmp$1);
}
$b14d5ec35d94097b$var$GalleryButton.displayName = "GalleryButton";
var $b14d5ec35d94097b$export$dd44f18ab656f3bb = $b14d5ec35d94097b$var$GalleryButton;
 /* react Not a pure module */ 
});

parcelRegister("e2Ecw", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a3906faa49f8addf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $jjSTi = parcelRequire("jjSTi");

var $aSJcu = parcelRequire("aSJcu");
function $a3906faa49f8addf$var$ExpandSequence(Props) {
    var isOpenOpt = Props.isOpen;
    var animateOpt = Props.animate;
    var crossFadeOpt = Props.crossFade;
    var topOffsetOpt = Props.topOffset;
    var getSourceElOpt = Props.getSourceEl;
    var allowPhaseChange = Props.allowPhaseChange;
    var onPhaseChange = Props.onPhaseChange;
    var onTouchEnd = Props.onTouchEnd;
    var onTouchStart = Props.onTouchStart;
    var onTouchMove = Props.onTouchMove;
    var renderForegroundOpt = Props.renderForeground;
    var autoHideSourceElOpt = Props.autoHideSourceEl;
    var zIndex = Props.zIndex;
    var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
    var animate = animateOpt !== undefined ? animateOpt : true;
    var crossFade = crossFadeOpt !== undefined ? crossFadeOpt : false;
    var topOffset = topOffsetOpt !== undefined ? topOffsetOpt : 0;
    var getSourceEl = getSourceElOpt !== undefined ? getSourceElOpt : function getSourceEl(param) {};
    var renderForeground = renderForegroundOpt !== undefined ? renderForegroundOpt : function renderForeground(param, param$1) {
        return null;
    };
    var autoHideSourceEl = autoHideSourceElOpt !== undefined ? autoHideSourceElOpt : true;
    var match = $aSJcu.use(undefined);
    var breakpoint = match.breakpoint;
    var getBoundingClientRect = function getBoundingClientRect(param) {
        return $2whNH.map($iv6Yc._1(getSourceEl, undefined), function(el) {
            return el.getBoundingClientRect();
        });
    };
    var domRect = getBoundingClientRect(undefined);
    var rect = $2whNH.map(domRect, function(domRect) {
        return {
            x: domRect.x | 0,
            y: domRect.y | 0,
            width: domRect.width | 0,
            height: domRect.height | 0
        };
    });
    var enterDuration;
    switch(breakpoint){
        case /* Xs */ 0:
        case /* Sm */ 1:
            enterDuration = 250;
            break;
        case /* Md */ 2:
            enterDuration = 300;
            break;
        case /* Lg */ 3:
            enterDuration = 350;
            break;
        case /* Xl */ 4:
            enterDuration = 400;
            break;
    }
    var exitDuration;
    switch(breakpoint){
        case /* Xs */ 0:
        case /* Sm */ 1:
            exitDuration = 200;
            break;
        case /* Md */ 2:
            exitDuration = 250;
            break;
        case /* Lg */ 3:
            exitDuration = 300;
            break;
        case /* Xl */ 4:
            exitDuration = 350;
            break;
    }
    var phases = rect !== undefined ? animate ? isOpen ? [
        [
            /* Hidden */ 0,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: rect
            },
            crossFade ? 50 : 0
        ],
        [
            /* MinimalFullscreen */ 1,
            enterDuration
        ],
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* CompleteFullscreen */ 2,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: rect
            },
            exitDuration
        ],
        [
            /* Hidden */ 0,
            crossFade ? 50 : 0
        ]
    ] : isOpen ? [
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* Hidden */ 0,
            0
        ]
    ] : animate ? isOpen ? [
        [
            /* MinimalFullscreen */ 1,
            0
        ],
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* CompleteFullscreen */ 2,
            0
        ],
        [
            /* MinimalOverSource */ {
                _0: {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                }
            },
            exitDuration
        ],
        [
            /* Hidden */ 0,
            crossFade ? 50 : 0
        ]
    ] : isOpen ? [
        [
            /* CompleteFullscreen */ 2,
            0
        ]
    ] : [
        [
            /* Hidden */ 0,
            0
        ]
    ];
    var style = {
        height: topOffset > 0 ? "calc(100% - " + $ezf3v.intToPx(topOffset) + ")" : "100%",
        left: "0",
        position: "fixed",
        top: $ezf3v.intToPx(topOffset),
        width: "100%",
        zIndex: $2whNH.getWithDefault(zIndex, "2147483647")
    };
    var match$1 = $jjSTi.useSequence(onPhaseChange, allowPhaseChange, phases);
    var phase = match$1[0];
    $g85JO.useLayoutEffect(function() {
        return function(param) {};
    }, [
        phase,
        autoHideSourceEl
    ]);
    if (phase === 0) return null;
    var tmp = {
        style: style
    };
    if (onTouchEnd !== undefined) tmp.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
    if (onTouchMove !== undefined) tmp.onTouchMove = $loT9g.valFromOption(onTouchMove);
    if (onTouchStart !== undefined) tmp.onTouchStart = $loT9g.valFromOption(onTouchStart);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, $iv6Yc._2(renderForeground, phase, match$1[1]));
}
$a3906faa49f8addf$var$ExpandSequence.displayName = "ExpandSequence";
var $a3906faa49f8addf$export$dd44f18ab656f3bb = $a3906faa49f8addf$var$ExpandSequence;
 /* react Not a pure module */ 
});
parcelRegister("jjSTi", function(module, exports) {

$parcel$export(module.exports, "useSequence", function () { return $e10a5edc54bb3b9f$export$574cda3fe44b1d9e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $d8lRc = parcelRequire("d8lRc");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $3QSSt = parcelRequire("3QSSt");

var $4Q2zg = parcelRequire("4Q2zg");
function $e10a5edc54bb3b9f$export$574cda3fe44b1d9e(onPhaseChangeOpt, allowPhaseChangeOpt, timedPhases) {
    var onPhaseChange = onPhaseChangeOpt !== undefined ? onPhaseChangeOpt : function onPhaseChange(param) {};
    var allowPhaseChange = allowPhaseChangeOpt !== undefined ? allowPhaseChangeOpt : function allowPhaseChange(param) {
        return true;
    };
    var didEdgeSwipe = $4Q2zg.useEdgeSwipeDetector(undefined);
    var timedPhases$1 = $iv6Yc._1(didEdgeSwipe, undefined) ? $i7mYY.map(timedPhases, function(param) {
        return [
            param[0],
            0
        ];
    }) : timedPhases;
    var phases = $i7mYY.map(timedPhases$1, function(param) {
        return param[0];
    });
    var durations = $i7mYY.map(timedPhases$1, function(param) {
        return param[1];
    });
    var initialPhase = phases[0];
    var match = $g85JO.useState(function() {
        return initialPhase;
    });
    var setPhase = match[1];
    var phase = match[0];
    var total = phases.length;
    var index = $2whNH.getWithDefault($i7mYY.getIndexBy(phases, function(p) {
        return $7bjme.equal(p, phase);
    }), 0);
    var phase$1 = phases[index];
    var duration = durations[index];
    var timeout = $g85JO.useRef(undefined);
    var nextPhase = $i7mYY.get(phases, index + 1 | 0);
    var next = $2whNH.map(nextPhase, function(nextPhase) {
        return {
            phase: nextPhase,
            previousPhase: phase$1,
            currentSequence: phases,
            index: index,
            total: total
        };
    });
    var phaseChangeAllowed = $2whNH.getWithDefault($2whNH.map(next, allowPhaseChange), true);
    var nextRef = $g85JO.useRef(next);
    nextRef.current = next;
    $g85JO.useLayoutEffect(function() {
        if (total !== 1 || duration !== 0) ;
        else $iv6Yc._1(onPhaseChange, {
            phase: phase$1,
            previousPhase: phase$1,
            currentSequence: phases,
            index: index,
            total: total
        });
    }, [
        phase$1,
        duration,
        total
    ]);
    $g85JO.useLayoutEffect(function() {
        if (phaseChangeAllowed) {
            $2whNH.map(timeout.current, function(prim) {
                clearTimeout(prim);
            });
            timeout.current = $loT9g.some(setTimeout(function(param) {
                var next = nextRef.current;
                if (next !== undefined) {
                    $iv6Yc._1(setPhase, function(param) {
                        return next.phase;
                    });
                    return $iv6Yc._1(onPhaseChange, next);
                }
            }, duration));
        }
    }, [
        nextPhase,
        phaseChangeAllowed
    ]);
    return [
        phase$1,
        duration
    ];
}
function $e10a5edc54bb3b9f$export$2a301f386223225(length, duration, isOpen) {
    var wasOpen = $3QSSt.usePreviousDistinct(isOpen);
    var durationPerItem = $d8lRc.div(duration, length);
    var phases = wasOpen ? isOpen ? [
        [
            length - 1 | 0,
            0
        ]
    ] : $i7mYY.makeBy(length, function(i) {
        return [
            length - i | 0,
            durationPerItem
        ];
    }) : isOpen ? $i7mYY.makeBy(length, function(i) {
        return [
            i,
            durationPerItem
        ];
    }) : [
        [
            0,
            0
        ]
    ];
    return $e10a5edc54bb3b9f$export$574cda3fe44b1d9e(undefined, undefined, phases)[0];
}
 /* react Not a pure module */ 
});
parcelRegister("4Q2zg", function(module, exports) {

$parcel$export(module.exports, "useEdgeSwipeDetector", function () { return $385e02a886c671c9$export$11f9a379a9296a15; });
$parcel$export(module.exports, "useEdgeSwipeDetectorImmediate", function () { return $385e02a886c671c9$export$9b8be4be2f76c0b6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $biidj = parcelRequire("biidj");
var $385e02a886c671c9$export$66e76ce6d60c3fb = function getTouchX(e) {
    return e.touches[0].pageX;
};
function $385e02a886c671c9$export$11f9a379a9296a15(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var lastDetectionTime = $g85JO.useRef(undefined);
    var touchStartX = $g85JO.useRef(undefined);
    var touchEndX = $g85JO.useRef(undefined);
    var didEdgeSwipe = function didEdgeSwipe(param) {
        return $2whNH.getWithDefault($2whNH.map(lastDetectionTime.current, function(t) {
            return Date.now() - t < 200.0;
        }), false);
    };
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchStartX.current = x;
        };
        var onTouchMove = function onTouchMove(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            touchEndX.current = x;
        };
        var onTouchEnd = function onTouchEnd(e) {
            var match = touchStartX.current;
            var match$1 = touchEndX.current;
            if (match !== undefined && match$1 !== undefined) {
                var leftEdgeSwipe = match < 20 && (match$1 - match | 0) > 20;
                var rightEdgeSwipe = (windowWidth - match | 0) < 20 && (match$1 - match | 0) < -20;
                if (leftEdgeSwipe || rightEdgeSwipe) lastDetectionTime.current = Date.now();
            }
            touchStartX.current = undefined;
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchmove", onTouchMove, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchmove", onTouchMove, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return didEdgeSwipe;
}
function $385e02a886c671c9$export$9b8be4be2f76c0b6(param) {
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var match = $g85JO.useState(function() {
        return false;
    });
    var setDidEdgeSwipe = match[1];
    $g85JO.useEffect(function() {
        var onTouchStart = function onTouchStart(e) {
            var x = $385e02a886c671c9$export$66e76ce6d60c3fb(e);
            var isLeftEdge = x <= 20;
            var isRightEdge = (windowWidth - x | 0) <= 20;
            if (isLeftEdge || isRightEdge) return $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return true;
            });
        };
        var onTouchEnd = function onTouchEnd(e) {
            $iv6Yc._1(setDidEdgeSwipe, function(param) {
                return false;
            });
        };
        document.addEventListener("touchstart", onTouchStart, true);
        document.addEventListener("touchend", onTouchEnd, true);
        return function(param) {
            document.removeEventListener("touchstart", onTouchStart, true);
            document.removeEventListener("touchend", onTouchEnd, true);
        };
    }, []);
    return match[0];
}
var $385e02a886c671c9$export$6683742126cd10b5 = 20;
 /* react Not a pure module */ 
});



parcelRegister("9JqU1", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $715d2f504c1550d7$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $7KlbQ = parcelRequire("7KlbQ");

var $7wIsS = parcelRequire("7wIsS");

var $55MCT = parcelRequire("55MCT");

var $9tGYJ = parcelRequire("9tGYJ");

var $62lkZ = parcelRequire("62lkZ");

var $27XcH = parcelRequire("27XcH");

var $dJcSN = parcelRequire("dJcSN");

var $38gYA = parcelRequire("38gYA");

var $8dLtV = parcelRequire("8dLtV");

var $239BR = parcelRequire("239BR");

var $gCzsf = parcelRequire("gCzsf");

var $1t9ha = parcelRequire("1t9ha");

var $biidj = parcelRequire("biidj");

var $aSJcu = parcelRequire("aSJcu");

var $8E2YL = parcelRequire("8E2YL");

var $upPgm = parcelRequire("upPgm");
function $715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem(Props) {
    var renderChildren = Props.renderChildren;
    var image = Props.image;
    var width = Props.width;
    var height = Props.height;
    var onSize = Props.onSize;
    var onClick = Props.onClick;
    var maxSizeOpt = Props.maxSize;
    var maxSize = maxSizeOpt !== undefined ? maxSizeOpt : true;
    var windowWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined);
    var src = $62lkZ.makeUrl($2whNH.getWithDefault(image, ""), windowWidth, undefined, /* Limit */ 0, undefined);
    var match = $9tGYJ.useImageSize(src);
    var match$1 = image !== undefined ? [
        match[0],
        match[1]
    ] : [
        undefined,
        undefined
    ];
    var match$2 = width > 0 && height > 0 ? [
        width,
        height
    ] : [
        match$1[0],
        match$1[1]
    ];
    var imageHeight = match$2[1];
    var imageWidth = match$2[0];
    var maxHeight;
    if (imageWidth !== undefined && imageHeight !== undefined && imageWidth > 0 && imageHeight > 0) {
        var maxHeight$1 = windowWidth / (imageWidth / imageHeight);
        maxHeight = maxSize ? Math.min(maxHeight$1, imageHeight) : maxHeight$1;
    } else maxHeight = undefined;
    $g85JO.useEffect(function() {
        if (maxHeight !== undefined && maxHeight > 0) $iv6Yc._1(onSize, maxHeight);
    }, [
        maxHeight
    ]);
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            maxHeight !== undefined ? "" : "invisible",
            "flex items-center justify-center h-full w-full overflow-hidden relative transition-opacity duration-300 cursor-zoom-out"
        ]))
    };
    var tmp$1 = $2whNH.map(maxHeight, function(maxHeight) {
        return {
            height: String(maxHeight) + "px"
        };
    });
    if (tmp$1 !== undefined) tmp.style = $loT9g.valFromOption(tmp$1);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($dJcSN.make, {
        children: /*#__PURE__*/ $g85JO.createElement($239BR.make, {
            render: function render(priority) {
                return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                    dataTestId: "pdp-photo",
                    children: /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix($1TRFX.make([
                            "absolute inset-0"
                        ])),
                        onClick: function onClick1(param) {
                            $iv6Yc._1(onClick, undefined);
                        }
                    }, $iv6Yc._1(renderChildren, priority))
                });
            }
        })
    }));
}
$715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem.displayName = "DesktopPhotoZoom.SliderItem";
var $715d2f504c1550d7$export$cf4a8ea79696f33c = {
    make: $715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem
};
function $715d2f504c1550d7$var$DesktopPhotoZoom(Props) {
    var product = Props.product;
    var variantId = Props.variantId;
    var medias = Props.medias;
    var viewport = Props.viewport;
    var onSlideChange = Props.onSlideChange;
    var onClickThumbnail = Props.onClickThumbnail;
    var thumbnailsPositionOpt = Props.thumbnailsPosition;
    var selectedIndex = Props.selectedIndex;
    var onClose = Props.onClose;
    var onPhotoZoomed = Props.onPhotoZoomed;
    var thumbnailsPosition = thumbnailsPositionOpt !== undefined ? thumbnailsPositionOpt : "bottom";
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var windowSize = match$1.windowSize;
    var match$2 = $g85JO.useState(function() {
        return 0;
    });
    var setCurrentSlide = match$2[1];
    var currentSlide = match$2[0];
    var match$3 = $g85JO.useState(function() {
        return $2whNH.getWithDefault(selectedIndex, -1);
    });
    var setSlideToIndex = match$3[1];
    var slideToIndex = match$3[0];
    var match$4 = $g85JO.useState(function() {
        return 0;
    });
    var setSlidesRendered = match$4[1];
    var slidesRendered = match$4[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setSlideToIndex, function(param) {
            return $2whNH.getWithDefault(selectedIndex, -1);
        });
    }, [
        selectedIndex
    ]);
    var scrollTo = $g85JO.useRef(function(param) {});
    var scrollableElement = $g85JO.useRef(null);
    var getSlides = function getSlides(param) {
        return $2whNH.mapWithDefault($2whNH.map($loT9g.nullable_to_opt(scrollableElement.current), function(prim) {
            return prim.children;
        }), [], function(prim) {
            return Array.prototype.slice.call(prim);
        });
    };
    $kQvlq.useSafeTimeout(undefined, undefined);
    var scrollToIndex = function scrollToIndex(index, slidesRendered) {
        var element = $i7mYY.get(getSlides(undefined), slideToIndex);
        var match = slidesRendered === medias.length;
        if (element !== undefined && match) {
            $iv6Yc._1(onPhotoZoomed, slideToIndex);
            return $iv6Yc._1(scrollTo.current, {
                TAG: /* Element */ 0,
                _0: $loT9g.valFromOption(element)
            });
        }
    };
    $g85JO.useEffect(function() {
        if (slideToIndex >= 0) scrollToIndex(slideToIndex, slidesRendered);
    }, [
        slideToIndex,
        slidesRendered
    ]);
    var handleScroll = function handleScroll(param, param$1) {
        var activeIndex = $i7mYY.reduceWithIndex($i7mYY.map($i7mYY.map(getSlides(undefined), function(prim) {
            return prim.getBoundingClientRect();
        }), function(prim) {
            return prim.top;
        }), undefined, function(acc, curr, index) {
            if (curr <= 0) return index;
            else return acc;
        });
        $iv6Yc._1(setCurrentSlide, function(param) {
            return activeIndex;
        });
        $iv6Yc._1(setSlideToIndex, function(param) {
            return -1;
        });
        $iv6Yc._1(onSlideChange, {
            activeIndex: activeIndex
        });
    };
    var items = $i7mYY.mapWithIndex(medias, function(idx, item) {
        var active = $7bjme.equal(idx, currentSlide);
        switch(item.TAG | 0){
            case /* Image */ 0:
                var match = item._0;
                var url = match.url;
                return /*#__PURE__*/ $g85JO.createElement($715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem, {
                    idx: idx,
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(priority) {
                        return /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                            src: url,
                            fit: /* ScaleDown */ 0,
                            priority: active ? 0 : priority
                        });
                    },
                    image: url,
                    width: match.width,
                    height: match.height,
                    onSize: function onSize(param) {
                        return $iv6Yc._1(setSlidesRendered, function(value) {
                            return value + 1 | 0;
                        });
                    },
                    onClick: function onClick(param) {
                        $iv6Yc._1(onClose, undefined);
                    },
                    key: variantId
                });
            case /* Video */ 1:
                var video = item._0;
                var match$1 = $7KlbQ.getVideoSource(video);
                if (match$1 === undefined) return null;
                var height = match$1.height;
                var width = match$1.width;
                var url$1 = match$1.url;
                var tmp = {
                    idx: idx,
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(param) {
                        var tmp = {
                            src: url$1,
                            viewport: viewport,
                            objectFit: width !== 0 || height !== 0 ? "contain" : "cover",
                            prioritize: true,
                            autoplay: settings.videoAutoPlay,
                            loop: settings.videoLoop,
                            muted: settings.videoMute,
                            controls: settings.videoControls,
                            key: variantId
                        };
                        if (video.posterUrl !== undefined) tmp.poster = video.posterUrl;
                        return /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp);
                    },
                    width: width,
                    height: height,
                    onSize: function onSize(param) {
                        return $iv6Yc._1(setSlidesRendered, function(value) {
                            return value + 1 | 0;
                        });
                    },
                    onClick: function onClick(param) {
                        $iv6Yc._1(onClose, undefined);
                    },
                    maxSize: false,
                    key: variantId
                };
                if (video.posterUrl !== undefined) tmp.image = $loT9g.valFromOption(video.posterUrl);
                return /*#__PURE__*/ $g85JO.createElement($715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem, tmp);
            case /* IframeEmbed */ 2:
                var url$2 = item._0.url;
                return /*#__PURE__*/ $g85JO.createElement($715d2f504c1550d7$var$DesktopPhotoZoom$SliderItem, {
                    idx: idx,
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(param) {
                        return /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                            url: url$2
                        });
                    },
                    width: windowSize.width,
                    height: windowSize.height,
                    onSize: function onSize(param) {
                        return $iv6Yc._1(setSlidesRendered, function(value) {
                            return value + 1 | 0;
                        });
                    },
                    onClick: function onClick(param) {
                        $iv6Yc._1(onClose, undefined);
                    },
                    maxSize: false,
                    key: variantId
                });
        }
    });
    var tmp = {
        medias: medias,
        setSlideToIndex: setSlideToIndex,
        onClickThumbnail: onClickThumbnail,
        visibility: "hover",
        product: product,
        variantId: variantId
    };
    if (currentSlide !== undefined) tmp.currentSlide = $loT9g.valFromOption(currentSlide);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("fixed inset-0 bg-white z-40")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 overflow-hidden group"),
        style: {
            backgroundColor: settings.pdpGalleryBGColor
        }
    }, /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
        restorationId: "pdp-photo-slider",
        scrollToRef: scrollTo,
        onScroll: handleScroll,
        children: items,
        fwdRef: scrollableElement,
        className: $ezf3v.prefix("absolute inset-0 space-y-4"),
        rememberScrollPosition: false
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute",
            thumbnailsPosition === "center" ? "top-1/2 left-0 pl-8 transform -translate-y-1/2" : "bottom-0 right-0 pb-8 pr-8"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($upPgm.make, tmp))), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-6 right-5")
    }, /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
        onClick: function onClick(param) {
            $iv6Yc._1(onClose, undefined);
        },
        shadow: true,
        icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilTimes.make, {
            size: /* Px */ {
                _0: 28
            }
        }),
        title: "Close",
        dataTestId: "pdp-button-open-close",
        className: $ezf3v.prefix("pointer-events-auto")
    })));
}
$715d2f504c1550d7$var$DesktopPhotoZoom.displayName = "DesktopPhotoZoom";
var $715d2f504c1550d7$export$dd44f18ab656f3bb = $715d2f504c1550d7$var$DesktopPhotoZoom;
 /* react Not a pure module */ 
});
parcelRegister("upPgm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $05b6d5ed2107e4b4$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $5alaa = parcelRequire("5alaa");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $55MCT = parcelRequire("55MCT");

var $38gYA = parcelRequire("38gYA");

var $gCzsf = parcelRequire("gCzsf");

var $fdM5o = parcelRequire("fdM5o");
function $05b6d5ed2107e4b4$var$PhotoSliderThumbnails(Props) {
    var medias = Props.medias;
    var currentSlide = Props.currentSlide;
    var setSlideToIndex = Props.setSlideToIndex;
    var onClickThumbnail = Props.onClickThumbnail;
    var visibilityOpt = Props.visibility;
    var maxThumbnailsOpt = Props.maxThumbnails;
    var maxSlidesPerViewport = Props.maxSlidesPerViewport;
    var product = Props.product;
    var variantId = Props.variantId;
    var visibility = visibilityOpt !== undefined ? visibilityOpt : "always";
    var maxThumbnails = maxThumbnailsOpt !== undefined ? maxThumbnailsOpt : 10;
    var images = $i7mYY.keepMap(medias, function(item) {
        switch(item.TAG | 0){
            case /* Image */ 0:
                return item._0.url;
            case /* Video */ 1:
                return item._0.posterUrl;
            case /* IframeEmbed */ 2:
                return;
        }
    });
    var partial_arg = images.length;
    var maxSlidesPerViewport$1 = $2whNH.map(maxSlidesPerViewport, function(param) {
        return Math.min(partial_arg, param);
    });
    var maxHeight = $2whNH.map(maxSlidesPerViewport$1, function(count) {
        return count * 48 + ($5alaa.ceil(count) - 1 | 0) * 6;
    });
    var render = function render(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col gap-2")
        }, /*#__PURE__*/ $g85JO.createElement($fdM5o.make, {
            product: product,
            variantId: variantId
        }), $i7mYY.mapWithIndex($i7mYY.keepWithIndex(images, function(src, idx) {
            return idx < maxThumbnails;
        }), function(idx, src) {
            var last = idx === (images.length - 1 | 0) || images.length > maxThumbnails && idx === (maxThumbnails - 1 | 0);
            var selected = $7bjme.equal(idx, currentSlide) || $7bjme.greaterthan(currentSlide, maxThumbnails - 1 | 0) && last;
            var delta = images.length - maxThumbnails | 0;
            return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                dataTestId: selected ? "photo-thumbnail-selected" : "photo-thumbnail",
                children: /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix((images.length > 1 ? "opacity-100" : "opacity-0 pointer-events-none") + " inline-block transition-transform text-primary rounded overflow-hidden cursor-pointer relative w-16 h-16 border border-solid transform-gpu duration-150" + (selected ? " border-main ring-current ring-1 scale-105" : " border-transparent scale-100")),
                    id: "photo-slider-thumbnails-" + String(idx) + "",
                    tabIndex: 0,
                    onClick: function onClick(e) {
                        $iv6Yc._1(setSlideToIndex, function(param) {
                            return idx;
                        });
                        $iv6Yc._1(onClickThumbnail, undefined);
                    }
                }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                    src: src,
                    fit: /* Cover */ 1,
                    alt: product.name,
                    priority: 1
                }), last && delta > 0 ? /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("bg-black bg-opacity-50 text-white flex items-center justify-center text-lg absolute inset-0")
                }, "+" + String(delta) + "") : null),
                key: src
            });
        }));
    };
    var stopTouchPropagation = $g85JO.useCallback(function(e) {
        e.stopPropagation();
    }, []);
    var scrollToRef = $g85JO.useRef(function(param) {});
    var scrollElementRef = $g85JO.useRef(null);
    $g85JO.useEffect(function() {
        if (maxHeight !== undefined && currentSlide !== undefined) {
            var thumbEl = $2whNH.flatMap($loT9g.nullable_to_opt(scrollElementRef.current), function(__x) {
                return $loT9g.nullable_to_opt(__x.querySelector("#photo-slider-thumbnails-" + String(currentSlide)));
            });
            var thumbOffsetTop = $2whNH.map($2whNH.map($2whNH.flatMap(thumbEl, function(prim) {
                return prim;
            }), function(prim) {
                return prim.offsetTop;
            }), function(prim) {
                return prim;
            });
            var thumbHeight = $2whNH.map($2whNH.map(thumbEl, function(prim) {
                return prim.clientHeight;
            }), function(prim) {
                return prim;
            });
            var containerHeight = $2whNH.mapWithDefault($loT9g.nullable_to_opt(scrollElementRef.current), 0, function(el) {
                return el.clientHeight;
            });
            if (thumbOffsetTop !== undefined && thumbHeight !== undefined) $iv6Yc._1(scrollToRef.current, {
                TAG: /* Pixel */ 1,
                _0: thumbOffsetTop + (thumbHeight / 2 - containerHeight / 2)
            });
        }
    }, [
        currentSlide,
        maxHeight
    ]);
    var getWrapperStyle = function getWrapperStyle(maxHeight) {
        return {
            height: "" + String(maxHeight + 6) + "px",
            width: "" + String(60) + "px"
        };
    };
    var tmp = {
        className: $ezf3v.prefix($1TRFX.make([
            "relative",
            visibility === "hover" ? "transition-opacity duration-150 group-hover:opacity-100 opacity-0" : ""
        ]))
    };
    var tmp$1 = maxHeight !== undefined ? $loT9g.some(getWrapperStyle(maxHeight)) : undefined;
    if (tmp$1 !== undefined) tmp.style = $loT9g.valFromOption(tmp$1);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, maxHeight !== undefined ? /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
        scrollToRef: scrollToRef,
        children: render(undefined),
        fwdRef: scrollElementRef,
        className: $ezf3v.prefix("p-1 pr-2"),
        onTouchStart: stopTouchPropagation,
        onTouchMove: stopTouchPropagation,
        onTouchEnd: stopTouchPropagation,
        style: getWrapperStyle(maxHeight)
    }) : render(undefined));
}
$05b6d5ed2107e4b4$var$PhotoSliderThumbnails.displayName = "PhotoSliderThumbnails";
var $05b6d5ed2107e4b4$export$dd44f18ab656f3bb = $05b6d5ed2107e4b4$var$PhotoSliderThumbnails;
 /* react Not a pure module */ 
});


parcelRegister("kPwXH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f2a22399d2320f01$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $lPfnp = parcelRequire("lPfnp");
function $f2a22399d2320f01$var$RectToRectTransition(Props) {
    var largeContainer = Props.largeContainer;
    var smallContainer = Props.smallContainer;
    var naturalSize = Props.naturalSize;
    var smallFitRule = Props.smallFitRule;
    var largeFitRule = Props.largeFitRule;
    var duration = Props.duration;
    var render = Props.render;
    var largeFit = $lPfnp.fitAndPosition({
        width: largeContainer.width,
        height: largeContainer.height
    }, naturalSize, largeFitRule);
    var render2 = function render2(sx, sy, tx, ty, invSx, invSy) {
        var transitionDuration = duration === 0 ? undefined : "" + String(duration) + "ms";
        var outerTransform = $ezf3v.translateAndScale(tx, ty, sx, sy);
        var innerTransform = $ezf3v.scale(invSx, invSy);
        var scaleUp = 1.0 / $81N94.float_max(sx * invSx, sy * invSy);
        var tmp = {
            height: "" + String(largeFit.height) + "px",
            width: "" + String(largeFit.width) + "px",
            transform: outerTransform,
            transformOrigin: "top left"
        };
        if (transitionDuration !== undefined) tmp.transitionDuration = transitionDuration;
        var tmp$1 = {
            height: "" + String(largeFit.height) + "px",
            width: "" + String(largeFit.width) + "px",
            transform: innerTransform
        };
        if (transitionDuration !== undefined) tmp$1.transitionDuration = transitionDuration;
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("pointer-events-none absolute inset-0 flex items-center justify-center")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0 pointer-events-auto ease-fastoutslow overflow-hidden transition-transform"),
            style: tmp
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("ease-fastoutslow transition-transform flex items-center"),
            style: tmp$1
        }, $iv6Yc._1(render, scaleUp))));
    };
    if (smallContainer === undefined) return render2(1.0, 1.0, 0, 0, 1.0, 1.0);
    var smallFit = $lPfnp.fitAndPosition({
        width: smallContainer.width,
        height: smallContainer.height
    }, naturalSize, smallFitRule);
    var sx = smallContainer.width / largeFit.width;
    var sy = smallContainer.height / largeFit.height;
    var tx = (smallContainer.x - largeContainer.x | 0) - largeFit.x | 0;
    var ty = (smallContainer.y - largeContainer.y | 0) - largeFit.y | 0;
    var invSx = smallFit.width / smallContainer.width;
    var invSy = smallFit.height / smallContainer.height;
    return render2(sx, sy, tx, ty, invSx, invSy);
}
$f2a22399d2320f01$var$RectToRectTransition.displayName = "RectToRectTransition";
var $f2a22399d2320f01$export$dd44f18ab656f3bb = $f2a22399d2320f01$var$RectToRectTransition;
 /* react Not a pure module */ 
});


parcelRegister("sK0FX", function(module, exports) {

$parcel$export(module.exports, "useMoreSections", function () { return $05664e3f3d15baa4$export$dca86605273ae1b7; });
$parcel$export(module.exports, "make", function () { return $05664e3f3d15baa4$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $1Ij4x = parcelRequire("1Ij4x");

var $dMhWy = parcelRequire("dMhWy");

var $kEThe = parcelRequire("kEThe");

var $czXEM = parcelRequire("czXEM");

var $8L1B1 = parcelRequire("8L1B1");

var $hBcYV = parcelRequire("hBcYV");

var $3uZKH = parcelRequire("3uZKH");

var $gamGp = parcelRequire("gamGp");

var $aSJcu = parcelRequire("aSJcu");

var $hqyY4 = parcelRequire("hqyY4");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $1z5jA = parcelRequire("1z5jA");

var $jtD5N = parcelRequire("jtD5N");

var $fOz3p = parcelRequire("fOz3p");

var $8E2YL = parcelRequire("8E2YL");

var $lHzh8 = parcelRequire("lHzh8");

var $1nuZE = parcelRequire("1nuZE");

var $hQWQG = parcelRequire("hQWQG");

var $84pt4 = parcelRequire("84pt4");
function $05664e3f3d15baa4$export$dca86605273ae1b7(separatorOpt, productCategory, showEnhanceContentOpt, showRelatedProductsOpt, showRelatedMediaOpt, isInsideQuickViewOpt, showMoreProductsOpt, descriptionLayout, shouldForceMobileOpt, relatedProductsLayout, scrollableContainerRef, hideRelatedProductId, layoutOpt, product, selectedVariant, param) {
    var separator = separatorOpt !== undefined ? separatorOpt : true;
    var showEnhanceContent = showEnhanceContentOpt !== undefined ? showEnhanceContentOpt : true;
    var showRelatedProducts = showRelatedProductsOpt !== undefined ? showRelatedProductsOpt : true;
    var showRelatedMedia = showRelatedMediaOpt !== undefined ? showRelatedMediaOpt : true;
    var showMoreProducts = showMoreProductsOpt !== undefined ? showMoreProductsOpt : true;
    var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
    var entrypointContext = $9pMGg.use(undefined);
    var pdpConfig = $1nuZE.use(undefined);
    var isMiniPDPVisible = entrypointContext.isMiniPDPVisible;
    var onOpenLink = entrypointContext.onOpenLink;
    var onProductClick = entrypointContext.onProductClick;
    var onAddToCart = entrypointContext.onAddToCart;
    var trackEvent = entrypointContext.trackEvent;
    var displayVariantBy = $jtD5N.useDisplayVariantBy(undefined);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var settings = config.settings;
    var match$1 = $hBcYV.useRouter(undefined);
    var relatedProductId = match$1.relatedProductId;
    var anyProductId = match$1.anyProductId;
    var listPageType = match$1.listPageType;
    var route = match$1.route;
    var match$2 = $aSJcu.use(undefined);
    var relatedMediaSlider = $1z5jA.useSlider(undefined, /* PDP */ 0, scrollableContainerRef, {
        TAG: /* ByProductIds */ 0,
        _0: [
            product.id
        ]
    }, undefined, undefined, undefined, undefined);
    var isMobile = match$2.isMobile || shouldForceMobile;
    var isQuickView;
    isQuickView = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? false : true;
    var cardShape = settings.productCardShape;
    var shouldShowProductsFromCollection = !$1xf0g.ExternalConnection.isConnectedToProductSource(productCategory) && $1xf0g.getProductIds(productCategory).length === 0 || isQuickView;
    var onRelatedProductClick = $g85JO.useCallback(function(relatedProduct) {
        return function(variant) {
            var tmp;
            tmp = typeof route === "number" || route.TAG !== /* QuickView */ 3 ? undefined : route._0.mediaId;
            $iv6Yc.app(trackEvent, [
                "product details:other products",
                undefined,
                undefined,
                product,
                selectedVariant,
                relatedProduct,
                undefined,
                undefined,
                tmp,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return $iv6Yc._2(onProductClick, relatedProduct, variant);
        };
    }, [
        trackEvent,
        product.id,
        onProductClick
    ]);
    var contextValue = $g85JO.useMemo(function() {
        var newrecord = $7bjme.obj_dup(entrypointContext);
        newrecord.onProductClick = onRelatedProductClick;
        return newrecord;
    }, [
        entrypointContext,
        onRelatedProductClick
    ]);
    var columns = isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3;
    var renderRelatedProductsPlaceholder = function renderRelatedProductsPlaceholder(param) {
        return /*#__PURE__*/ $g85JO.createElement($czXEM.make, {
            columns: columns,
            children: [
                /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: "infinite-0"
                }),
                /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: "infinite-1"
                }),
                /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: "infinite-2"
                }),
                /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                    shape: cardShape,
                    kind: /* Product */ 0,
                    contentBoxStylableClassName: "product-card__content-box",
                    titleStylableClassName: "category-card__title",
                    key: "infinite-3"
                })
            ],
            paddingOverride: 0
        });
    };
    var renderRelatedProducts = function renderRelatedProducts(param) {
        if (shouldShowProductsFromCollection) return $loT9g.some(/*#__PURE__*/ $g85JO.createElement($84pt4.make, {
            productId: relatedProductId !== undefined ? relatedProductId : anyProductId !== undefined ? anyProductId : "",
            categoryId: $2whNH.getWithDefault($2whNH.flatMap(listPageType, function(id) {
                if (typeof id === "number" || id.TAG !== /* Category */ 0) return;
                else return id._0;
            }), ""),
            hideOutOfStock: settings.hideOutOfStock,
            viewport: scrollableContainerRef,
            render: function render(products) {
                var cards = $i7mYY.mapWithIndex(products, function(dataCount, product) {
                    var tmp = {
                        shape: cardShape,
                        productCategory: productCategory,
                        product: product,
                        onClick: onProductClick,
                        onAddToCart: onAddToCart,
                        onOpenLink: onOpenLink,
                        dataCount: dataCount,
                        key: product.id
                    };
                    if (isMiniPDPVisible !== undefined) tmp.isMiniPDPVisible = $loT9g.valFromOption(isMiniPDPVisible);
                    return /*#__PURE__*/ $g85JO.createElement($kEThe.make, tmp);
                });
                return /*#__PURE__*/ $g85JO.createElement($czXEM.make, {
                    columns: columns,
                    children: cards,
                    paddingOverride: 0
                });
            },
            displayVariantBySelector: displayVariantBy
        }));
    };
    var productDetails = $1Ij4x.makeSection(undefined, "description", $loT9g.some(/*#__PURE__*/ $g85JO.createElement($lHzh8.DetailedAccordions.make, {
        variant: selectedVariant,
        product: product
    })), undefined, undefined, separator, undefined, undefined);
    var productsContentLayout = $g85JO.useMemo(function() {
        return {
            TAG: /* GridLayout */ 1,
            _0: {
                columns: /* TwoColumnGrid */ 1,
                gap: /* Half */ 1,
                maxRows: undefined,
                maxWidth: undefined,
                padding: undefined,
                pattern: undefined
            }
        };
    }, []);
    var productsContentLayout$1 = $2whNH.getWithDefault(relatedProductsLayout, productsContentLayout);
    var forcedSize = relatedProductsLayout !== undefined ? undefined : /* Lg */ 5;
    var tmp;
    if (showMoreProducts && !shouldShowProductsFromCollection) {
        if (showRelatedProducts) {
            var match$3 = $1xf0g.ExternalConnection.getConnection(productCategory);
            var tmp$1;
            if (match$3 !== undefined) {
                if (typeof match$3 === "number") switch(match$3){
                    case /* History */ 0:
                        tmp$1 = /* History */ 3;
                        break;
                    case /* Favorites */ 1:
                        tmp$1 = /* Favorites */ 2;
                        break;
                    case /* StoreCart */ 2:
                        tmp$1 = /* StoreCart */ 4;
                        break;
                }
                else tmp$1 = match$3.TAG === /* StoreCategory */ 0 ? /* Products */ 0 : /* Category */ 1;
            } else tmp$1 = /* Products */ 0;
            var tmp$2 = {
                index: 3,
                preferredContentType: tmp$1,
                shouldShowHeader: false,
                isZoomEnabled: false,
                category: productCategory,
                refreshUserSavedProducts: false,
                layout: productsContentLayout$1,
                scrollableContainerRef: scrollableContainerRef,
                isPaddingEnabled: false,
                isThemeEnabled: false
            };
            if (forcedSize !== undefined) tmp$2.forcedSize = $loT9g.valFromOption(forcedSize);
            var content = /*#__PURE__*/ $g85JO.createElement($3uZKH.make, tmp$2);
            tmp = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($9pMGg.Provider.make, {
                value: contextValue,
                children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                    condition: isMobile,
                    children: /*#__PURE__*/ $g85JO.createElement($2ZaET.RenderAfterLCP.make, {
                        children: content,
                        fallbackElement: /*#__PURE__*/ $g85JO.createElement("div", undefined, "Loading...")
                    }),
                    fallback: content
                })
            }));
        } else tmp = $loT9g.some(renderRelatedProductsPlaceholder(undefined));
    } else tmp = undefined;
    var moreSections = [
        $1Ij4x.makeSection({
            TAG: /* Element */ 1,
            _0: null
        }, "enhance section", showEnhanceContent && pdpConfig.enhanceSections.length !== 0 ? $loT9g.some(/*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col space-y-4")
        }, $i7mYY.keepMap($i7mYY.map(pdpConfig.enhanceSections, function(section) {
            var content = $fOz3p.EnhanceSection.renderContent(undefined, undefined, isMobile || settings.desktopPDPLayout === /* Old */ 0, product, selectedVariant, config, section);
            var heading = $2whNH.mapWithDefault($2whNH.keep(section.showTitle, function(a) {
                return a;
            }), null, function(param) {
                return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("text-xl font-semibold text-primary uppercase")
                }, section.title);
            });
            return $2whNH.map(content, function(content) {
                return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, {
                    children: null,
                    key: $iv6Yc._1($hQWQG.SectionId.toString, section.id)
                }, heading, content);
            });
        }), function(a) {
            return a;
        }))) : undefined, undefined, undefined, undefined, undefined, undefined),
        $1Ij4x.makeSection({
            TAG: /* Text */ 0,
            _0: "Related Media"
        }, "related media", showRelatedMedia ? relatedMediaSlider : undefined, undefined, undefined, undefined, undefined, undefined),
        $1Ij4x.makeSection({
            TAG: /* Text */ 0,
            _0: "Products from this category"
        }, "products from this category", tmp, undefined, undefined, undefined, undefined, undefined),
        $1Ij4x.makeSection({
            TAG: /* Text */ 0,
            _0: "Related products"
        }, "related products", showMoreProducts ? showRelatedProducts ? renderRelatedProducts(undefined) : $loT9g.some(renderRelatedProductsPlaceholder(undefined)) : undefined, undefined, undefined, separator, undefined, undefined)
    ];
    if (descriptionLayout) return $i7mYY.concat([
        productDetails
    ], moreSections);
    else return moreSections;
}
function $05664e3f3d15baa4$var$PDPContentDetails(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var productCategory = Props.productCategory;
    var shouldForceMobile = Props.shouldForceMobile;
    var isInsideQuickView = Props.isInsideQuickView;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var scrollToDetailsRef = Props.scrollToDetailsRef;
    var stickyDetailsRef = Props.stickyDetailsRef;
    var showHeaderOpt = Props.showHeader;
    var titleStyleOpt = Props.titleStyle;
    var largeTitleStyleOpt = Props.largeTitleStyle;
    var optionSizeOpt = Props.optionSize;
    var optionStyleOpt = Props.optionStyle;
    var colorOptionSizeOpt = Props.colorOptionSize;
    var hideRelatedProductId = Props.hideRelatedProductId;
    var showEnhanceContentOpt = Props.showEnhanceContent;
    var showRelatedProductsOpt = Props.showRelatedProducts;
    var showRelatedMediaOpt = Props.showRelatedMedia;
    var showMoreProductsOpt = Props.showMoreProducts;
    var descriptionLayout = Props.descriptionLayout;
    var onCTAButtonVisibilityChange = Props.onCTAButtonVisibilityChange;
    var stickyCTA = Props.stickyCTA;
    var relatedProductsLayout = Props.relatedProductsLayout;
    var layoutOpt = Props.layout;
    var separatorOpt = Props.separator;
    var headerSize = Props.headerSize;
    var sections = Props.sections;
    var singleColumnHorizontalPadding = Props.singleColumnHorizontalPadding;
    var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
    var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold";
    var largeTitleStyle = largeTitleStyleOpt !== undefined ? largeTitleStyleOpt : "medium";
    var optionSize = optionSizeOpt !== undefined ? optionSizeOpt : /* Lg */ 3;
    var optionStyle = optionStyleOpt !== undefined ? optionStyleOpt : /* Border */ 0;
    var colorOptionSize = colorOptionSizeOpt !== undefined ? colorOptionSizeOpt : /* Lg */ 3;
    var showEnhanceContent = showEnhanceContentOpt !== undefined ? showEnhanceContentOpt : true;
    var showRelatedProducts = showRelatedProductsOpt !== undefined ? showRelatedProductsOpt : true;
    var showRelatedMedia = showRelatedMediaOpt !== undefined ? showRelatedMediaOpt : true;
    var showMoreProducts = showMoreProductsOpt !== undefined ? showMoreProductsOpt : true;
    var layout = layoutOpt !== undefined ? layoutOpt : /* SingleColumn */ 0;
    var separator = separatorOpt !== undefined ? separatorOpt : true;
    var store = $8L1B1.use(undefined);
    var match = $aSJcu.use(undefined);
    var match$1 = $dMhWy.useFavorites(undefined);
    var showRelatedMedia$1 = !isInsideQuickView && showRelatedMedia;
    var isMobile = match.isMobile || shouldForceMobile;
    var tmp = {
        productTitle: $7KlbQ.getDisplayName(store, variant, product),
        product: product,
        variant: variant,
        onClick: function onClick(e) {
            $iv6Yc._1(scrollToDetailsRef.current, undefined);
        },
        scrollToDetailsRef: scrollToDetailsRef
    };
    if (stickyDetailsRef !== undefined) tmp.fwdRef = $loT9g.valFromOption(stickyDetailsRef);
    var stickyDetailsContent = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: isMobile,
        children: /*#__PURE__*/ $g85JO.createElement($hqyY4.make, tmp)
    });
    var moreSections = $05664e3f3d15baa4$export$dca86605273ae1b7(separator, productCategory, showEnhanceContent, showRelatedProducts, showRelatedMedia$1, isInsideQuickView, showMoreProducts, descriptionLayout, shouldForceMobile, relatedProductsLayout, scrollableContainerRef, hideRelatedProductId, layout, product, variant, undefined);
    var tmp$1 = {
        product: product,
        variant: variant,
        productCategory: productCategory,
        shouldForceMobile: shouldForceMobile,
        scrollToDetailsRef: scrollToDetailsRef,
        showHeader: showHeader,
        titleStyle: titleStyle,
        largeTitleStyle: largeTitleStyle,
        optionSize: optionSize,
        optionStyle: optionStyle,
        colorOptionSize: colorOptionSize,
        moreSections: moreSections,
        layout: layout,
        showFavoriteButton: match$1.enabled
    };
    if (onCTAButtonVisibilityChange !== undefined) tmp$1.onCTAButtonVisibilityChange = $loT9g.valFromOption(onCTAButtonVisibilityChange);
    if (headerSize !== undefined) tmp$1.headerSize = $loT9g.valFromOption(headerSize);
    if (stickyCTA !== undefined) tmp$1.stickyCTA = stickyCTA;
    if (sections !== undefined) tmp$1.sections = $loT9g.valFromOption(sections);
    if (singleColumnHorizontalPadding !== undefined) tmp$1.singleColumnHorizontalPadding = $loT9g.valFromOption(singleColumnHorizontalPadding);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($lHzh8.make, tmp$1), stickyDetailsContent);
}
$05664e3f3d15baa4$var$PDPContentDetails.displayName = "PDPContentDetails";
var $05664e3f3d15baa4$export$dd44f18ab656f3bb = $05664e3f3d15baa4$var$PDPContentDetails;
 /* react Not a pure module */ 
});
parcelRegister("hqyY4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cafffd43ba7d02a3$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $6iioJ = parcelRequire("6iioJ");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $849Xu = parcelRequire("849Xu");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $5av24 = parcelRequire("5av24");

var $8E2YL = parcelRequire("8E2YL");
function $cafffd43ba7d02a3$var$PDPStickyDetails(Props) {
    var productTitle = Props.productTitle;
    var product = Props.product;
    var variant = Props.variant;
    var showOpt = Props.show;
    var imageOpt = Props.image;
    var renderSubtitle = Props.renderSubtitle;
    var onClickOpt = Props.onClick;
    var fwdRef = Props.fwdRef;
    var show = showOpt !== undefined ? showOpt : false;
    var image = imageOpt !== undefined ? imageOpt : true;
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(e) {};
    var match = $8E2YL.use(undefined).config;
    var imageFit = match.settings.productCardFitToContainer ? /* Contain */ 2 : /* Cover */ 1;
    var match$1 = $g85JO.useState(function() {
        return show;
    });
    var setShow = match$1[1];
    var show$1 = match$1[0];
    $2whNH.forEach(fwdRef, function(ref) {
        ref.current = function(show) {
            $iv6Yc._1(setShow, function(param) {
                return show;
            });
        };
    });
    var match$2 = variant.media;
    var imgUrl;
    switch(match$2.TAG | 0){
        case /* Image */ 0:
            imgUrl = match$2._0.url;
            break;
        case /* Video */ 1:
        case /* IframeEmbed */ 2:
            imgUrl = undefined;
            break;
    }
    var numColors = $7KlbQ.getOptionsByName(product, "Color").length;
    var displayColor = numColors > 1 ? $2whNH.getWithDefault($7KlbQ.Variant.getOptionValue(variant, "Color"), "") : "";
    var getPropertiesAsString = function getPropertiesAsString(param) {
        return $i7mYY.keep([
            displayColor
        ], function(i) {
            return i.trim() !== "";
        }).join(", ");
    };
    var renderDetails = function renderDetails(param) {
        var tmp;
        if (image) {
            var tmp$1 = {
                fit: imageFit,
                alt: productTitle,
                priority: 1
            };
            if (imgUrl !== undefined) tmp$1.src = imgUrl;
            tmp = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-full aspect-ratio-square h-0 overflow-hidden col-span-1 rounded relative bg-placeholder")
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute inset-0")
            }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp$1)));
        } else tmp = null;
        return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, tmp, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("col-span-4 items-center w-full grid grid-cols-5")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("text-secondary text-lg col-span-3")
        }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
            lines: 2,
            children: productTitle
        }), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("font-semibold")
        }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
            lines: 2,
            children: $2whNH.mapWithDefault(renderSubtitle, getPropertiesAsString(undefined), function(fn) {
                return $iv6Yc._1(fn, undefined);
            })
        }))), /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex flex-col col-span-2 text-lg font-semibold justify-end items-end")
        }, /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
            at: /* PDP */ 0,
            product: product,
            variant: variant,
            align: /* Right */ 1,
            minPriceFirst: false,
            multiline: true
        }))));
    };
    return /*#__PURE__*/ $g85JO.createElement($849Xu.make, {
        show: show$1,
        unmount: false,
        enter: $ezf3v.prefix("transition-transform transform-gpu duration-300"),
        enterFrom: $ezf3v.prefix("translate-y-full"),
        enterTo: $ezf3v.prefix("translate-y-0"),
        leave: $ezf3v.prefix("transition-transform transform-gpu duration-75"),
        leaveFrom: $ezf3v.prefix("translate-y-0"),
        leaveTo: $ezf3v.prefix("translate-y-full"),
        className: $ezf3v.prefix("sticky shadow-xl left-0 w-full bg-main bottom-0"),
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataActive: show$1,
            dataTestId: "pdp-sticky-details-popup",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("grid grid-cols-1 gap-4 py-4 px-6 items-center")
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("grid grid-cols-5 col-span-1 w-full gap-4 items-center cursor-pointer"),
                onClick: onClick
            }, renderDetails(undefined)), /*#__PURE__*/ $g85JO.createElement($6iioJ.make, {
                product: product,
                variant: variant
            }))
        })
    });
}
$cafffd43ba7d02a3$var$PDPStickyDetails.displayName = "PDPStickyDetails";
var $cafffd43ba7d02a3$export$dd44f18ab656f3bb = $cafffd43ba7d02a3$var$PDPStickyDetails;
 /* react Not a pure module */ 
});

parcelRegister("84pt4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $01842b28ba27ad01$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $3QSSt = parcelRequire("3QSSt");

var $7xAyC = parcelRequire("7xAyC");

var $gFKzh = parcelRequire("gFKzh");

var $5bEXW = parcelRequire("5bEXW");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $iJp5F = parcelRequire("iJp5F");

var $8E2YL = parcelRequire("8E2YL");

var $ij6do = parcelRequire("ij6do");
function $01842b28ba27ad01$var$RelatedProductsContent(Props) {
    var productId = Props.productId;
    var categoryId = Props.categoryId;
    var hideOutOfStock = Props.hideOutOfStock;
    var viewport = Props.viewport;
    var render = Props.render;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var account = match$2.transitiveAccount;
    var configId = match$2.id;
    var match$3 = $9pMGg.use(undefined);
    var swr = $c6E1z.useRelatedProducts(productId, match$2.transitiveStoreId, categoryId, hideOutOfStock, true, match$3.smartnavApiHost, match$3.market, undefined);
    var match$4 = $7xAyC.getPageInfo(swr, function(page) {
        return page.page.next;
    }, function(page) {
        return page.products;
    });
    var setSize = match$4.setSize;
    var size = match$4.size;
    var error = swr.error;
    var products = $2whNH.getWithDefault(match$4.contents, []);
    var previousProducts = $3QSSt.usePreviousDistinct(products);
    var products$1 = products.length === 0 ? previousProducts : products;
    $g85JO.useEffect(function() {
        if (products$1.length !== 0) {
            var newrecord = $7bjme.obj_dup($ij6do.empty);
            $gFKzh.trackRetargeting(account, configId, (newrecord.title = "Related Products", newrecord.id = "related-products", newrecord), undefined, undefined, isMobile, undefined, undefined, undefined, products$1, undefined, "view_item_list");
        }
    }, [
        $i7mYY.joinWith(products$1, "|", function(p) {
            return p.id;
        })
    ]);
    var lastPageRef = $g85JO.useRef(null);
    var match$5 = $iJp5F.use(lastPageRef, viewport, undefined, [
        0.5
    ], undefined, undefined, undefined, undefined);
    var isIntersecting = match$5.isIntersecting;
    var loadedAll = match$4.numLoadedPages >= size;
    $g85JO.useEffect(function() {
        if (isIntersecting && loadedAll) $iv6Yc._1(setSize, size + 1 | 0);
    }, [
        isIntersecting,
        loadedAll,
        setSize,
        size
    ]);
    var loading = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !match$4.reachedEnd && error === undefined,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(lastPageRef),
            className: $ezf3v.prefix("h-12 text-center flex items-center justify-center")
        }, "Loading more products...")
    });
    return /*#__PURE__*/ $g85JO.createElement("div", undefined, $iv6Yc._1(render, products$1), loading);
}
$01842b28ba27ad01$var$RelatedProductsContent.displayName = "RelatedProductsContent";
var $01842b28ba27ad01$export$dd44f18ab656f3bb = $01842b28ba27ad01$var$RelatedProductsContent;
 /* react Not a pure module */ 
});


parcelRegister("1M10O", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $14ab0f1d8c7f0bcd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $dJcSN = parcelRequire("dJcSN");

var $8dLtV = parcelRequire("8dLtV");

var $239BR = parcelRequire("239BR");

var $insiF = parcelRequire("insiF");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $1t9ha = parcelRequire("1t9ha");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $9JqU1 = parcelRequire("9JqU1");

var $2ZaET = parcelRequire("2ZaET");

var $8E2YL = parcelRequire("8E2YL");

var $upPgm = parcelRequire("upPgm");
function $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$BlurBg(Props) {
    var medias = Props.medias;
    var src = $2whNH.flatMap($i7mYY.get(medias, 0), $7KlbQ.Media.getImageUrlWithPosterFallback);
    var tmp = {};
    if (src !== undefined) tmp.src = $loT9g.valFromOption(src);
    return /*#__PURE__*/ $g85JO.createElement($55MCT.ColorOverlay.make, tmp);
}
$14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$BlurBg.displayName = "DesktopPhotoSlider.BlurBg";
var $14ab0f1d8c7f0bcd$export$734182267fabccfa = {
    make: $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$BlurBg
};
function $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem(Props) {
    var idxOpt = Props.idx;
    var enterZoom = Props.enterZoom;
    var renderChildren = Props.renderChildren;
    var zoomRequireOpt = Props.zoomRequire;
    var idx = idxOpt !== undefined ? idxOpt : 0;
    var zoomRequire = zoomRequireOpt !== undefined ? zoomRequireOpt : true;
    var parentRef = $g85JO.useRef(null);
    var baseClassName = $ezf3v.prefix($1TRFX.make([
        "flex items-center justify-center h-full w-full overflow-hidden relative transition-opacity duration-300"
    ]));
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(parentRef),
        className: baseClassName
    }, /*#__PURE__*/ $g85JO.createElement($dJcSN.make, {
        children: /*#__PURE__*/ $g85JO.createElement($239BR.make, {
            render: function render(priority) {
                return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                    dataTestId: "pdp-photo",
                    children: /*#__PURE__*/ $g85JO.createElement("div", {
                        className: $ezf3v.prefix($1TRFX.make([
                            zoomRequire ? "cursor-zoom-in" : "cursor-default",
                            "absolute inset-0"
                        ])),
                        onClick: function onClick(param) {
                            if (zoomRequire) return $iv6Yc._1(enterZoom, idx);
                        }
                    }, $iv6Yc._1(renderChildren, priority))
                });
            }
        })
    }));
}
$14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem.displayName = "DesktopPhotoSlider.SliderItem";
var $14ab0f1d8c7f0bcd$export$cf4a8ea79696f33c = {
    make: $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem
};
function $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider(Props) {
    var product = Props.product;
    var variantId = Props.variantId;
    var medias = Props.medias;
    var viewport = Props.viewport;
    var onPhotoZoomed = Props.onPhotoZoomed;
    var onSlideChange = Props.onSlideChange;
    var onClickThumbnail = Props.onClickThumbnail;
    var zoomOpt = Props.zoom;
    var bgBlurOpt = Props.bgBlur;
    var thumbnailsPositionOpt = Props.thumbnailsPosition;
    var selectedIndex = Props.selectedIndex;
    var zoomRequireOpt = Props.zoomRequire;
    var zoom = zoomOpt !== undefined ? zoomOpt : true;
    var bgBlur = bgBlurOpt !== undefined ? bgBlurOpt : true;
    var thumbnailsPosition = thumbnailsPositionOpt !== undefined ? thumbnailsPositionOpt : "bottom";
    var zoomRequire = zoomRequireOpt !== undefined ? zoomRequireOpt : true;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var match$2 = $g85JO.useState(function() {
        return 0;
    });
    var setCurrentSlide = match$2[1];
    var currentSlide = match$2[0];
    var match$3 = $g85JO.useState(function() {
        return $2whNH.getWithDefault(selectedIndex, -1);
    });
    var setSlideToIndex = match$3[1];
    var match$4 = $hBcYV.useRouter(undefined);
    var route = match$4.route;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setSlideToIndex, function(param) {
            return $2whNH.getWithDefault(selectedIndex, -1);
        });
    }, [
        selectedIndex
    ]);
    var items = $i7mYY.mapWithIndex(medias, function(idx, item) {
        var active = $7bjme.equal(idx, currentSlide);
        switch(item.TAG | 0){
            case /* Image */ 0:
                var url = item._0.url;
                return /*#__PURE__*/ $g85JO.createElement($14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem, {
                    idx: idx,
                    enterZoom: function enterZoom(i) {
                        $iv6Yc._1(onPhotoZoomed, i);
                    },
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(priority) {
                        return /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                            src: url,
                            fit: /* ScaleDown */ 0,
                            priority: active ? 0 : priority
                        });
                    },
                    zoomRequire: zoomRequire,
                    key: variantId
                });
            case /* Video */ 1:
                var video = item._0;
                var src = $2whNH.map($7KlbQ.getVideoSource(video), function(source) {
                    return source.url;
                });
                if (src !== undefined) return /*#__PURE__*/ $g85JO.createElement($14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem, {
                    idx: idx,
                    enterZoom: function enterZoom(i) {
                        $iv6Yc._1(onPhotoZoomed, i);
                    },
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(param) {
                        var tmp = {
                            src: src,
                            viewport: viewport,
                            objectFit: "contain",
                            prioritize: true,
                            autoplay: settings.videoAutoPlay,
                            loop: settings.videoLoop,
                            muted: settings.videoMute,
                            controls: settings.videoControls,
                            key: variantId
                        };
                        if (video.posterUrl !== undefined) tmp.poster = video.posterUrl;
                        return /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp);
                    },
                    zoomRequire: zoomRequire,
                    key: variantId
                });
                else return null;
            case /* IframeEmbed */ 2:
                var url$1 = item._0.url;
                return /*#__PURE__*/ $g85JO.createElement($14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$SliderItem, {
                    idx: idx,
                    enterZoom: function enterZoom(i) {
                        $iv6Yc._1(onPhotoZoomed, i);
                    },
                    viewport: viewport,
                    active: active,
                    renderChildren: function renderChildren(param) {
                        return /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                            url: url$1
                        });
                    },
                    zoomRequire: zoomRequire,
                    key: variantId
                });
        }
    });
    var onSlideChange$1 = function onSlideChange$1(e) {
        $iv6Yc._1(setCurrentSlide, function(param) {
            return e.activeIndex;
        });
        $iv6Yc._1(setSlideToIndex, function(param) {
            return -1;
        });
        $iv6Yc._1(onSlideChange, undefined);
    };
    var match$5 = settings.pdpGalleryCustomAction;
    var tmp = {
        medias: medias,
        setSlideToIndex: setSlideToIndex,
        onClickThumbnail: onClickThumbnail,
        visibility: match$5 !== undefined ? "always" : "hover",
        product: product,
        variantId: variantId
    };
    if (currentSlide !== undefined) tmp.currentSlide = $loT9g.valFromOption(currentSlide);
    var tmp$1;
    if (zoom && !(typeof route === "number" || route.TAG !== /* PDP */ 2)) {
        var zoomedPhotoIndex = route._0.zoomedPhotoIndex;
        if ($2whNH.isSome(zoomedPhotoIndex)) {
            var tmp$2 = {
                product: product,
                variantId: variantId,
                medias: medias,
                viewport: viewport,
                onSlideChange: onSlideChange$1,
                onClickThumbnail: onClickThumbnail,
                bgBlur: false,
                thumbnailsPosition: "center",
                onClose: function onClose(param) {
                    $iv6Yc._1(onPhotoZoomed, undefined);
                },
                onPhotoZoomed: onPhotoZoomed
            };
            if (zoomedPhotoIndex !== undefined) tmp$2.selectedIndex = $loT9g.valFromOption(zoomedPhotoIndex);
            tmp$1 = /*#__PURE__*/ $g85JO.createElement($9JqU1.make, tmp$2);
        } else tmp$1 = null;
    } else tmp$1 = null;
    var content = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 overflow-hidden group"),
        style: {
            backgroundColor: settings.pdpGalleryBGColor
        }
    }, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: bgBlur && settings.pdpGalleryBGBlur,
        children: /*#__PURE__*/ $g85JO.createElement($14ab0f1d8c7f0bcd$var$DesktopPhotoSlider$BlurBg, {
            medias: medias,
            needsBorderRadius: settings.smartbarEnabled && !match$1.isMobile
        })
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0")
    }, /*#__PURE__*/ $g85JO.createElement($insiF.make, {
        items: items,
        spaceBetween: 12,
        slidesPerView: /* Float */ {
            _0: 1.1
        },
        direction: "vertical",
        enableFreeMode: true,
        centeredSlides: true,
        autoHeight: true,
        slideToIndex: match$3[0],
        allowTouchMove: medias.length > 1,
        enableScrollbar: medias.length > 1,
        hideScrollbar: true,
        enableMousewheel: true,
        className: $ezf3v.prefix("absolute inset-0"),
        onSlideChange: onSlideChange$1,
        restorationId: "pdp-photo-slider",
        key: variantId
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute",
            thumbnailsPosition === "center" ? "top-1/2 left-0 pl-8" : "bottom-0 right-0 pb-8 pr-8"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($upPgm.make, tmp)), tmp$1);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 overflow-hidden")
    }, content);
}
$14ab0f1d8c7f0bcd$var$DesktopPhotoSlider.displayName = "DesktopPhotoSlider";
var $14ab0f1d8c7f0bcd$export$dd44f18ab656f3bb = $14ab0f1d8c7f0bcd$var$DesktopPhotoSlider;
 /* react Not a pure module */ 
});


parcelRegister("hO3nk", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cf69b973fcd96f05$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $cf69b973fcd96f05$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("33EHy"));
});
function $cf69b973fcd96f05$var$LauncherApp_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($cf69b973fcd96f05$var$component, Props);
}
$cf69b973fcd96f05$var$LauncherApp_Lazy.displayName = "LauncherApp_Lazy";
var $cf69b973fcd96f05$export$dd44f18ab656f3bb = $cf69b973fcd96f05$var$LauncherApp_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("33EHy", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9UnI4")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6BNlF")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("heMtg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aVOcH")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("hI3Yy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("5Jza1"))
]).then(function() {
    return parcelRequire("4jlPh");
});

});
parcelRegister("isbc1", function(module, exports) {
"use strict";

var $7J4BA = parcelRequire("7J4BA");
module.exports = $7J4BA(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7J4BA", function(module, exports) {
"use strict";
var $5a004edf52e5b33a$var$cachedBundles = {};
var $5a004edf52e5b33a$var$cachedPreloads = {};
var $5a004edf52e5b33a$var$cachedPrefetches = {};
function $5a004edf52e5b33a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5a004edf52e5b33a$var$cachedPreloads;
        case "prefetch":
            return $5a004edf52e5b33a$var$cachedPrefetches;
        default:
            return $5a004edf52e5b33a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5a004edf52e5b33a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("7wgKE", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $579884101b2e33e1$export$6503ec6e8aabbaf; }, function (v) { return $579884101b2e33e1$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $579884101b2e33e1$export$f7ad0328861e2f03; }, function (v) { return $579884101b2e33e1$export$f7ad0328861e2f03 = v; });
var $579884101b2e33e1$export$6503ec6e8aabbaf;
var $579884101b2e33e1$export$f7ad0328861e2f03;
"use strict";
var $579884101b2e33e1$var$mapping = new Map();
function $579884101b2e33e1$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$579884101b2e33e1$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $579884101b2e33e1$var$resolve(id) {
    var resolved = $579884101b2e33e1$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$579884101b2e33e1$export$6503ec6e8aabbaf = $579884101b2e33e1$var$register;
$579884101b2e33e1$export$f7ad0328861e2f03 = $579884101b2e33e1$var$resolve;

});



parcelRegister("cZrFr", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9750a4b65f4b7170$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $d8lRc = parcelRequire("d8lRc");

var $2Ng4w = parcelRequire("2Ng4w");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $58Tj9 = parcelRequire("58Tj9");

var $b5sXm = parcelRequire("b5sXm");

var $7KlbQ = parcelRequire("7KlbQ");

var $kq2hG = parcelRequire("kq2hG");

var $8iMy9 = parcelRequire("8iMy9");

var $55MCT = parcelRequire("55MCT");

var $bygWp = parcelRequire("bygWp");

var $90LTg = parcelRequire("90LTg");

var $g0DOt = parcelRequire("g0DOt");

var $38gYA = parcelRequire("38gYA");

var $fvE4w = parcelRequire("fvE4w");

var $gSw5h = parcelRequire("gSw5h");

var $8wpG4 = parcelRequire("8wpG4");

var $fCPBg = parcelRequire("fCPBg");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $gBkg7 = parcelRequire("gBkg7");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $fUtdg = parcelRequire("fUtdg");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $5YnL9 = parcelRequire("5YnL9");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $sK0FX = parcelRequire("sK0FX");

var $5CE1l = parcelRequire("5CE1l");

var $8E2YL = parcelRequire("8E2YL");

var $upPgm = parcelRequire("upPgm");

var $gUsPc = parcelRequire("gUsPc");
function $9750a4b65f4b7170$var$PDPContentMobile$ColorVariants(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setShow = match$1[1];
    var show = match$1[0];
    var match$2 = $9pMGg.use(undefined);
    var trackEvent = match$2.trackEvent;
    var handleStackClick = function handleStackClick(e) {
        $iv6Yc.app(trackEvent, [
            "mobile pdp:clicked see more color options",
            undefined,
            undefined,
            product,
            variant,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        e.preventDefault();
        e.stopPropagation();
        $iv6Yc._1(setShow, function(show) {
            return !show;
        });
    };
    var getColorVariant = function getColorVariant(color) {
        return $i7mYY.getBy($7KlbQ.getAllVariants(product), function(v) {
            return $7bjme.equal(color, $7KlbQ.Variant.getOptionValue(v, "Color"));
        });
    };
    var colors = $i7mYY.keepMap($i7mYY.keepMap($7KlbQ.getOptionsByName(product, "Color"), function(color) {
        return getColorVariant(color.value);
    }), function(item) {
        var media = item.media;
        var color = $7KlbQ.Variant.getOptionValue(item, "Color");
        var image;
        switch(media.TAG | 0){
            case /* Image */ 0:
                image = media._0.url;
                break;
            case /* Video */ 1:
                image = $2whNH.map($7KlbQ.getVideoSource(media._0), function(source) {
                    return source.url;
                });
                break;
            case /* IframeEmbed */ 2:
                image = undefined;
                break;
        }
        if (color !== undefined && image !== undefined) return [
            color,
            image
        ];
    });
    var renderColorForStack = function renderColorForStack(titleOpt, linkOpt, color, image, width, height, param) {
        var title = titleOpt !== undefined ? titleOpt : false;
        var link = linkOpt !== undefined ? linkOpt : false;
        var containerWidth = title ? width + 12 | 0 : width;
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "pdp-button-color",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "bg-white relative border-px border-white border-solid",
                    title ? "p-2" : ""
                ])),
                style: {
                    width: String(containerWidth) + "px"
                },
                onClick: function onClick(param) {
                    var variant = getColorVariant(color);
                    if (typeof route === "number" || !(route.TAG === /* PDP */ 2 && variant !== undefined && link)) return;
                    else return $iv6Yc._3(goTo, undefined, true, {
                        TAG: /* PDP */ 2,
                        _0: {
                            categoryId: route._0.categoryId,
                            productCategoryId: product.categoryId,
                            productId: product.id,
                            variantId: variant.id,
                            zoomedPhotoIndex: undefined
                        }
                    });
                }
            }, /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                src: image,
                containerWidth: width,
                containerHeight: height,
                fit: /* Cover */ 1,
                priority: 0
            }), title ? /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("text-center text-lg text-black py-2")
            }, color) : null)
        });
    };
    if (colors.length <= 1) return null;
    else return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute right-0 pr-5"),
        style: {
            bottom: "66px",
            width: "68px"
        }
    }, show ? null : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute"),
        style: {
            top: "-58px"
        }
    }, /*#__PURE__*/ $g85JO.createElement($b5sXm.make, {
        maxThumbnails: 3,
        items: $i7mYY.map($58Tj9.stableSortBy(colors, function(param, b) {
            if ($7bjme.equal(param[0], $7KlbQ.Variant.getOptionValue(variant, "Color"))) return -1;
            else return 1;
        }), function(param) {
            var image = param[1];
            var color = param[0];
            return [
                color,
                function(param) {
                    return renderColorForStack(undefined, undefined, color, image, 33, 33, param);
                },
                function(param) {
                    $iv6Yc._1(setShow, function(show) {
                        return !show;
                    });
                }
            ];
        }),
        direction: /* Fan */ 2,
        width: 33,
        height: 33
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("text-white font-medium text-center text-lg drop-shadow"),
        onClick: handleStackClick
    }, "More Colors")), show ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("fixed inset-0"),
        style: {
            zIndex: "2147483647"
        },
        onClick: handleStackClick
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute right-0 overflow-x-auto flex gap-2 pr-2 pb-2"),
        style: {
            bottom: "108px",
            maxWidth: "calc(100vw - 82px)"
        },
        onTouchEnd: function onTouchEnd(e) {
            e.stopPropagation();
        },
        onTouchMove: function onTouchMove(e) {
            e.stopPropagation();
        },
        onTouchStart: function onTouchStart(e) {
            e.stopPropagation();
        }
    }, $i7mYY.map(colors, function(param) {
        return renderColorForStack(true, true, param[0], param[1], 90, 90, undefined);
    }))) : null);
}
$9750a4b65f4b7170$var$PDPContentMobile$ColorVariants.displayName = "PDPContentMobile.ColorVariants";
var $9750a4b65f4b7170$export$a604db21b1043c5f = {
    make: $9750a4b65f4b7170$var$PDPContentMobile$ColorVariants
};
function $9750a4b65f4b7170$var$PDPContentMobile$ProductSlide(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var productPositionOpt = Props.productPosition;
    var productsCountOpt = Props.productsCount;
    var productCategory = Props.productCategory;
    var scrollToDetails = Props.scrollToDetails;
    var selectedSlideOpt = Props.selectedSlide;
    var visibleOpt = Props.visible;
    var isInsideQuickView = Props.isInsideQuickView;
    var productPosition = productPositionOpt !== undefined ? productPositionOpt : 0;
    var productsCount = productsCountOpt !== undefined ? productsCountOpt : 0;
    var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : true;
    var visible = visibleOpt !== undefined ? visibleOpt : true;
    var store = $8L1B1.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var match$1 = $9pMGg.use(undefined);
    var onBackClick = match$1.onBackClick;
    var onOpenLink = match$1.onOpenLink;
    var trackEvent = match$1.trackEvent;
    var match$2 = $8E2YL.use(undefined);
    var config = match$2.config;
    var hideAddToCartButton = $2whNH.mapWithDefault($2whNH.flatMap(config.transitiveAccount, function(account) {
        return account.productRules.hideAddToCartButton;
    }), false, function(rule) {
        return $5CE1l.matchesProduct(rule, product, variant);
    });
    var match$3 = $g85JO.useState(function() {
        return 0;
    });
    var setCurrentSlide = match$3[1];
    var currentSlide = match$3[0];
    var handleChange = $g85JO.useCallback(function(nextValue) {
        $iv6Yc._1(setCurrentSlide, function(param) {
            return nextValue;
        });
    }, [
        setCurrentSlide
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setCurrentSlide, function(param) {
            return 0;
        });
    }, [
        variant.id
    ]);
    var hideMediaFromOtherVariants = $2whNH.mapWithDefault(config.transitiveAccount, false, function(account) {
        return account.pdpHideMediaFromOtherVariants;
    });
    var medias = $g85JO.useMemo(function() {
        return $7KlbQ.getAllVariantMedia(hideMediaFromOtherVariants, product, variant);
    }, [
        variant.id,
        product.id
    ]);
    var title;
    if (listPageType !== undefined && typeof listPageType === "number") switch(listPageType){
        case /* Favorites */ 0:
            title = "Favorites";
            break;
        case /* History */ 1:
            title = "Recently Viewed";
            break;
        case /* StoreCart */ 2:
            title = productCategory.title;
            break;
    }
    else title = productCategory.title;
    var renderOpenLinkButton = function renderOpenLinkButton(param) {
        return /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex items-center justify-center flex-col bg-white",
                "text-lg text-center text-black font-semibold drop-shadow-sm cursor-pointer"
            ])),
            style: {
                height: "46px",
                lineHeight: "46px",
                maxWidth: "calc(100vw - (54px + 28px) * 2)",
                width: "250px"
            },
            onClick: function onClick(param) {
                $iv6Yc._5(onOpenLink, productCategory, undefined, product, variant, undefined);
            }
        }, config.settings.pdpOpenLinkLabel);
    };
    var renderBuyNowButton = function renderBuyNowButton(param) {
        return /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex items-center justify-center flex-col bg-white",
                "text-lg text-center text-black font-semibold drop-shadow-sm cursor-pointer"
            ])),
            style: {
                height: "46px",
                lineHeight: "46px",
                maxWidth: "calc(100vw - (54px + 28px) * 2)",
                width: "250px"
            },
            onClick: function onClick(param) {
                $iv6Yc.app(trackEvent, [
                    "mobile pdp:clicked main cta btn",
                    undefined,
                    undefined,
                    product,
                    variant,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
                $iv6Yc._1(scrollToDetails, undefined);
            }
        }, config.settings.newMobilePDPCtaLabel);
    };
    var tmp;
    var exit = 0;
    if (title === "" && productsCount === 0) tmp = "";
    else exit = 1;
    if (exit === 1) tmp = productsCount !== 0 ? title + " " + String(productPosition) + "/" + String(productsCount) : title;
    var summary = product.reviewSummary;
    var match$4 = config.settings.pdpCTAButtons;
    var match$5 = match$4[0];
    var tmp$1;
    if (match$5 === "open_link") tmp$1 = renderOpenLinkButton(undefined);
    else if (match$5 === "add_to_cart") {
        var match$6 = match$4[1];
        tmp$1 = match$6 !== undefined && match$6 === "open_link" && hideAddToCartButton ? renderOpenLinkButton(undefined) : renderBuyNowButton(undefined);
    } else tmp$1 = renderBuyNowButton(undefined);
    var tmp$2;
    if (medias.length > 1) {
        var bottom = medias.length <= 3 ? 58 : 62;
        tmp$2 = /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute left-0 pl-5"),
            style: {
                bottom: String(bottom) + "px"
            }
        }, /*#__PURE__*/ $g85JO.createElement($upPgm.make, {
            medias: medias,
            currentSlide: currentSlide,
            setSlideToIndex: setCurrentSlide,
            onClickThumbnail: function onClickThumbnail(param) {},
            maxSlidesPerViewport: 3.2,
            product: product,
            variantId: variant.id
        }));
    } else tmp$2 = null;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 bg-main no-flicker")
    }, /*#__PURE__*/ $g85JO.createElement($gSw5h.make, {
        product: product,
        variant: variant,
        settings: config.settings,
        selectedSlide: selectedSlide,
        visible: visible,
        onChange: handleChange,
        currentSlide: currentSlide,
        children: null
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute w-full top-10 left-0 px-6 no-flicker text-white")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("grid grid-cols-12 grid-rows-1 gap-1 justify-between items-start")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("text-white flex items-start col-span-11")
    }, tmp), match$1.embedType !== /* ProductDetailsPage */ 5 || isInsideQuickView ? /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-button-open-close",
        children: /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute -top-4 right-1",
                "border-none bg-transparent",
                "w-14 h-14",
                "text-white flex items-center justify-center"
            ])),
            onClick: function onClick(param) {
                $iv6Yc._1(onBackClick, undefined);
            }
        }, /*#__PURE__*/ $g85JO.createElement($90LTg.make, {
            className: $ezf3v.prefix("cursor-pointer")
        }))
    }) : null), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex gap-2 justify-between items-start")
    }, /*#__PURE__*/ $g85JO.createElement("div", undefined, /*#__PURE__*/ $g85JO.createElement($gBkg7.make, {
        className: $ezf3v.prefix("mt-2"),
        dataTestId: "pdp-product-badges",
        product: product,
        variant: variant
    }), /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-product-title",
        children: /*#__PURE__*/ $g85JO.createElement("h1", {
            className: $ezf3v.prefix("text-xl font-bold drop-shadow-sm text-white mt-3 mb-1")
        }, $7KlbQ.getDisplayName(store, variant, product))
    }), /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
        at: /* PDP */ 0,
        product: product,
        variant: variant,
        size: /* Md */ 1,
        labelsEnabled: false,
        minPriceFirst: true,
        multiline: false,
        textColor: "text-white"
    })), summary !== undefined ? /*#__PURE__*/ $g85JO.createElement($fUtdg.make, {
        at: /* PDP */ 0,
        product: product,
        variant: variant,
        className: $ezf3v.prefix("mt-4"),
        countClassName: $ezf3v.prefix("text-white"),
        largeCount: true
    }) : null)), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute bottom-0 left-0 pb-3 w-full",
            "flex items-center justify-center flex-col gap-6",
            "no-flicker"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-button-buy-now",
        children: tmp$1
    }), /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-button-product-details",
        children: /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "border-none bg-transparent",
                "flex items-center justify-center flex-col",
                "text-lg text-center text-white font-semibold drop-shadow-sm cursor-pointer"
            ])),
            onClick: function onClick(param) {
                $iv6Yc.app(trackEvent, [
                    "mobile pdp:clicked view details btn",
                    undefined,
                    undefined,
                    product,
                    variant,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
                $iv6Yc._1(scrollToDetails, undefined);
            }
        }, /*#__PURE__*/ $g85JO.createElement("span", {
            className: $ezf3v.prefix("text-white")
        }, "Product Details"), /*#__PURE__*/ $g85JO.createElement($kq2hG.make, {}))
    })), tmp$2, /*#__PURE__*/ $g85JO.createElement($9750a4b65f4b7170$var$PDPContentMobile$ColorVariants, {
        product: product,
        variant: variant
    })));
}
$9750a4b65f4b7170$var$PDPContentMobile$ProductSlide.displayName = "PDPContentMobile.ProductSlide";
var $9750a4b65f4b7170$var$make = /*#__PURE__*/ $g85JO.memo($9750a4b65f4b7170$var$PDPContentMobile$ProductSlide);
var $9750a4b65f4b7170$export$93c020ceac354304 = {
    make: $9750a4b65f4b7170$var$make
};
function $9750a4b65f4b7170$var$PDPContentMobile$ProductDetails(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var isInsideQuickView = Props.isInsideQuickView;
    var productCategory = Props.productCategory;
    var shouldForceMobile = Props.shouldForceMobile;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var scrollToTop = Props.scrollToTop;
    var scrollToDetails = Props.scrollToDetails;
    var detailsVisibleFirstFold = Props.detailsVisibleFirstFold;
    var detailsVisibleSecondFold = Props.detailsVisibleSecondFold;
    var windowHeight = Props.windowHeight;
    var showMoreProducts = Props.showMoreProducts;
    var scrollToDetailsRef = $g85JO.useRef(scrollToDetails);
    var match = $g85JO.useState(function() {
        return /* Visible */ 3;
    });
    var setCtaVisible = match[1];
    var handleCTAVisibilityChange = $g85JO.useCallback(function(visibility) {
        $iv6Yc._1(setCtaVisible, function(param) {
            return visibility;
        });
    }, [
        setCtaVisible
    ]);
    var showRelatedProducts = detailsVisibleFirstFold || detailsVisibleSecondFold;
    var tmp = {
        product: product,
        variant: variant,
        productCategory: productCategory,
        shouldForceMobile: shouldForceMobile,
        isInsideQuickView: isInsideQuickView,
        scrollableContainerRef: scrollableContainerRef,
        scrollToDetailsRef: scrollToDetailsRef,
        showHeader: false,
        collapsible: false,
        titleStyle: "normal",
        largeTitleStyle: "medium",
        optionSize: /* Md */ 2,
        optionStyle: /* Border */ 0,
        colorOptionSize: /* Xxl */ 5,
        hideRelatedProductId: product.id,
        showRelatedProducts: showRelatedProducts,
        descriptionLayout: /* Accordion */ 1,
        onCTAButtonVisibilityChange: handleCTAVisibilityChange,
        stickyCTA: false
    };
    if (showMoreProducts !== undefined) tmp.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($5YnL9.make, {
        product: product,
        variant: variant,
        scrollToDetails: scrollToDetails,
        scrollableContainerRef: scrollableContainerRef,
        position: /* StickyTop */ 1,
        shadow: false,
        showCTA: match[0] === /* HiddenBottom */ 1 || detailsVisibleSecondFold,
        allowTitleWrap: true,
        onBackClick: function onBackClick(param) {
            $iv6Yc._1(scrollToTop, undefined);
        }
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.Delayed.make, {
        delayMs: 300,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("mt-6"),
            style: {
                minHeight: String(windowHeight - ($5YnL9.stickyHeight - 22 | 0) | 0) + "px"
            }
        }, /*#__PURE__*/ $g85JO.createElement($sK0FX.make, tmp))
    }));
}
$9750a4b65f4b7170$var$PDPContentMobile$ProductDetails.displayName = "PDPContentMobile.ProductDetails";
var $9750a4b65f4b7170$var$make$1 = /*#__PURE__*/ $g85JO.memo($9750a4b65f4b7170$var$PDPContentMobile$ProductDetails);
var $9750a4b65f4b7170$export$dc961174b5c26c1f = {
    make: $9750a4b65f4b7170$var$make$1
};
function $9750a4b65f4b7170$var$PDPContentMobile$Slider(Props) {
    var selectedSlideOpt = Props.selectedSlide;
    var windowHeight = Props.windowHeight;
    var goToSlide = Props.goToSlide;
    var children = Props.children;
    var preventScroll = Props.preventScroll;
    var animationOpt = Props.animation;
    var animateOpt = Props.animate;
    var showIntroAnimationOpt = Props.showIntroAnimation;
    var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : 0;
    var animation = animationOpt !== undefined ? animationOpt : /* Slide */ 0;
    var animate = animateOpt !== undefined ? animateOpt : true;
    var showIntroAnimation = showIntroAnimationOpt !== undefined ? showIntroAnimationOpt : false;
    $9pMGg.use(undefined);
    var match = $aSJcu.use(undefined);
    var windowWidth = match.windowSize.width;
    var match$1 = $g85JO.useState(function() {
        return selectedSlide;
    });
    var setInternalSelectedSlide = match$1[1];
    var internalSelectedSlide = match$1[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setInternalSelectedSlide, function(param) {
            return selectedSlide;
        });
    }, [
        selectedSlide
    ]);
    var match$2 = $g85JO.useState(function() {
        return /* NotSwiping */ 0;
    });
    var setSwipe = match$2[1];
    var swipe = match$2[0];
    var handleMouseDown = function handleMouseDown($$event) {
        var x = $$event.clientX;
        var y = $$event.clientY;
        $iv6Yc._1(setSwipe, function(param) {
            return /* Swiping */ {
                _0: x,
                _1: y,
                _2: 0
            };
        });
    };
    var handleTouchDown = function handleTouchDown($$event) {
        var x = $$event.touches[0].clientX;
        var y = $$event.touches[0].clientY;
        $iv6Yc._1(setSwipe, function(param) {
            return /* Swiping */ {
                _0: x,
                _1: y,
                _2: 0
            };
        });
    };
    var handleMove = function handleMove(positionX, positionY) {
        if (!swipe) return;
        var y = swipe._1;
        var x = swipe._0;
        var diffX = x - positionX | 0;
        var diffY = y - positionY | 0;
        var isSignificantMovement = (Math.imul(diffX, diffX) + Math.imul(diffY, diffY) | 0) >= 25;
        var touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180.0 / Math.PI;
        var edgeSwipe = x < 20 || (windowWidth - x | 0) < 20;
        var reachedEnd = internalSelectedSlide === (children.length - 1 | 0);
        var match = touchAngle < 45;
        if (isSignificantMovement) {
            if (match) {
                if (!edgeSwipe) {
                    if (diffX > 0 && !reachedEnd) return $iv6Yc._1(setSwipe, function(param) {
                        return /* Swiping */ {
                            _0: x,
                            _1: y,
                            _2: diffX
                        };
                    });
                    else if (diffX < 0 && internalSelectedSlide !== 0) return $iv6Yc._1(setSwipe, function(param) {
                        return /* Swiping */ {
                            _0: x,
                            _1: y,
                            _2: diffX
                        };
                    });
                    else return;
                }
                if (!edgeSwipe) return;
            }
        } else if (!edgeSwipe) return;
        $iv6Yc._1(setSwipe, function(param) {
            return /* NotSwiping */ 0;
        });
    };
    var handleMouseMove = function handleMouseMove($$event) {
        handleMove($$event.clientX, $$event.clientY);
    };
    var handleTouchMove = function handleTouchMove($$event) {
        handleMove($$event.touches[0].clientX, $$event.touches[0].clientY);
    };
    var handleMouseUp = function handleMouseUp(e) {
        if (!swipe) return;
        var diff = swipe._2;
        var direction = diff < -10 ? -1 : diff > 10 ? 1 : 0;
        var nextSlideIndex;
        switch(direction){
            case -1:
                nextSlideIndex = internalSelectedSlide - 1 | 0;
                break;
            case 0:
                nextSlideIndex = undefined;
                break;
            case 1:
                nextSlideIndex = internalSelectedSlide + 1 | 0;
                break;
            default:
                nextSlideIndex = undefined;
        }
        var nextSlide = $i7mYY.get(children, $2whNH.getWithDefault(nextSlideIndex, internalSelectedSlide));
        if (nextSlideIndex !== undefined && nextSlide !== undefined) {
            $iv6Yc._1(setInternalSelectedSlide, function(param) {
                return nextSlideIndex;
            });
            $iv6Yc._1(goToSlide, nextSlideIndex);
        }
        $iv6Yc._1(setSwipe, function(param) {
            return /* NotSwiping */ 0;
        });
        $iv6Yc._1(preventScroll, false);
    };
    var match$3;
    if (animation) {
        var transformZ = windowWidth / 2;
        var rotate = Math.imul(internalSelectedSlide, 90);
        var exit = 0;
        if (swipe) {
            var diff = swipe._2;
            if (diff > 10 || diff < -10) {
                var rotate$1 = rotate + (diff / windowWidth * 90 | 0) | 0;
                match$3 = [
                    0,
                    transformZ,
                    rotate$1,
                    ""
                ];
            } else exit = 1;
        } else exit = 1;
        if (exit === 1) match$3 = animate ? [
            0,
            transformZ,
            rotate,
            "transform 0.3s"
        ] : [
            0,
            transformZ,
            rotate,
            ""
        ];
    } else {
        var transformX = Math.imul(internalSelectedSlide, windowWidth);
        var exit$1 = 0;
        if (swipe) {
            var diff$1 = swipe._2;
            if (diff$1 > 10 || diff$1 < -10) {
                var transformX$1 = transformX + diff$1 | 0;
                match$3 = [
                    transformX$1,
                    0,
                    0,
                    ""
                ];
            } else exit$1 = 1;
        } else exit$1 = 1;
        if (exit$1 === 1) match$3 = animate ? [
            transformX,
            0,
            0,
            "transform 0.3s"
        ] : [
            transformX,
            0,
            0,
            ""
        ];
    }
    var rotate$2 = match$3[2];
    var transformZ$1 = match$3[1];
    var transformX$2 = match$3[0];
    var perspective = animation ? "600px" : "none";
    var transformStyle = animation ? "preserve-3d" : "flat";
    $g85JO.useEffect(function() {
        if (animation) $iv6Yc._1(preventScroll, rotate$2 % 90 !== 0);
        else $iv6Yc._1(preventScroll, $d8lRc.mod_(transformX$2, windowWidth) !== 0);
    }, [
        animation,
        transformX$2,
        rotate$2
    ]);
    var visibleSlides = $g85JO.useMemo(function() {
        return $i7mYY.keepMap($i7mYY.mapWithIndex(children, function(i, param) {
            return [
                i,
                param[0],
                param[1]
            ];
        }), function(param) {
            var id = param[1];
            var i = param[0];
            var visible = Math.abs(i - internalSelectedSlide | 0) <= 1;
            var result = visible ? [
                i,
                id,
                param[2]
            ] : [
                i,
                id,
                undefined
            ];
            if (animation && !visible) return;
            else return result;
        });
    }, [
        children,
        animation,
        internalSelectedSlide
    ]);
    var renderedChildren = $g85JO.useMemo(function() {
        return $i7mYY.map(visibleSlides, function(param) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: param[1],
                className: $ezf3v.prefix($1TRFX.make([
                    "h-full bg-white",
                    animation ? "absolute" : "relative",
                    "pdp-slider-item"
                ])),
                style: Object.assign({}, {
                    width: String(windowWidth) + "px"
                }, {
                    "--pdp-slider-item-index": String(param[0])
                })
            }, $2whNH.getWithDefault(param[2], null));
        });
    }, [
        visibleSlides,
        animation
    ]);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "sticky top-0 left-0 w-full h-full bg-black",
            showIntroAnimation ? "animate-nudge-left" : ""
        ])),
        style: {
            height: String(windowHeight) + "px",
            perspective: perspective
        },
        onMouseDown: handleMouseDown,
        onMouseMove: handleMouseMove,
        onMouseUp: handleMouseUp,
        onTouchEnd: handleMouseUp,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchDown
    }, /*#__PURE__*/ $g85JO.createElement("style", undefined, animation === /* Cube */ 1 ? ".QVTW__pdp-slider {\n        --pdp-slider-transform: translateZ(-" + String(transformZ$1) + "px) rotateY(-" + String(rotate$2) + "deg);\n      }" : ".QVTW__pdp-slider {\n        --pdp-slider-transform: translate3d(-" + String(transformX$2) + "px, 0, 0);\n      }", "\n      .QVTW__pdp-slider {\n        --pdp-slider-transform-style: " + transformStyle + ";\n        --pdp-slider-transition: " + match$3[3] + ";\n        --pdp-slider-width: " + (animation ? "100%" : String(Math.imul(windowWidth, children.length))) + "px;\n      }\n\n      " + (animation === /* Cube */ 1 ? ".QVTW__pdp-slider-item {\n        transform: rotateY(calc(var(--pdp-slider-item-index) * 90)deg) translateZ(" + String(transformZ$1) + 'px)";\n      }' : "") + "\n      "), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("pdp-slider h-full relative flex"),
        style: {
            width: "var(--pdp-slider-width, 0px)",
            transition: "var(--pdp-slider-transition, initial)",
            transform: "var(--pdp-slider-transform, initial)",
            transformStyle: "var(--pdp-slider-transform-style, initial)"
        }
    }, renderedChildren));
}
$9750a4b65f4b7170$var$PDPContentMobile$Slider.displayName = "PDPContentMobile.Slider";
var $9750a4b65f4b7170$var$make$2 = /*#__PURE__*/ $g85JO.memo($9750a4b65f4b7170$var$PDPContentMobile$Slider);
var $9750a4b65f4b7170$export$472062a354075cee = {
    horizontalThreshold: 10,
    make: $9750a4b65f4b7170$var$make$2
};
function $9750a4b65f4b7170$var$PDPContentMobile(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var productCategory = Props.productCategory;
    var config = Props.config;
    var shouldForceMobile = Props.shouldForceMobile;
    var settings = Props.settings;
    var isInsideQuickView = Props.isInsideQuickView;
    var routeProductId = Props.routeProductId;
    var routeVariantId = Props.routeVariantId;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var scrollToRef = Props.scrollToRef;
    var showMoreProducts = Props.showMoreProducts;
    var drawerState = $fvE4w.Provider.use(undefined);
    $8E2YL.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var embedType = match$1.embedType;
    var seenSlides = $g85JO.useRef([]);
    var windowHeight = $gUsPc.useAdjustedWindowHeight(undefined);
    var productDetailsContainerRef = $g85JO.useRef(null);
    var productChanged = $7bjme.notequal(product.id, routeProductId);
    var match$2 = productChanged ? [
        product.id,
        undefined
    ] : [
        routeProductId,
        routeVariantId
    ];
    var productId = match$2[0];
    var partial_arg = (0, $g0DOt.default)(function(nextPosition) {
        var isAlreadySeen = $i7mYY.some(seenSlides.current, function(storedPosition) {
            return storedPosition === nextPosition;
        });
        var previousPosition = $2whNH.getWithDefault($i7mYY.get(seenSlides.current, seenSlides.current.length - 1 | 0), 0);
        var direction = nextPosition > previousPosition ? 1 : -1;
        seenSlides.current = $i7mYY.concat(seenSlides.current, [
            nextPosition
        ]);
        var nextProduct = $i7mYY.get(config.slides, nextPosition);
        if (nextProduct === undefined) return;
        switch(nextProduct.TAG | 0){
            case /* Product */ 0:
                var variant = nextProduct.variant;
                var product = nextProduct.product;
                switch(direction){
                    case -1:
                        if (!isAlreadySeen) $iv6Yc.app(trackEvent, [
                            "mobile pdp:swiped previous product",
                            undefined,
                            undefined,
                            product,
                            variant,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined
                        ]);
                        break;
                    case 0:
                        break;
                    case 1:
                        if (!isAlreadySeen) $iv6Yc.app(trackEvent, [
                            "mobile pdp:swiped next product",
                            undefined,
                            undefined,
                            product,
                            variant,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined
                        ]);
                        break;
                    default:
                }
                if (typeof route !== "number") switch(route.TAG | 0){
                    case /* PDP */ 2:
                        var match = route._0;
                        return $iv6Yc._3(goTo, undefined, undefined, {
                            TAG: /* PDP */ 2,
                            _0: {
                                categoryId: match.categoryId,
                                productCategoryId: $2whNH.orElse(match.productCategoryId, productCategory.id),
                                productId: product.id,
                                variantId: undefined,
                                zoomedPhotoIndex: undefined
                            }
                        });
                    case /* QuickView */ 3:
                        var match$1 = route._0;
                        return $iv6Yc._3(goTo, undefined, undefined, {
                            TAG: /* QuickView */ 3,
                            _0: {
                                mediaId: match$1.mediaId,
                                mediaParentId: match$1.mediaParentId,
                                albumId: undefined,
                                productId: product.id,
                                relatedMediaProductIds: match$1.relatedMediaProductIds,
                                relatedMediaCategoryId: match$1.relatedMediaCategoryId,
                                variantId: undefined,
                                panelClosed: match$1.panelClosed,
                                zoomedPhotoIndex: undefined,
                                time: undefined
                            }
                        });
                    default:
                }
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: productCategory.id,
                        productCategoryId: productCategory.id,
                        productId: product.id,
                        variantId: undefined,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* Placeholder */ 1:
            case /* UnloadedProduct */ 2:
                return;
        }
    }, 500);
    var goToSlide = $g85JO.useCallback($iv6Yc.__1(partial_arg), [
        $8iMy9.getKey(config),
        $hBcYV.toString(route)
    ]);
    var match$3 = $g85JO.useState(function() {
        return false;
    });
    var setPreventScroll = match$3[1];
    var preventScroll = match$3[0];
    var match$4 = $g85JO.useState(function() {
        return /* Top */ 0;
    });
    var setScrollPosition = match$4[1];
    var scrollPosition = match$4[0];
    var handlePreventScroll = $g85JO.useCallback(function(prevent) {
        $iv6Yc._1(setPreventScroll, function(param) {
            return prevent;
        });
    }, []);
    var scrollToTop = $g85JO.useCallback(function(param) {
        $iv6Yc._1(scrollToRef.current, /* Top */ 0);
    }, []);
    var scrollToDetails = $g85JO.useCallback(function(param) {
        $2whNH.forEach($loT9g.nullable_to_opt(productDetailsContainerRef.current), function(el) {
            $iv6Yc._1(scrollToRef.current, {
                TAG: /* Element */ 0,
                _0: el
            });
        });
    }, []);
    var detailsVisibleFirstFold = scrollPosition === 1;
    var detailsVisibleSecondFold = typeof scrollPosition === "number" ? scrollPosition >= 2 : false;
    var handleScroll = $g85JO.useMemo(function() {
        return function(param, param$1) {
            var scrollTop = $2whNH.mapWithDefault($loT9g.nullable_to_opt(scrollableContainerRef.current), 0.0, function(el) {
                return el.scrollTop;
            }) | 0;
            var nextScrollPosition = scrollTop === 0 ? /* Top */ 0 : scrollTop > 0 && scrollTop < windowHeight ? /* InTransit */ {
                _0: scrollTop / windowHeight
            } : scrollTop >= windowHeight && scrollTop < windowHeight << 1 ? /* DetailsFirstFold */ 1 : /* DetailsSecondFold */ 2;
            return $iv6Yc._1(setScrollPosition, function(param) {
                return nextScrollPosition;
            });
        };
    }, [
        setScrollPosition
    ]);
    var renderMobileNavbar = function renderMobileNavbar(param) {
        var shouldRender = drawerState === /* Open */ 2 || isInsideQuickView;
        var showNavbar = shouldRender && embedType !== /* ProductDetailsPage */ 5;
        if (showNavbar) return /*#__PURE__*/ $g85JO.createElement($fCPBg.make, {
            position: /* Fixed */ 1,
            show: detailsVisibleFirstFold || detailsVisibleSecondFold,
            showSidebar: false,
            shadow: true,
            initiator: "pdp-mobile"
        });
        else return null;
    };
    var match$5 = $g85JO.useState(function() {
        return $2whNH.getWithDefault($2whNH.map($bygWp.getParam($bygWp.getCurrentUrl(undefined), "maker_pdp_intro"), $2Ng4w.bool_of_string), $2whNH.mapWithDefault($8wpG4.get(undefined, "pdpIntro"), true, function(value) {
            return value !== "true";
        }));
    });
    var showIntroAnimation = match$5[0];
    $g85JO.useEffect(function() {
        if (showIntroAnimation) $8wpG4.set(undefined, "pdpIntro", "true");
    }, [
        showIntroAnimation
    ]);
    var slides = $g85JO.useMemo(function() {
        return $i7mYY.mapWithIndex(config.slides, function(i, slide) {
            switch(slide.TAG | 0){
                case /* Product */ 0:
                    var product = slide.product;
                    if (i <= (config.position + 2 | 0) && i >= (config.position - 2 | 0)) return [
                        product.id,
                        $loT9g.some(/*#__PURE__*/ $g85JO.createElement($9750a4b65f4b7170$var$make, {
                            product: product,
                            variant: slide.variant,
                            productPosition: i + 1 | 0,
                            productsCount: config.total,
                            productCategory: productCategory,
                            scrollToDetails: scrollToDetails,
                            selectedSlide: $7bjme.equal(product.id, productId),
                            visible: typeof scrollPosition === "number" ? scrollPosition === 0 : scrollPosition._0 < 0.8,
                            isInsideQuickView: isInsideQuickView
                        }))
                    ];
                    else return [
                        product.id,
                        undefined
                    ];
                case /* Placeholder */ 1:
                case /* UnloadedProduct */ 2:
                    return [
                        slide.id,
                        undefined
                    ];
            }
        });
    }, [
        $8iMy9.getKey(config),
        productId,
        variant.id,
        productCategory.id,
        scrollToDetails,
        scrollPosition
    ]);
    var tmp;
    if (preventScroll) tmp = null;
    else {
        var tmp$1 = {
            product: product,
            variant: variant,
            isInsideQuickView: isInsideQuickView,
            productCategory: productCategory,
            shouldForceMobile: shouldForceMobile,
            scrollableContainerRef: scrollableContainerRef,
            scrollToTop: scrollToTop,
            scrollToDetails: scrollToDetails,
            detailsVisibleFirstFold: detailsVisibleFirstFold,
            detailsVisibleSecondFold: detailsVisibleSecondFold,
            windowHeight: windowHeight
        };
        if (showMoreProducts !== undefined) tmp$1.showMoreProducts = $loT9g.valFromOption(showMoreProducts);
        tmp = /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(productDetailsContainerRef),
            className: $ezf3v.prefix("relative smartnav-pdp__details bg-main rounded-custom"),
            style: {
                overflow: "clip"
            }
        }, /*#__PURE__*/ $g85JO.createElement($9750a4b65f4b7170$var$make$1, tmp$1));
    }
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
        restorationId: isInsideQuickView ? "qv-pdp" : "nav-pdp",
        scrollToRef: scrollToRef,
        onScroll: handleScroll,
        children: null,
        fwdRef: scrollableContainerRef,
        className: $ezf3v.prefix($1TRFX.make([
            "h-full bg-main text-primary",
            preventScroll ? "overflow-hidden" : "overflow-y-auto",
            showIntroAnimation ? "animate-nudge-up" : ""
        ])),
        rememberScrollPosition: false
    }, /*#__PURE__*/ $g85JO.createElement($9750a4b65f4b7170$var$make$2, {
        selectedSlide: config.position,
        windowHeight: windowHeight,
        goToSlide: goToSlide,
        children: slides,
        preventScroll: handlePreventScroll,
        animation: settings.newMobilePDPCube ? /* Cube */ 1 : /* Slide */ 0,
        animate: !productChanged,
        showIntroAnimation: showIntroAnimation
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 pointer-events-none transition duration-150"),
        style: {
            backgroundColor: "rgba(0,0,0," + (typeof scrollPosition === "number" ? scrollPosition !== 0 ? "0.75" : "0" : (scrollPosition._0 * 0.75).toString()) + ")"
        }
    }), tmp), renderMobileNavbar(undefined));
}
$9750a4b65f4b7170$var$PDPContentMobile.displayName = "PDPContentMobile";
var $9750a4b65f4b7170$export$dd44f18ab656f3bb = $9750a4b65f4b7170$var$PDPContentMobile;
 /* make Not a pure module */ 
});
parcelRegister("b5sXm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $81269f7e71e1c8d1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $ezf3v = parcelRequire("ezf3v");

var $jBcRb = parcelRequire("jBcRb");
function $81269f7e71e1c8d1$var$Stack(Props) {
    var maxThumbnails = Props.maxThumbnails;
    var items = Props.items;
    var isVisibleOpt = Props.isVisible;
    var directionOpt = Props.direction;
    var spacingOpt = Props.spacing;
    var widthOpt = Props.width;
    var offsetLeftOpt = Props.offsetLeft;
    var offsetRightOpt = Props.offsetRight;
    var offsetBottomOpt = Props.offsetBottom;
    var heightOpt = Props.height;
    var rotationOpt = Props.rotation;
    var isVisible = isVisibleOpt !== undefined ? isVisibleOpt : true;
    var direction = directionOpt !== undefined ? directionOpt : /* Vertical */ 0;
    var spacing = spacingOpt !== undefined ? spacingOpt : 8;
    var width = widthOpt !== undefined ? widthOpt : 0;
    var offsetLeft = offsetLeftOpt !== undefined ? offsetLeftOpt : 0;
    var offsetRight = offsetRightOpt !== undefined ? offsetRightOpt : 0;
    var offsetBottom = offsetBottomOpt !== undefined ? offsetBottomOpt : 0;
    var height = heightOpt !== undefined ? heightOpt : 0;
    var rotation = rotationOpt !== undefined ? rotationOpt : /* Positive */ 1;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setThumbnailsMouseOver = match[1];
    var thumbnailsMouseOver = match[0];
    var total = items.length;
    var thumbnails = $i7mYY.mapWithIndex(items, function(index, param) {
        var id = param[0];
        var render = param[1];
        var onClick = param[2];
        var tilt = index - (total - (4 < maxThumbnails ? 4 : maxThumbnails) | 0) | 0;
        var x;
        if (thumbnailsMouseOver) switch(direction){
            case /* Vertical */ 0:
                x = 0;
                break;
            case /* Horizontal */ 1:
                x = Math.imul(index, width + spacing | 0);
                break;
            case /* Fan */ 2:
                x = (tilt > 0 ? tilt : 0) << 1;
                break;
        }
        else x = (tilt > 0 ? tilt : 0) << 1;
        var x$1 = String(x + spacing | 0);
        var y;
        if (thumbnailsMouseOver) switch(direction){
            case /* Vertical */ 0:
                y = Math.imul(index, height + spacing | 0);
                break;
            case /* Horizontal */ 1:
                y = 0;
                break;
            case /* Fan */ 2:
                y = Math.imul(tilt > 0 ? tilt : 0, 3);
                break;
        }
        else y = Math.imul(tilt > 0 ? tilt : 0, 3);
        var y$1 = String(y + spacing | 0);
        var angle = thumbnailsMouseOver ? direction >= 2 ? Math.imul(tilt > 0 ? tilt : 0, 7) : 0 : Math.imul(tilt > 0 ? tilt : 0, 5);
        var angle$1 = String(rotation ? angle : -angle | 0);
        var className = $ezf3v.prefix($1TRFX.make([
            "relative transition-shadow duration-500 bg-white",
            thumbnailsMouseOver || tilt >= 0 ? "shadow" : ""
        ]));
        return /*#__PURE__*/ $g85JO.createElement("div", {
            key: id,
            className: $ezf3v.prefix("absolute transition-transform duration-200 pointer-events-auto"),
            style: {
                transform: "translate(" + x$1 + "px, " + y$1 + "px) rotate(" + angle$1 + "deg)"
            }
        }, /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
            onClick: function onClick1(e) {
                e.stopPropagation();
                e.preventDefault();
                $iv6Yc._1(onClick, undefined);
            },
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: className
            }, $iv6Yc._1(render, undefined))
        }));
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            left: $ezf3v.intToPx(offsetLeft)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            right: $ezf3v.intToPx(offsetRight)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative"),
        style: {
            bottom: $ezf3v.intToPx(offsetBottom)
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "transition-opacity duration-200",
            isVisible ? "opacity-100" : "opacity-0"
        ])),
        onMouseEnter: function onMouseEnter(param) {
            $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                return true;
            });
        },
        onMouseLeave: function onMouseLeave(param) {
            $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                return false;
            });
        }
    }, thumbnails))));
}
$81269f7e71e1c8d1$var$Stack.displayName = "Stack";
var $81269f7e71e1c8d1$export$dd44f18ab656f3bb = $81269f7e71e1c8d1$var$Stack;
 /* react Not a pure module */ 
});

parcelRegister("g0DOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7b877d63b6054e$export$2e2bcd8739ae039; });

var $iYlcu = parcelRequire("iYlcu");

var $92qkg = parcelRequire("92qkg");

var $flcGD = parcelRequire("flcGD");
/** Error message constants. */ var $ba7b877d63b6054e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ba7b877d63b6054e$var$nativeMax = Math.max, $ba7b877d63b6054e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ba7b877d63b6054e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ba7b877d63b6054e$var$FUNC_ERROR_TEXT);
    wait = (0, $flcGD.default)(wait) || 0;
    if ((0, $iYlcu.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ba7b877d63b6054e$var$nativeMax((0, $flcGD.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ba7b877d63b6054e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $92qkg.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $92qkg.default)());
    }
    function debounced() {
        var time = (0, $92qkg.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $ba7b877d63b6054e$export$2e2bcd8739ae039 = $ba7b877d63b6054e$var$debounce;

});
parcelRegister("iYlcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfe469055918527$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $gfRPo = parcelRequire("gfRPo");
function $dcfe469055918527$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value);
    return value != null && (type == "object" || type == "function");
}
var $dcfe469055918527$export$2e2bcd8739ae039 = $dcfe469055918527$var$isObject;

});

parcelRegister("92qkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6948b8bba5c9c483$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6948b8bba5c9c483$var$now = function now() {
    return (0, $enmTs.default).Date.now();
};
var $6948b8bba5c9c483$export$2e2bcd8739ae039 = $6948b8bba5c9c483$var$now;

});
parcelRegister("enmTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b36f5e631d88f5$export$2e2bcd8739ae039; });

var $igP3b = parcelRequire("igP3b");
/** Detect free variable `self`. */ var $02b36f5e631d88f5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $02b36f5e631d88f5$var$root = (0, $igP3b.default) || $02b36f5e631d88f5$var$freeSelf || Function("return this")();
var $02b36f5e631d88f5$export$2e2bcd8739ae039 = $02b36f5e631d88f5$var$root;

});
parcelRegister("igP3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d152269e8defce$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d4d152269e8defce$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d4d152269e8defce$export$2e2bcd8739ae039 = $d4d152269e8defce$var$freeGlobal;

});



parcelRegister("flcGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b2a881acb233f6$export$2e2bcd8739ae039; });

var $7bKHP = parcelRequire("7bKHP");

var $iYlcu = parcelRequire("iYlcu");

var $9WZwf = parcelRequire("9WZwf");
/** Used as references for various `Number` constants. */ var $b2b2a881acb233f6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b2b2a881acb233f6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b2b2a881acb233f6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b2b2a881acb233f6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b2b2a881acb233f6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b2b2a881acb233f6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $9WZwf.default)(value)) return $b2b2a881acb233f6$var$NAN;
    if ((0, $iYlcu.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYlcu.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $7bKHP.default)(value);
    var isBinary = $b2b2a881acb233f6$var$reIsBinary.test(value);
    return isBinary || $b2b2a881acb233f6$var$reIsOctal.test(value) ? $b2b2a881acb233f6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b2b2a881acb233f6$var$reIsBadHex.test(value) ? $b2b2a881acb233f6$var$NAN : +value;
}
var $b2b2a881acb233f6$export$2e2bcd8739ae039 = $b2b2a881acb233f6$var$toNumber;

});
parcelRegister("7bKHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53bdca4c640065b2$export$2e2bcd8739ae039; });

var $hVIkI = parcelRequire("hVIkI");
/** Used to match leading whitespace. */ var $53bdca4c640065b2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $53bdca4c640065b2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $hVIkI.default)(string) + 1).replace($53bdca4c640065b2$var$reTrimStart, "") : string;
}
var $53bdca4c640065b2$export$2e2bcd8739ae039 = $53bdca4c640065b2$var$baseTrim;

});
parcelRegister("hVIkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0da26260aa88ea2$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $d0da26260aa88ea2$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d0da26260aa88ea2$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d0da26260aa88ea2$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d0da26260aa88ea2$export$2e2bcd8739ae039 = $d0da26260aa88ea2$var$trimmedEndIndex;

});


parcelRegister("9WZwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e9403b864b7e92$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $gEvC5 = parcelRequire("gEvC5");

var $2pW4B = parcelRequire("2pW4B");
/** `Object#toString` result references. */ var $73e9403b864b7e92$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73e9403b864b7e92$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value)) == "symbol" || (0, $2pW4B.default)(value) && (0, $gEvC5.default)(value) == $73e9403b864b7e92$var$symbolTag;
}
var $73e9403b864b7e92$export$2e2bcd8739ae039 = $73e9403b864b7e92$var$isSymbol;

});
parcelRegister("gEvC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f8e78702c28b95$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");

var $drSKx = parcelRequire("drSKx");

var $gu259 = parcelRequire("gu259");
/** `Object#toString` result references. */ var $c1f8e78702c28b95$var$nullTag = "[object Null]", $c1f8e78702c28b95$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c1f8e78702c28b95$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c1f8e78702c28b95$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c1f8e78702c28b95$var$undefinedTag : $c1f8e78702c28b95$var$nullTag;
    return $c1f8e78702c28b95$var$symToStringTag && $c1f8e78702c28b95$var$symToStringTag in Object(value) ? (0, $drSKx.default)(value) : (0, $gu259.default)(value);
}
var $c1f8e78702c28b95$export$2e2bcd8739ae039 = $c1f8e78702c28b95$var$baseGetTag;

});
parcelRegister("155hF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9a5b621e5301b6$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/** Built-in value references. */ var $0c9a5b621e5301b6$var$Symbol = (0, $enmTs.default).Symbol;
var $0c9a5b621e5301b6$export$2e2bcd8739ae039 = $0c9a5b621e5301b6$var$Symbol;

});

parcelRegister("drSKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca84417f00d2331$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");
/** Used for built-in method references. */ var $9ca84417f00d2331$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ca84417f00d2331$var$hasOwnProperty = $9ca84417f00d2331$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9ca84417f00d2331$var$nativeObjectToString = $9ca84417f00d2331$var$objectProto.toString;
/** Built-in value references. */ var $9ca84417f00d2331$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9ca84417f00d2331$var$getRawTag(value) {
    var isOwn = $9ca84417f00d2331$var$hasOwnProperty.call(value, $9ca84417f00d2331$var$symToStringTag), tag = value[$9ca84417f00d2331$var$symToStringTag];
    try {
        value[$9ca84417f00d2331$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9ca84417f00d2331$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9ca84417f00d2331$var$symToStringTag] = tag;
        else delete value[$9ca84417f00d2331$var$symToStringTag];
    }
    return result;
}
var $9ca84417f00d2331$export$2e2bcd8739ae039 = $9ca84417f00d2331$var$getRawTag;

});

parcelRegister("gu259", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0011029f37088ab$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $c0011029f37088ab$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0011029f37088ab$var$nativeObjectToString = $c0011029f37088ab$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c0011029f37088ab$var$objectToString(value) {
    return $c0011029f37088ab$var$nativeObjectToString.call(value);
}
var $c0011029f37088ab$export$2e2bcd8739ae039 = $c0011029f37088ab$var$objectToString;

});


parcelRegister("2pW4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2af6b3f01b3b43$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c2af6b3f01b3b43$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1c2af6b3f01b3b43$export$2e2bcd8739ae039 = $1c2af6b3f01b3b43$var$isObjectLike;

});




parcelRegister("fvE4w", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $b4a8d5b63998f43c$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "Provider", function () { return $b4a8d5b63998f43c$export$2881499e37b75b9a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $b4a8d5b63998f43c$export$1f96ae73734a86cc(param) {
    var match = $g85JO.useState(function() {
        return /* Closed */ 0;
    });
    var setState = match[1];
    var stateRef = $g85JO.useRef(/* Closed */ 0);
    var handleChange = function handleChange(next) {
        $iv6Yc._1(setState, function(param) {
            return next;
        });
        stateRef.current = next;
    };
    var onClose = function onClose(param) {
        handleChange(/* Closed */ 0);
    };
    var onOpen = function onOpen(param) {
        handleChange(/* Open */ 2);
    };
    var onOpening = function onOpening(param) {
        handleChange(/* Opening */ 1);
    };
    return {
        state: match[0],
        stateRef: stateRef,
        onOpening: onOpening,
        onOpen: onOpen,
        onClose: onClose
    };
}
var $b4a8d5b63998f43c$var$context = /*#__PURE__*/ $g85JO.createContext(/* Closed */ 0);
var $b4a8d5b63998f43c$var$provider = $b4a8d5b63998f43c$var$context.Provider;
function $b4a8d5b63998f43c$var$DrawerState$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    return /*#__PURE__*/ $g85JO.createElement($b4a8d5b63998f43c$var$provider, {
        value: value,
        children: children
    });
}
$b4a8d5b63998f43c$var$DrawerState$Provider.displayName = "DrawerState.Provider";
function $b4a8d5b63998f43c$var$use$1(param) {
    return $g85JO.useContext($b4a8d5b63998f43c$var$context);
}
var $b4a8d5b63998f43c$export$2881499e37b75b9a = {
    context: $b4a8d5b63998f43c$var$context,
    provider: $b4a8d5b63998f43c$var$provider,
    make: $b4a8d5b63998f43c$var$DrawerState$Provider,
    use: $b4a8d5b63998f43c$var$use$1
};
 /* context Not a pure module */ 
});

parcelRegister("gSw5h", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $c49a93bfa43bce1d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $ePG8R = parcelRequire("ePG8R");

var $IFWJb = parcelRequire("IFWJb");

var $8dLtV = parcelRequire("8dLtV");

var $4IRro = parcelRequire("4IRro");

var $gpCTg = parcelRequire("gpCTg");

var $1lWE3 = parcelRequire("1lWE3");

var $9pMGg = parcelRequire("9pMGg");

var $kJLmR = parcelRequire("kJLmR");

var $8E2YL = parcelRequire("8E2YL");
function $c49a93bfa43bce1d$var$ImageSlider(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var settings = Props.settings;
    var selectedSlideOpt = Props.selectedSlide;
    var visibleOpt = Props.visible;
    var onChange = Props.onChange;
    var currentSlide = Props.currentSlide;
    var children = Props.children;
    var selectedSlide = selectedSlideOpt !== undefined ? selectedSlideOpt : true;
    var visible = visibleOpt !== undefined ? visibleOpt : true;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $IFWJb.use(undefined);
    var onMainImageRendered = match$1.onMainImageRendered;
    var hideMediaFromOtherVariants = $2whNH.mapWithDefault($8E2YL.use(undefined).config.transitiveAccount, false, function(account) {
        return account.pdpHideMediaFromOtherVariants;
    });
    var allVariantMedia = $g85JO.useMemo(function() {
        return $7KlbQ.getAllVariantMedia(hideMediaFromOtherVariants, product, variant);
    }, [
        variant.id,
        product.id
    ]);
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setZoomed = match$2[1];
    var zoomed = match$2[0];
    var handleZoom = $g85JO.useCallback(function(ref) {
        return function($$event) {
            return $iv6Yc._1(setZoomed, function(param) {
                return ref.state.scale > 2;
            });
        };
    }, [
        setZoomed
    ]);
    var match$3 = $ePG8R.use(undefined, undefined, function(param) {
        return 0;
    });
    var setSelectedImage = match$3[1];
    var selectedImage = match$3[0];
    $g85JO.useEffect(function() {
        if (currentSlide !== undefined) $iv6Yc._1(setSelectedImage, function(param) {
            return currentSlide;
        });
    }, [
        currentSlide
    ]);
    var match$4 = $g85JO.useState(function() {
        if (selectedSlide) return visible;
        else return false;
    });
    var setAutoplay = match$4[1];
    var autoplay = match$4[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setAutoplay, function(param) {
            if (selectedSlide) return visible;
            else return false;
        });
    }, [
        selectedSlide,
        visible
    ]);
    var image = $g85JO.useMemo(function() {
        return $i7mYY.get(allVariantMedia, selectedImage);
    }, [
        allVariantMedia,
        selectedImage
    ]);
    var mediaSrc = $2whNH.flatMap(image, $7KlbQ.Media.getImageUrl);
    var match$5 = $kJLmR.use(autoplay, undefined, $2whNH.map(image, function(image) {
        switch(image.TAG | 0){
            case /* Image */ 0:
                return "image";
            case /* Video */ 1:
                return "video";
            case /* IframeEmbed */ 2:
                return "iframe";
        }
    }), mediaSrc, undefined);
    var setProgress = match$5[1];
    var match$6 = $g85JO.useState(function() {
        return false;
    });
    var setAutoplayPaused = match$6[1];
    var autoplayPaused = match$6[0];
    var autoplayPausedRef = $g85JO.useRef(false);
    var loadedRef = $g85JO.useRef([]);
    var match$7 = $kQvlq.useSafeTimeout(undefined, undefined);
    var $$clearTimeout$1 = match$7.clearTimeout;
    var $$setTimeout$1 = match$7.setTimeout;
    var isLoaded = function isLoaded(src) {
        return $i7mYY.some(loadedRef.current, function(k) {
            return k === src;
        });
    };
    var setLoaded = function setLoaded(src) {
        loadedRef.current = $i7mYY.concat(loadedRef.current, [
            src
        ]);
    };
    var pauseAutoplay = function pauseAutoplay(value) {
        autoplayPausedRef.current = value;
        $iv6Yc._1(setAutoplayPaused, function(param) {
            return value;
        });
    };
    $g85JO.useEffect(function() {
        if (mediaSrc !== undefined) pauseAutoplay(!isLoaded(mediaSrc));
    }, [
        mediaSrc,
        selectedSlide,
        visible
    ]);
    var handleTouchStart = function handleTouchStart(param) {
        $iv6Yc._1($$clearTimeout$1, undefined);
        $$setTimeout$1(function(param) {
            if (mediaSrc !== undefined && isLoaded(mediaSrc)) return pauseAutoplay(true);
        }, 250);
    };
    var handleTouchEnd = function handleTouchEnd(param) {
        $iv6Yc._1($$clearTimeout$1, undefined);
        $$setTimeout$1(function(param) {
            if (mediaSrc !== undefined && isLoaded(mediaSrc)) return pauseAutoplay(false);
        }, 42);
    };
    var mediaCount = allVariantMedia.length;
    var nextImage = function nextImage(param) {
        if (!autoplayPausedRef.current || $2whNH.mapWithDefault(mediaSrc, false, isLoaded) === false) {
            $iv6Yc._1(setProgress, 0);
            return $iv6Yc._1(setSelectedImage, function(image) {
                var next = image + 1 | 0;
                var next$1 = next >= mediaCount ? 0 : next;
                $iv6Yc._1(onChange, next$1);
                return next$1;
            });
        }
    };
    var nextImageWithTracking = function nextImageWithTracking(param) {
        $iv6Yc.app(trackEvent, [
            "mobile pdp:tapped next image",
            undefined,
            undefined,
            product,
            variant,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        nextImage(undefined);
    };
    var prevImageWithTracking = function prevImageWithTracking(param) {
        $iv6Yc.app(trackEvent, [
            "mobile pdp:tapped previous image",
            undefined,
            undefined,
            product,
            variant,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        if (!autoplayPausedRef.current || $2whNH.mapWithDefault(mediaSrc, false, isLoaded) === false) {
            $iv6Yc._1(setProgress, 0);
            return $iv6Yc._1(setSelectedImage, function(image) {
                var prev = image - 1 | 0;
                var prev$1 = prev < 0 ? mediaCount - 1 | 0 : prev;
                $iv6Yc._1(onChange, prev$1);
                return prev$1;
            });
        }
    };
    var autoplayTimerRef = $g85JO.useRef(undefined);
    $g85JO.useEffect(function() {
        var $$clearTimeout$2 = function $$clearTimeout$2(param) {
            var id = autoplayTimerRef.current;
            if (id !== undefined) {
                clearTimeout($loT9g.valFromOption(id));
                return;
            }
        };
        $$clearTimeout$2(undefined);
        if (image !== undefined) switch(image.TAG | 0){
            case /* Image */ 0:
                if (autoplayPaused || !autoplay) ;
                else autoplayTimerRef.current = $loT9g.some(setTimeout(nextImage, 5000));
                break;
            case /* Video */ 1:
            case /* IframeEmbed */ 2:
                break;
        }
        return function(param) {
            $$clearTimeout$2(undefined);
        };
    }, [
        $2whNH.flatMap(image, $7KlbQ.Media.getImageUrl),
        autoplayPaused,
        autoplay
    ]);
    var handleTimeChange = function handleTimeChange(time, duration) {
        $iv6Yc._1(setProgress, Math.round(time / duration * 100) | 0);
    };
    var handleContextMenu = function handleContextMenu(e) {
        e.preventDefault();
    };
    var panning = $g85JO.useMemo(function() {
        return {
            disabled: !zoomed
        };
    }, [
        zoomed
    ]);
    var doubleClick = $g85JO.useMemo(function() {
        return {
            disabled: true
        };
    }, []);
    var handleClickTab = $g85JO.useCallback(function(i) {
        $iv6Yc._1(setSelectedImage, function(param) {
            return i;
        });
        $iv6Yc._1(onChange, i);
    }, [
        setSelectedImage,
        onChange
    ]);
    var tmp = {
        index: selectedImage,
        total: mediaCount,
        onClick: handleClickTab,
        autoplay: autoplay,
        autoplayPaused: autoplayPaused,
        setProgressRef: match$5[2],
        enableTruncation: true,
        isMobile: true,
        dataTestId: "pdp-images-tabs"
    };
    var tmp$1 = $2whNH.flatMap(image, $7KlbQ.Media.getImageUrl);
    if (tmp$1 !== undefined) tmp.mediaId = tmp$1;
    var tmp$2 = match$5[0];
    if (tmp$2 !== undefined) tmp.progressSpeed = tmp$2;
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($4IRro.TransformWrapper, {
        panning: panning,
        doubleClick: doubleClick,
        onZoom: handleZoom,
        children: /*#__PURE__*/ $g85JO.createElement($4IRro.TransformComponent, {
            wrapperClass: $ezf3v.prefix("absolute inset-0 w-full h-full"),
            contentClass: $ezf3v.prefix("absolute inset-0 w-full h-full"),
            children: /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, $2whNH.mapWithDefault(image, null, function(image) {
                var match = settings.newMobilePDPCover;
                var match$1 = settings.backdropBlur;
                var tmp;
                switch(image.TAG | 0){
                    case /* Image */ 0:
                        var url = image._0.url;
                        tmp = /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                            src: url,
                            fit: settings.newMobilePDPCover ? /* Cover */ 1 : /* ScaleDown */ 0,
                            priority: 0,
                            onLoad: function onLoad(param) {
                                if (param.imageSize.width >= param.width) {
                                    setLoaded(url);
                                    if ($7bjme.equal(url, mediaSrc)) return pauseAutoplay(false);
                                    else return;
                                }
                            },
                            onRender: function onRender(param) {
                                $iv6Yc._1(onMainImageRendered, undefined);
                            },
                            noFlicker: true
                        });
                        break;
                    case /* Video */ 1:
                        var video = image._0;
                        var src = $2whNH.map($7KlbQ.getVideoSource(video), function(source) {
                            return source.url;
                        });
                        if (src !== undefined) {
                            var tmp$1 = {
                                src: src,
                                isPaused: autoplayPaused || !autoplay,
                                onReady: function onReady(param) {
                                    setLoaded(src);
                                    return pauseAutoplay(false);
                                },
                                onTimeChange: handleTimeChange,
                                muted: false,
                                onEnded: nextImage,
                                loop: false,
                                controls: false,
                                objectFit: settings.newMobilePDPCover ? "cover" : "contain"
                            };
                            if (video.posterUrl !== undefined) tmp$1.poster = $loT9g.valFromOption(video.posterUrl);
                            tmp = /*#__PURE__*/ $g85JO.createElement($1lWE3.Video.make, tmp$1);
                        } else tmp = null;
                        break;
                    case /* IframeEmbed */ 2:
                        tmp = /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                            url: image._0.url
                        });
                        break;
                }
                return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("flex items-center justify-center absolute inset-0 overflow-hidden")
                }, match || !match$1 ? null : zoomed ? /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("absolute inset-0 bg-black")
                }) : /*#__PURE__*/ $g85JO.createElement($55MCT.ColorOverlay.make, {
                    media: image
                }), tmp);
            }), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute inset-0 no-flicker"),
                style: {
                    background: "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 35%, rgba(0, 0, 0, 0) 69.79%, rgba(0, 0, 0, 0.5) 100%)"
                }
            }), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute inset-0 flex justify-between items-stetch no-touch-callout no-user-select"),
                onContextMenu: handleContextMenu,
                onTouchCancel: handleTouchEnd,
                onTouchEnd: handleTouchEnd,
                onTouchStart: handleTouchStart
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-1/4 h-full"),
                onClick: prevImageWithTracking
            }), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-3/4 h-full"),
                onClick: nextImageWithTracking
            })))
        })
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "transition-opacity duration-500",
            zoomed ? "opacity-0" : "opacity-100"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($gpCTg.make, tmp), children));
}
$c49a93bfa43bce1d$var$ImageSlider.displayName = "ImageSlider";
var $c49a93bfa43bce1d$export$dd44f18ab656f3bb = $c49a93bfa43bce1d$var$ImageSlider;
 /* react Not a pure module */ 
});

parcelRegister("5YnL9", function(module, exports) {

$parcel$export(module.exports, "stickyHeight", function () { return $4594fc82d1320555$export$a892e62cc9c883c0; });
$parcel$export(module.exports, "make", function () { return $4594fc82d1320555$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $6iioJ = parcelRequire("6iioJ");

var $7KlbQ = parcelRequire("7KlbQ");

var $7wIsS = parcelRequire("7wIsS");

var $55MCT = parcelRequire("55MCT");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $8L1B1 = parcelRequire("8L1B1");

var $fUtdg = parcelRequire("fUtdg");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $8E2YL = parcelRequire("8E2YL");

var $lHzh8 = parcelRequire("lHzh8");
function $4594fc82d1320555$var$PDPContentHeader(Props) {
    var product = Props.product;
    var variant = Props.variant;
    var scrollToDetails = Props.scrollToDetails;
    var positionOpt = Props.position;
    var animateVisibilityOpt = Props.animateVisibility;
    var shadowOpt = Props.shadow;
    var bgOpt = Props.bg;
    var imageOpt = Props.image;
    var showCTAOpt = Props.showCTA;
    var reviewsOpt = Props.reviews;
    var allowTitleWrapOpt = Props.allowTitleWrap;
    var productCategory = Props.productCategory;
    var productPositionOpt = Props.productPosition;
    var productsCountOpt = Props.productsCount;
    var maxWidth = Props.maxWidth;
    var sizeOpt = Props.size;
    var variantsInfoOpt = Props.variantsInfo;
    var variantsOpt = Props.variants;
    var optionSize = Props.optionSize;
    var optionStyle = Props.optionStyle;
    var colorOptionSize = Props.colorOptionSize;
    var titleStyle = Props.titleStyle;
    var largeTitleStyle = Props.largeTitleStyle;
    var titleSize = Props.titleSize;
    var onBackClick = Props.onBackClick;
    var position = positionOpt !== undefined ? positionOpt : /* Relative */ 0;
    var animateVisibility = animateVisibilityOpt !== undefined ? animateVisibilityOpt : false;
    var shadow = shadowOpt !== undefined ? shadowOpt : true;
    var bg = bgOpt !== undefined ? bgOpt : true;
    var image = imageOpt !== undefined ? imageOpt : true;
    var showCTA = showCTAOpt !== undefined ? showCTAOpt : false;
    var reviews = reviewsOpt !== undefined ? reviewsOpt : false;
    var allowTitleWrap = allowTitleWrapOpt !== undefined ? allowTitleWrapOpt : false;
    var productPosition = productPositionOpt !== undefined ? productPositionOpt : 0;
    var productsCount = productsCountOpt !== undefined ? productsCountOpt : 0;
    var size = sizeOpt !== undefined ? sizeOpt : /* Base */ 0;
    var variantsInfo = variantsInfoOpt !== undefined ? variantsInfoOpt : false;
    var variants = variantsOpt !== undefined ? variantsOpt : false;
    var store = $8L1B1.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setHover = match$1[1];
    var match$2 = $aSJcu.use(undefined);
    var match$3 = $8E2YL.use(undefined);
    var scrollToDetailsRef = $g85JO.useRef(scrollToDetails);
    var size$1 = $2whNH.isSome(productCategory) ? /* Lg */ 1 : size;
    var stickyHeight = size$1 ? 110 : 107;
    var tmp;
    switch(position){
        case /* Relative */ 0:
            tmp = "relative";
            break;
        case /* StickyTop */ 1:
            tmp = "sticky top-0";
            break;
        case /* FixedBottom */ 2:
            tmp = "fixed bottom-0";
            break;
        case /* FixedTop */ 3:
            tmp = "fixed top-0";
            break;
    }
    var tmp$1;
    var exit = 0;
    if (position !== 1 && position < 3) tmp$1 = "";
    else exit = 1;
    if (exit === 1) tmp$1 = match$2.windowSize.width <= 1600 && match$2.breakpoint > /* Sm */ 1 ? "pt-18" : "";
    var tmp$2 = {};
    var tmp$3 = animateVisibility && position === 2 ? String(stickyHeight) + "px" : undefined;
    if (tmp$3 !== undefined) tmp$2.marginTop = tmp$3;
    if (maxWidth !== undefined) tmp$2.maxWidth = maxWidth;
    var tmp$4 = {
        className: $ezf3v.prefix($1TRFX.make([
            tmp,
            "w-full bg-main z-20",
            maxWidth !== undefined ? "left-1/2 -translate-x-1/2" : "left-0",
            "p-6 pl-3",
            tmp$1,
            shadow && position !== 0 ? "shadow" : "",
            "transition-transform transform",
            animateVisibility ? position !== 1 ? "translate-y-0" : "translate-y-full" : position !== 2 ? position >= 3 ? "-translate-y-full" : "translate-y-0" : "translate-y-full"
        ])),
        style: tmp$2,
        onMouseEnter: function onMouseEnter(param) {
            $iv6Yc._1(setHover, function(param) {
                return true;
            });
        },
        onMouseLeave: function onMouseLeave(param) {
            $iv6Yc._1(setHover, function(param) {
                return false;
            });
        }
    };
    var tmp$5 = animateVisibility ? undefined : true;
    if (tmp$5 !== undefined) tmp$4["aria-hidden"] = $loT9g.valFromOption(tmp$5);
    var match$4 = variant.media;
    var tmp$6;
    var exit$1 = 0;
    var url;
    if (image) switch(match$4.TAG | 0){
        case /* Image */ 0:
            url = match$4._0.url;
            exit$1 = 1;
            break;
        case /* Video */ 1:
            var url$1 = match$4._0.posterUrl;
            if (url$1 !== undefined) {
                url = url$1;
                exit$1 = 1;
            } else tmp$6 = null;
            break;
        case /* IframeEmbed */ 2:
            tmp$6 = null;
            break;
    }
    else tmp$6 = null;
    if (exit$1 === 1) {
        var maxHeight = stickyHeight - (size$1 ? 24 : 38);
        var ratio = $diVVk.Size.getRatio(match$3.config.settings.productCardShape);
        var width = maxHeight * ratio;
        tmp$6 = /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex items-center justify-center flex-shrink-0 flex-grow-0"),
            tabIndex: 0,
            onClick: function onClick(e) {
                if (onBackClick !== undefined) return $iv6Yc._1(onBackClick, e);
                else return $iv6Yc._1(scrollToDetails, undefined);
            }
        }, onBackClick !== undefined ? /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
            size: /* Px */ {
                _0: 20
            }
        }) : null, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative"),
            style: {
                height: String(maxHeight) + "px",
                width: String(width) + "px"
            }
        }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
            src: url,
            fit: /* Cover */ 1,
            priority: 0,
            noFlicker: true
        })));
    }
    var tmp$7 = {};
    var tmp$8 = allowTitleWrap ? "72px" : undefined;
    if (tmp$8 !== undefined) tmp$7.minHeight = tmp$8;
    var match$5 = product.reviewSummary;
    var tmp$9 = {
        product: product,
        variant: variant,
        secondary: false,
        tertiary: false
    };
    var tmp$10 = animateVisibility ? undefined : -1;
    if (tmp$10 !== undefined) tmp$9.tabIndex = $loT9g.valFromOption(tmp$10);
    var tmp$11 = {
        product: product,
        variant: variant,
        scrollToDetailsRef: scrollToDetailsRef,
        showHeader: false,
        layout: /* Inline */ 2,
        sections: [
            "variants",
            "quantity",
            "cta"
        ],
        showSizeGuide: false
    };
    if (productCategory !== undefined) tmp$11.productCategory = $loT9g.valFromOption(productCategory);
    if (titleStyle !== undefined) tmp$11.titleStyle = $loT9g.valFromOption(titleStyle);
    if (largeTitleStyle !== undefined) tmp$11.largeTitleStyle = $loT9g.valFromOption(largeTitleStyle);
    if (titleSize !== undefined) tmp$11.titleSize = $loT9g.valFromOption(titleSize);
    if (optionSize !== undefined) tmp$11.optionSize = $loT9g.valFromOption(optionSize);
    if (optionStyle !== undefined) tmp$11.optionStyle = $loT9g.valFromOption(optionStyle);
    if (colorOptionSize !== undefined) tmp$11.colorOptionSize = $loT9g.valFromOption(colorOptionSize);
    var tmp$12 = animateVisibility ? undefined : -1;
    if (tmp$12 !== undefined) tmp$11.tabIndex = $loT9g.valFromOption(tmp$12);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp$4, bg ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 bg-gray-600 opacity-20 z-0")
    }) : null, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("relative z-10 flex items-start justify-between space-x-4")
    }, tmp$6, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("leading-loose flex flex-col gap-2 flex-grow-1 w-full"),
        style: tmp$7,
        onClick: function onClick(param) {
            $iv6Yc._1(scrollToDetails, undefined);
        }
    }, productCategory !== undefined ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex gap-5 items-end justify-start text-lg")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("uppercase font-semibold underline cursor-pointer"),
        onClick: function onClick(param) {
            $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* ListPage */ 1,
                _0: {
                    listPageType: {
                        TAG: /* Category */ 0,
                        _0: productCategory.id
                    },
                    viewPLP: false,
                    filters: undefined,
                    sort: undefined
                }
            });
        }
    }, productCategory.title), /*#__PURE__*/ $g85JO.createElement("div", undefined, String(productPosition + 1 | 0) + "/" + String(productsCount))) : null, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-product-title",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "truncate-lines font-bold",
                allowTitleWrap ? "truncate-lines-2" : "truncate-lines-1",
                size$1 ? "text-2xl" : "text-xl"
            ]))
        }, $7KlbQ.getDisplayName(store, variant, product))
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex gap-6 items-center justify-start mt-2")
    }, /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
        at: /* PDP */ 0,
        product: product,
        variant: variant,
        size: size$1 ? /* Md */ 1 : /* Sm */ 2,
        marginTop: false,
        minPriceFirst: true,
        multiline: false,
        bold: false
    })), reviews && match$5 !== undefined ? /*#__PURE__*/ $g85JO.createElement($fUtdg.make, {
        at: /* PDP */ 0,
        product: product,
        variant: variant,
        countClassName: $ezf3v.prefix("text-base text-secondary")
    }) : null, variantsInfo ? $i7mYY.joinWith($i7mYY.keep([
        [
            "colors",
            $7KlbQ.getOptionsByName(product, "Color").length
        ],
        [
            "sizes",
            $7KlbQ.getOptionsByName(product, "Size").length
        ]
    ], function(param) {
        return param[1] > 1;
    }), ", ", function(param) {
        return String(param[1]) + " " + param[0];
    }) : null), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: showCTA,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-shrink-0")
        }, /*#__PURE__*/ $g85JO.createElement($6iioJ.make, tmp$9))
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: variants,
        children: /*#__PURE__*/ $g85JO.createElement($lHzh8.make, tmp$11)
    })));
}
$4594fc82d1320555$var$PDPContentHeader.displayName = "PDPContentHeader";
var $4594fc82d1320555$export$a892e62cc9c883c0 = 110;
var $4594fc82d1320555$export$dd44f18ab656f3bb = $4594fc82d1320555$var$PDPContentHeader;
 /* react Not a pure module */ 
});


parcelRegister("ja0oJ", function(module, exports) {

$parcel$export(module.exports, "useProductCategory", function () { return $df2f4285010a27d5$export$a2eda845ab9c2e74; });
$parcel$export(module.exports, "usePDPPagination", function () { return $df2f4285010a27d5$export$793e55090f3dc085; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $8u0V4 = parcelRequire("8u0V4");

var $7KlbQ = parcelRequire("7KlbQ");

var $hG39s = parcelRequire("hG39s");

var $1xf0g = parcelRequire("1xf0g");

var $8iMy9 = parcelRequire("8iMy9");

var $7xAyC = parcelRequire("7xAyC");

var $98NfX = parcelRequire("98NfX");

var $5bEXW = parcelRequire("5bEXW");

var $8TQEo = parcelRequire("8TQEo");

var $8L1B1 = parcelRequire("8L1B1");

var $fLfrY = parcelRequire("fLfrY");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $7MOac = parcelRequire("7MOac");

var $hPPub = parcelRequire("hPPub");

var $c06xW = parcelRequire("c06xW");

var $ij6do = parcelRequire("ij6do");
function $df2f4285010a27d5$export$5e355d425cb0f7f3(str) {
    return $2whNH.isSome($loT9g.null_to_opt(str.match(/^\d+$/)));
}
function $df2f4285010a27d5$export$a2eda845ab9c2e74(smartnavApiHost, storeId, productId, route, shouldFetch) {
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var settings = match$1.settings;
    var activeCategory = $hBcYV.useActiveCategory(true, undefined, match$1.categories);
    var match$2 = $g85JO.useState(function() {
        return activeCategory;
    });
    var setCurrentCategory = match$2[1];
    var currentCategory = match$2[0];
    var productCategoryId;
    if (typeof route === "number" || route.TAG !== /* PDP */ 2) productCategoryId = undefined;
    else {
        var productCategoryId$1 = route._0.productCategoryId;
        productCategoryId = productCategoryId$1 !== undefined && productCategoryId$1.trim() !== "" ? productCategoryId$1 : undefined;
    }
    var rootCategory = $2whNH.keep(settings.indexNode, $1xf0g.ExternalConnection.isConnectedToStoreCategory);
    var match$3 = $c6E1z.useCategoriesByProduct(smartnavApiHost, storeId, activeCategory !== undefined || currentCategory !== undefined || rootCategory !== undefined ? undefined : productId, shouldFetch, undefined);
    var productCategories = $2whNH.getWithDefault($2whNH.flatMap(match$3.data, function(page) {
        return page.categories;
    }), []);
    var match$4 = productCategories.length;
    var firstProductCategory = match$4 === 0 || match$4 === 1 ? $i7mYY.get(productCategories, 0) : $98NfX.getByPredicateOrFirst($i7mYY.keep(productCategories, function(category) {
        return $iv6Yc._1($hG39s.CategoryId.toString, category.id) !== "all";
    }), function(category) {
        return $7bjme.equal($iv6Yc._1($hG39s.CategoryId.toString, category.id), productCategoryId);
    });
    var firstProductCategory$1 = $g85JO.useMemo(function() {
        return $2whNH.map(firstProductCategory, function(param) {
            return $8TQEo.toShowsideCategory(settings, param);
        });
    }, [
        $2whNH.map(firstProductCategory, function(a) {
            return a.id;
        })
    ]);
    var result = $g85JO.useMemo(function() {
        return $2whNH.orElse($2whNH.orElse(activeCategory, rootCategory), firstProductCategory$1);
    }, [
        activeCategory,
        settings.indexNode,
        firstProductCategory$1
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setCurrentCategory, function(previous) {
            return $2whNH.orElse(result, previous);
        });
    }, [
        result
    ]);
    return $g85JO.useMemo(function() {
        return $1xf0g.setChildren($2whNH.getWithDefault(currentCategory, $ij6do.empty), []);
    }, [
        currentCategory
    ]);
}
function $df2f4285010a27d5$export$262cdabd3e110461(loadedFeaturedProductsOpt, featuredProductsIds, productId, variantId) {
    var loadedFeaturedProducts = loadedFeaturedProductsOpt !== undefined ? loadedFeaturedProductsOpt : [];
    return $i7mYY.keepMap($i7mYY.mapWithIndex(featuredProductsIds, function(order, id) {
        return $8iMy9.Slide.makeUnloadedProductSlide(true, id, order);
    }), function(slide) {
        var match = $i7mYY.getBy(loadedFeaturedProducts, function(product) {
            return product.id === $8iMy9.Slide.getId(slide);
        });
        if (loadedFeaturedProducts.length === 0 && match === undefined) return slide;
        if (match !== undefined) return $8iMy9.Slide.makeProductSlide(true, variantId, $8iMy9.Slide.getOrder(slide), match);
    });
}
function $df2f4285010a27d5$export$7a91af4c5b61f676(productId, variantId, pagesOpt, param) {
    var pages = pagesOpt !== undefined ? pagesOpt : [];
    var total = $2whNH.getWithDefault($i7mYY.get($i7mYY.keepMap(pages, function(page) {
        return page.total;
    }), 0), 0);
    var arg = $8iMy9.Slide.makePlaceholderSlide;
    var initialSlides = $i7mYY.makeBy(total, function(eta) {
        return $iv6Yc._3(arg, undefined, undefined, eta);
    });
    return $g85JO.useMemo(function() {
        return $8iMy9.trimTrailingPlaceholders($i7mYY.reduce(pages, initialSlides, function(slides, page) {
            var offset = $2whNH.getWithDefault(page.page.offset, 0);
            var leftSlides = $i7mYY.slice(slides, 0, offset);
            var middleSlides = $i7mYY.mapWithIndex(page.products, function(i, product) {
                return $8iMy9.Slide.makeProductSlide(undefined, variantId, offset + i | 0, product);
            });
            var rightSlides = $i7mYY.sliceToEnd(slides, offset);
            return $i7mYY.mapWithIndex($i7mYY.concat($i7mYY.concat(leftSlides, middleSlides), rightSlides), function(i, slide) {
                return $8iMy9.Slide.setOrder(slide, i);
            });
        }));
    }, [
        $i7mYY.flatMap(pages, function(page) {
            return page.products;
        }).length,
        variantId
    ]);
}
function $df2f4285010a27d5$export$37b398bdc9e846c0(category, settings, productId, variantId) {
    var match = $9pMGg.use(undefined);
    var market = match.market;
    var smartnavApiHost = match.smartnavApiHost;
    $8u0V4.getValues(market);
    var match$1 = $hBcYV.useRouter(undefined);
    var productFilters = match$1.productFilters;
    var relatedProductId = match$1.relatedProductId;
    var listPageType = match$1.listPageType;
    var match$2 = $8E2YL.use(undefined);
    var match$3 = match$2.config;
    var account = match$3.transitiveAccount;
    var storeId = match$3.transitiveStoreId;
    var storeConnection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    var match$4 = $1xf0g.ExternalConnection.getConnection(category);
    var listPageType$1;
    if (match$4 !== undefined && typeof match$4 === "number") switch(match$4){
        case /* History */ 0:
            listPageType$1 = /* History */ 1;
            break;
        case /* Favorites */ 1:
            listPageType$1 = /* Favorites */ 0;
            break;
        case /* StoreCart */ 2:
            listPageType$1 = /* StoreCart */ 2;
            break;
    }
    else listPageType$1 = listPageType;
    var defaultFilters = $2whNH.flatMap(storeConnection, function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, account);
    });
    var match$5 = $c6E1z.useProductById($2whNH.isSome(storeConnection), settings.hideOutOfStock, category.id, smartnavApiHost, market, $2whNH.getWithDefault(productId, ""));
    var productFromImmediateCache = match$5.product;
    var featuredProductsIds = $g85JO.useMemo(function() {
        if ($2whNH.isNone(productFilters)) return $1xf0g.getProductIds(category);
        else return [];
    }, []);
    var focalProductId = $g85JO.useMemo(function() {
        if ($i7mYY.some(featuredProductsIds, function(id) {
            return $7bjme.equal(id, productId);
        })) return;
        else return productId;
    }, []);
    var match$6 = $c6E1z.useCategoryProducts(true, storeId, category.id, storeConnection, settings.hideOutOfStock, productFilters, defaultFilters, 10, match$1.productSort, $2whNH.isSome(storeConnection), smartnavApiHost, focalProductId, market, undefined);
    var connectedDirection = match$6.direction;
    var setConnectedDirection = match$6.setDirection;
    var connectedProductsSwr = match$6.swr;
    var match$7 = $7xAyC.getPageInfo(connectedProductsSwr, function(page) {
        return page.page.next;
    }, function(page) {
        return page.products;
    });
    var connectedProductsTotal = $2whNH.getWithDefault($2whNH.flatMap($2whNH.flatMap(connectedProductsSwr.data, function(pages) {
        return $i7mYY.getBy(pages, function(page) {
            return page.total !== undefined;
        });
    }), function(page) {
        return page.total;
    }), 0);
    var match$8 = $7xAyC.useRateLimitedPagination(connectedProductsSwr, 3);
    var setConnectedNumPages = match$8.setSize;
    var connectedNumPages = match$8.size;
    var match$9 = $c6E1z.useProductsById(storeId, featuredProductsIds, false, true, category.id, smartnavApiHost, market, undefined);
    var loadedFeaturedProducts = match$9.products;
    var relatedProductsSwr = $c6E1z.useRelatedProducts(relatedProductId, storeId, category.id, settings.hideOutOfStock, $2whNH.isNone(storeConnection), smartnavApiHost, market, undefined);
    var match$10 = $7xAyC.getPageInfo(relatedProductsSwr, function(page) {
        return page.page.next;
    }, function(page) {
        return page.products;
    });
    var match$11 = $7xAyC.useRateLimitedPagination(relatedProductsSwr, 3);
    var match$12 = $7MOac.useUserSavedProducts(settings.hideOutOfStock, $7bjme.equal(listPageType$1, /* History */ 1), true, undefined, "history");
    var historyProducts = match$12.products;
    var match$13 = $7MOac.useUserSavedProducts(settings.hideOutOfStock, $7bjme.equal(listPageType$1, /* Favorites */ 0), true, undefined, "favorites");
    var favoriteProducts = match$13.products;
    var match$14 = $7MOac.useUserSavedProducts(settings.hideOutOfStock, $7bjme.equal(listPageType$1, /* StoreCart */ 2), true, undefined, "cart");
    var cartProducts = match$14.products;
    var match$15;
    var exit = 0;
    if (listPageType$1 !== undefined && typeof listPageType$1 === "number") switch(listPageType$1){
        case /* Favorites */ 0:
            match$15 = [
                $2whNH.map(favoriteProducts, $c06xW.Page.makeVirtualPages),
                $2whNH.isSome(favoriteProducts),
                1,
                function(param) {
                    return true;
                },
                $2whNH.getWithDefault($2whNH.map(favoriteProducts, function(prim) {
                    return prim.length;
                }), 0),
                function(param) {},
                undefined
            ];
            break;
        case /* History */ 1:
            match$15 = [
                $2whNH.map(historyProducts, $c06xW.Page.makeVirtualPages),
                $2whNH.isSome(historyProducts),
                1,
                function(param) {
                    return true;
                },
                $2whNH.getWithDefault($2whNH.map(historyProducts, function(prim) {
                    return prim.length;
                }), 0),
                function(param) {},
                undefined
            ];
            break;
        case /* StoreCart */ 2:
            match$15 = [
                $2whNH.map(cartProducts, $c06xW.Page.makeVirtualPages),
                $2whNH.isSome(cartProducts),
                1,
                function(param) {
                    return true;
                },
                $2whNH.getWithDefault($2whNH.map(cartProducts, function(prim) {
                    return prim.length;
                }), 0),
                function(param) {},
                undefined
            ];
            break;
    }
    else exit = 1;
    if (exit === 1) match$15 = relatedProductId !== undefined ? [
        relatedProductsSwr.data,
        match$10.reachedEnd,
        match$11.size,
        match$11.setSize,
        $2whNH.getWithDefault($2whNH.map(match$10.contents, function(prim) {
            return prim.length;
        }), 0),
        function(param) {},
        relatedProductsSwr.error
    ] : storeConnection !== undefined ? [
        connectedProductsSwr.data,
        match$7.reachedEnd,
        connectedNumPages,
        setConnectedNumPages,
        connectedProductsTotal,
        setConnectedDirection,
        connectedProductsSwr.error
    ] : [
        undefined,
        $2whNH.isSome(loadedFeaturedProducts),
        1,
        function(param) {
            return true;
        },
        $2whNH.getWithDefault($2whNH.map(loadedFeaturedProducts, function(prim) {
            return prim.length;
        }), 0),
        function(param) {},
        match$9.error
    ];
    var error = match$15[6];
    var total = match$15[4];
    var featuredSlides = $df2f4285010a27d5$export$262cdabd3e110461(loadedFeaturedProducts, featuredProductsIds, productId, variantId);
    var slides = $df2f4285010a27d5$export$7a91af4c5b61f676(productId, variantId, match$15[0], undefined);
    var slidesFromImmediateCache = $g85JO.useMemo(function() {
        return $i7mYY.map($i7mYY.keepMap([
            productFromImmediateCache
        ], function(a) {
            return a;
        }), function(product) {
            return $8iMy9.Slide.makeProductSlide(undefined, variantId, 0, product);
        });
    }, [
        productFromImmediateCache,
        variantId
    ]);
    var slides$1 = $g85JO.useMemo(function() {
        if (slides.length !== 0) return $8iMy9.Slides.dedupById($i7mYY.concat($i7mYY.concat(featuredSlides, slides), slidesFromImmediateCache));
        else return $8iMy9.Slides.dedupById($i7mYY.concat(featuredSlides, slidesFromImmediateCache));
    }, [
        featuredSlides,
        slides,
        slidesFromImmediateCache,
        variantId
    ]);
    var position = $2whNH.getWithDefault($i7mYY.getIndexBy(slides$1, function(slide) {
        switch(slide.TAG | 0){
            case /* Product */ 0:
                return $7bjme.equal(slide.product.id, productId);
            case /* Placeholder */ 1:
            case /* UnloadedProduct */ 2:
                return false;
        }
    }), 0);
    var currentSlideIndex = $i7mYY.getIndexBy(slides$1, function(slide) {
        return $8iMy9.Slide.getId(slide) === productId;
    });
    $g85JO.useEffect(function() {
        if (currentSlideIndex !== undefined) {
            var closestLeftPlaceholderIndex = $81N94.int_max($i7mYY.map(slides$1.slice(0, currentSlideIndex), function(slide) {
                switch(slide.TAG | 0){
                    case /* Placeholder */ 1:
                        return true;
                    case /* Product */ 0:
                    case /* UnloadedProduct */ 2:
                        return false;
                }
            }).lastIndexOf(true), 0);
            var closestRightPlaceholderIndex = $81N94.int_max($i7mYY.map(slides$1, function(slide) {
                switch(slide.TAG | 0){
                    case /* Placeholder */ 1:
                        return true;
                    case /* Product */ 0:
                    case /* UnloadedProduct */ 2:
                        return false;
                }
            }).indexOf(true, currentSlideIndex), 0);
            var currentSlideIndexRelativeToLeftPlaceholder = currentSlideIndex - closestLeftPlaceholderIndex | 0;
            var tooCloseToLeft = currentSlideIndexRelativeToLeftPlaceholder < 10 && closestLeftPlaceholderIndex > 0;
            var tooCloseToRight = (closestRightPlaceholderIndex - currentSlideIndex | 0) < 10;
            var exit = 0;
            if (tooCloseToRight && connectedDirection <= 0) {
                $iv6Yc._1(setConnectedDirection, 1);
                $iv6Yc._1(setConnectedNumPages, connectedNumPages + 1 | 0);
            } else exit = 1;
            if (exit === 1) {
                if (tooCloseToLeft && connectedDirection >= 0) {
                    $iv6Yc._1(setConnectedDirection, -1);
                    $iv6Yc._1(setConnectedNumPages, connectedNumPages + 1 | 0);
                } else $iv6Yc._1(setConnectedDirection, 0);
            }
        }
    }, [
        currentSlideIndex
    ]);
    return $g85JO.useMemo(function() {
        return {
            position: position,
            total: total,
            slides: slides$1,
            error: error
        };
    }, [
        position,
        total,
        slides$1,
        error
    ]);
}
function $df2f4285010a27d5$export$793e55090f3dc085(quickViewConfig, category, settings, productId, variantId) {
    var match = $hBcYV.useRouter(undefined);
    var isInsideQuickView = match.isQuickView;
    var match$1 = $hBcYV.useRouter(undefined);
    var quickView = match$1.raw.quickView;
    var config = $df2f4285010a27d5$export$37b398bdc9e846c0(category, settings, productId, variantId);
    var match$2 = quickView.mediaId;
    var media = quickViewConfig !== undefined && match$2 !== undefined ? $fLfrY.mediaById(quickViewConfig, match$2) : undefined;
    return $g85JO.useMemo(function() {
        if (!isInsideQuickView) return config;
        if (media === undefined) return config;
        if (quickViewConfig === undefined) return config;
        var products = $i7mYY.reduce($iv6Yc._2($fLfrY.productsInMedia, quickViewConfig, media), [], function(acc, curr) {
            var found = $i7mYY.some(acc, function(media) {
                return media.id === curr.id;
            });
            if (found) return acc;
            else return $i7mYY.concat(acc, [
                curr
            ]);
        });
        var total = products.length;
        var position = $i7mYY.getIndexBy(products, function(p) {
            return $7bjme.equal(p.id, productId);
        });
        if (position !== undefined) return {
            position: position,
            total: total,
            slides: $i7mYY.mapWithIndex(products, function(order, product) {
                return $8iMy9.Slide.makeProductSlide(undefined, variantId, order, product);
            }),
            error: undefined
        };
        else return config;
    }, [
        $8iMy9.getKey(config),
        quickViewConfig,
        quickView.mediaId,
        isInsideQuickView,
        variantId
    ]);
}
function $df2f4285010a27d5$var$UsePDPPagination$DebugViewer(Props) {
    var currentProductId = Props.currentProductId;
    var data = Props.data;
    var store = $8L1B1.use(undefined);
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var goToProduct = $g85JO.useCallback(function(productId) {
        return function(variantId) {
            if (typeof route === "number") return;
            switch(route.TAG | 0){
                case /* PDP */ 2:
                    var pdpRoute = route._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* PDP */ 2,
                        _0: {
                            categoryId: pdpRoute.categoryId,
                            productCategoryId: pdpRoute.productCategoryId,
                            productId: productId,
                            variantId: variantId,
                            zoomedPhotoIndex: pdpRoute.zoomedPhotoIndex
                        }
                    });
                case /* QuickView */ 3:
                    var qvRoute = route._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* QuickView */ 3,
                        _0: {
                            mediaId: qvRoute.mediaId,
                            mediaParentId: qvRoute.mediaParentId,
                            albumId: qvRoute.albumId,
                            productId: productId,
                            relatedMediaProductIds: qvRoute.relatedMediaProductIds,
                            relatedMediaCategoryId: qvRoute.relatedMediaCategoryId,
                            variantId: variantId,
                            panelClosed: qvRoute.panelClosed,
                            zoomedPhotoIndex: qvRoute.zoomedPhotoIndex,
                            time: qvRoute.time
                        }
                    });
                default:
                    return;
            }
        };
    }, []);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute bottom-0 left-0 w-full overflow-auto flex bg-black bg-opacity-80 gap-2"),
        style: {
            zIndex: "2147483647"
        }
    }, /*#__PURE__*/ $g85JO.createElement("h1", {
        className: $ezf3v.prefix("text-red-200 text-4xl sticky left-0 top-0")
    }, "Debug Viewer"), $i7mYY.mapWithIndex(data, function(i, slide) {
        var tmp;
        switch(slide.TAG | 0){
            case /* Product */ 0:
                tmp = slide.product.id === currentProductId ? "opacity-100 bg-red-200 w-8 cursor-pointer" : "opacity-50 bg-white w-4 cursor-pointer";
                break;
            case /* Placeholder */ 1:
                tmp = "opacity-25 bg-transparent w-4";
                break;
            case /* UnloadedProduct */ 2:
                tmp = "opacity-25 bg-white w-4";
                break;
        }
        var tmp$1;
        switch(slide.TAG | 0){
            case /* Product */ 0:
                var product = slide.product;
                tmp$1 = "" + $7KlbQ.getDisplayName(store, product.firstVariant, product) + " (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
                break;
            case /* Placeholder */ 1:
                tmp$1 = "Placeholder (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
                break;
            case /* UnloadedProduct */ 2:
                tmp$1 = "Loading... '" + slide.id + "' (" + String(i + 1 | 0) + " / " + String(data.length) + ")";
                break;
        }
        return /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.callbackDomRef(function(el) {
                if (el == null) return;
                switch(slide.TAG | 0){
                    case /* Product */ 0:
                        if (slide.product.id === currentProductId) {
                            (0, $hPPub.default)(el, {
                                behavior: "smooth",
                                block: "nearest",
                                inline: "center",
                                scrollMode: "always"
                            });
                            return;
                        } else return;
                    case /* Placeholder */ 1:
                    case /* UnloadedProduct */ 2:
                        return;
                }
            }),
            className: $ezf3v.prefix($1TRFX.make([
                "rounded h-3 border border-solid border-white transition-all duration-300",
                tmp,
                "flex-shrink-0"
            ])),
            title: tmp$1,
            onClick: function onClick(param) {
                switch(slide.TAG | 0){
                    case /* Product */ 0:
                        return $iv6Yc._2(goToProduct, slide.product.id, slide.variant.id);
                    case /* Placeholder */ 1:
                    case /* UnloadedProduct */ 2:
                        return;
                }
            }
        });
    }));
}
$df2f4285010a27d5$var$UsePDPPagination$DebugViewer.displayName = "UsePDPPagination.DebugViewer";
var $df2f4285010a27d5$export$fe545c00049c9eb9 = {
    make: $df2f4285010a27d5$var$UsePDPPagination$DebugViewer
};
 /* react Not a pure module */ 
});
parcelRegister("98NfX", function(module, exports) {

$parcel$export(module.exports, "getByPredicateOrFirst", function () { return $6a7b11b89603ba9b$export$d022bc216870242d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $6a7b11b89603ba9b$export$d022bc216870242d(array, predicate) {
    return $2whNH.orElse($i7mYY.getBy(array, predicate), $i7mYY.get(array, 0));
}
 /* No side effect */ 
});

parcelRegister("8TQEo", function(module, exports) {

$parcel$export(module.exports, "toShowsideCategory", function () { return $67ac4d0ddf1c281c$export$aa30f9f8a38ff2c0; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $hG39s = parcelRequire("hG39s");

var $ij6do = parcelRequire("ij6do");
function $67ac4d0ddf1c281c$export$aa30f9f8a38ff2c0(settings, category) {
    var newrecord = $7bjme.obj_dup($ij6do.empty);
    newrecord.categoryType = {
        TAG: /* Standard */ 1,
        _0: {
            firstCard: undefined,
            externalConnection: {
                TAG: /* StoreCategory */ 0,
                _0: {
                    categoryId: $iv6Yc._1($hG39s.CategoryId.toString, category.id),
                    sortBy: /* Default */ 0,
                    filterBy: undefined,
                    count: $2whNH.getWithDefault(category.productsCount, 0),
                    relatedMediaCount: undefined
                }
            },
            children: [],
            loadMoreChildren: undefined,
            totalChildren: 0,
            link: category.link,
            products: [],
            taggedMedia: undefined,
            imageHotspots: undefined,
            imageWidth: undefined,
            imageHeight: undefined
        }
    };
    newrecord.card = {
        TAG: /* MedialessLinkCard */ 5,
        _0: {
            link: {
                TAG: /* URL */ 0,
                _0: $2whNH.getWithDefault(category.link, "")
            },
            size: settings.productCardSize,
            shape: settings.productCardShape
        }
    };
    newrecord.title = $2whNH.getWithDefault(category.name, "");
    newrecord.id = $iv6Yc._1($hG39s.CategoryId.toString, category.id);
    return newrecord;
}
 /* StoreId-ApiTypes Not a pure module */ 
});


parcelRegister("2vzQN", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $1d3a492b38f7b2d6$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7KlbQ = parcelRequire("7KlbQ");

var $1xf0g = parcelRequire("1xf0g");

var $38gYA = parcelRequire("38gYA");

var $gCzsf = parcelRequire("gCzsf");

var $fN11P = parcelRequire("fN11P");

var $4qWal = parcelRequire("4qWal");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $jFdMp = parcelRequire("jFdMp");

var $5YnL9 = parcelRequire("5YnL9");

var $9pMGg = parcelRequire("9pMGg");

var $sK0FX = parcelRequire("sK0FX");

var $8E2YL = parcelRequire("8E2YL");

var $lHzh8 = parcelRequire("lHzh8");
function $1d3a492b38f7b2d6$var$PDPContentDesktop$HeaderTitle(Props) {
    var productCategory = Props.productCategory;
    var match = $hBcYV.useRouter(undefined);
    var listPageType = match.listPageType;
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onHistoryClick = match$1.onHistoryClick;
    var onFavoritesClick = match$1.onFavoritesClick;
    var isDeeplinked = match$1.embedType !== /* ProductDetailsPage */ 5;
    var title;
    if (listPageType !== undefined && typeof listPageType === "number") switch(listPageType){
        case /* Favorites */ 0:
            title = "Favorites";
            break;
        case /* History */ 1:
            title = "Recently Viewed";
            break;
        case /* StoreCart */ 2:
            title = productCategory.title;
            break;
    }
    else title = productCategory.title;
    var handleClick = isDeeplinked ? function handleClick(e) {
        e.preventDefault();
        if (listPageType !== undefined && typeof listPageType === "number") switch(listPageType){
            case /* Favorites */ 0:
                return $iv6Yc._1(onFavoritesClick, undefined);
            case /* History */ 1:
                return $iv6Yc._1(onHistoryClick, undefined);
            case /* StoreCart */ 2:
                break;
        }
        $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* ListPage */ 1,
            _0: {
                listPageType: {
                    TAG: /* Category */ 0,
                    _0: productCategory.id
                },
                viewPLP: false,
                filters: undefined,
                sort: undefined
            }
        });
    } : undefined;
    var tmp;
    if (handleClick !== undefined) tmp = /*#__PURE__*/ $g85JO.createElement("a", {
        className: $ezf3v.prefix("!text-primary !no-underline"),
        href: "#",
        onClick: handleClick
    }, title);
    else {
        var tmp$1 = {
            className: $ezf3v.prefix($1TRFX.make([
                "!text-primary !no-underline",
                $1xf0g.getCategoryLink(productCategory) === undefined ? "cursor-default" : "cursor-pointer"
            ]))
        };
        var tmp$2 = $1xf0g.getCategoryLink(productCategory);
        if (tmp$2 !== undefined) tmp$1.href = $loT9g.valFromOption(tmp$2);
        tmp = /*#__PURE__*/ $g85JO.createElement("a", tmp$1, title);
    }
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-category-link",
        children: tmp
    });
}
$1d3a492b38f7b2d6$var$PDPContentDesktop$HeaderTitle.displayName = "PDPContentDesktop.HeaderTitle";
var $1d3a492b38f7b2d6$export$edb76fdb8665f52 = {
    make: $1d3a492b38f7b2d6$var$PDPContentDesktop$HeaderTitle
};
function $1d3a492b38f7b2d6$var$PDPContentDesktop$StaticHeader(Props) {
    var config = Props.config;
    var productCategory = Props.productCategory;
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var route = match.route;
    var goToProduct = function goToProduct(direction) {
        var position = direction === "left" ? config.position - 1 | 0 : direction === "right" ? config.position + 1 | 0 : 0;
        var nextProduct = $i7mYY.get(config.slides, position);
        if (nextProduct === undefined) return;
        switch(nextProduct.TAG | 0){
            case /* Product */ 0:
                var product = nextProduct.product;
                if (typeof route !== "number") switch(route.TAG | 0){
                    case /* PDP */ 2:
                        var match = route._0;
                        return $iv6Yc._3(goTo, undefined, undefined, {
                            TAG: /* PDP */ 2,
                            _0: {
                                categoryId: match.categoryId,
                                productCategoryId: $2whNH.orElse(match.productCategoryId, productCategory.id),
                                productId: product.id,
                                variantId: undefined,
                                zoomedPhotoIndex: undefined
                            }
                        });
                    case /* QuickView */ 3:
                        var match$1 = route._0;
                        return $iv6Yc._3(goTo, undefined, undefined, {
                            TAG: /* QuickView */ 3,
                            _0: {
                                mediaId: match$1.mediaId,
                                mediaParentId: match$1.mediaParentId,
                                albumId: undefined,
                                productId: product.id,
                                relatedMediaProductIds: match$1.relatedMediaProductIds,
                                relatedMediaCategoryId: match$1.relatedMediaCategoryId,
                                variantId: undefined,
                                panelClosed: match$1.panelClosed,
                                zoomedPhotoIndex: undefined,
                                time: undefined
                            }
                        });
                    default:
                }
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: productCategory.id,
                        productCategoryId: productCategory.id,
                        productId: product.id,
                        variantId: undefined,
                        zoomedPhotoIndex: undefined
                    }
                });
            case /* Placeholder */ 1:
            case /* UnloadedProduct */ 2:
                return;
        }
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex justify-between items-center text-lg mb-4 h-9")
    }, config.position > 0 && config.total > 1 ? /*#__PURE__*/ $g85JO.createElement("button", {
        className: $ezf3v.prefix("flex items-center gap-2 bg-transparent cursor-pointer text-primary w-44 no-underline group-2 hover:underline whitespace-nowrap font-medium"),
        onClick: function onClick(e) {
            e.preventDefault();
            goToProduct("left");
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("transform scale-60 w-12 h-12 flex items-center flex-shrink-0 justify-center rounded-full ring-2 ring-primary text-primary group-2-hover:bg-primary group-2-hover:text-main")
    }, /*#__PURE__*/ $g85JO.createElement($fN11P.make, {})), "PREVIOUS PRODUCT") : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("w-44")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("text-center text-primary flex justify-center gap-6")
    }, /*#__PURE__*/ $g85JO.createElement($1d3a492b38f7b2d6$var$PDPContentDesktop$HeaderTitle, {
        productCategory: productCategory
    }), config.total > 1 ? /*#__PURE__*/ $g85JO.createElement("span", undefined, String(config.position + 1 | 0) + "/" + String(config.total)) : null), config.position < (config.total - 1 | 0) ? /*#__PURE__*/ $g85JO.createElement("button", {
        className: $ezf3v.prefix("flex items-center gap-2 text-primary w-44 justify-end bg-transparent cursor-pointer no-underline group-2 hover:underline whitespace-nowrap font-medium"),
        onClick: function onClick(e) {
            e.preventDefault();
            goToProduct("right");
        }
    }, "NEXT PRODUCT", /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("transform scale-60 w-12 h-12 flex items-center flex-shrink-0 justify-center rounded-full ring-2 ring-primary text-primary group-2-hover:bg-primary group-2-hover:text-main")
    }, /*#__PURE__*/ $g85JO.createElement($4qWal.make, {}))) : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("w-44")
    }));
}
$1d3a492b38f7b2d6$var$PDPContentDesktop$StaticHeader.displayName = "PDPContentDesktop.StaticHeader";
var $1d3a492b38f7b2d6$export$7b093cc9549ab395 = {
    make: $1d3a492b38f7b2d6$var$PDPContentDesktop$StaticHeader
};
function $1d3a492b38f7b2d6$var$PDPContentDesktop$Layout(Props) {
    var photos = Props.photos;
    var basicInfo = Props.basicInfo;
    var moreInfo = Props.moreInfo;
    var match = $8E2YL.use(undefined).config;
    var match$1 = match.settings.desktopPDPLayout;
    switch(match$1){
        case /* Old */ 0:
        case /* Horizontal */ 1:
            break;
        case /* Vertical */ 2:
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-full relative m-auto")
            }, photos), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-full relative m-auto"),
                style: {
                    maxWidth: "1400px"
                }
            }, basicInfo));
    }
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("w-full relative m-auto grid gap-13"),
        style: {
            gridTemplateColumns: "1fr 384px"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", undefined, photos), /*#__PURE__*/ $g85JO.createElement("div", undefined, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("sticky top-0")
    }, basicInfo)), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-2")
    }, moreInfo));
}
$1d3a492b38f7b2d6$var$PDPContentDesktop$Layout.displayName = "PDPContentDesktop.Layout";
var $1d3a492b38f7b2d6$export$c84671f46d6a1ca = {
    make: $1d3a492b38f7b2d6$var$PDPContentDesktop$Layout
};
function $1d3a492b38f7b2d6$var$PDPContentDesktop(Props) {
    var config = Props.config;
    var product = Props.product;
    var variant = Props.variant;
    var productCategory = Props.productCategory;
    var shouldForceMobile = Props.shouldForceMobile;
    var isInsideQuickView = Props.isInsideQuickView;
    var viewport = Props.viewport;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var scrollToRef = Props.scrollToRef;
    var quickViewConfig = Props.quickViewConfig;
    var showMoreProducts = Props.showMoreProducts;
    var renderLauncher = Props.renderLauncher;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    $aSJcu.use(undefined);
    $9pMGg.use(undefined);
    $hBcYV.useRouter(undefined);
    var hideMediaFromOtherVariants = $2whNH.mapWithDefault(match.transitiveAccount, false, function(account) {
        return account.pdpHideMediaFromOtherVariants;
    });
    var allVariantMedia = $g85JO.useMemo(function() {
        return $7KlbQ.getAllVariantMedia(hideMediaFromOtherVariants, product, variant);
    }, [
        variant.id,
        product.id
    ]);
    var stickyDetailsRef = $g85JO.useRef(function(visible) {});
    var scrollToDetails = $g85JO.useCallback(function(param) {
        $iv6Yc._1(scrollToRef.current, /* Top */ 0);
    }, []);
    var scrollToDetailsRef = $g85JO.useRef(scrollToDetails);
    var relatedProductsLayout = $g85JO.useMemo(function() {
        return {
            TAG: /* GridLayout */ 1,
            _0: {
                columns: /* FourColumnGrid */ 3,
                gap: /* Half */ 1,
                maxRows: undefined,
                maxWidth: undefined,
                padding: undefined,
                pattern: undefined
            }
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return /* Visible */ 3;
    });
    var setCTAVisible = match$1[1];
    var ctaVisible = match$1[0];
    var handleCTAVisibilityChange = $g85JO.useCallback(function(visibility) {
        $iv6Yc._1(setCTAVisible, function(param) {
            return visibility;
        });
    }, [
        setCTAVisible
    ]);
    var moreSections = $sK0FX.useMoreSections(false, productCategory, undefined, undefined, undefined, undefined, true, settings.desktopPDPLayout === /* Vertical */ 2 ? /* Accordion */ 1 : /* Hidden */ 0, shouldForceMobile, relatedProductsLayout, scrollableContainerRef, product.id, undefined, product, variant, undefined);
    var match$2 = settings.desktopPDPLayout;
    var match$3 = settings.desktopPDPLayout;
    var tmp;
    if (ctaVisible !== 0) switch(ctaVisible){
        case /* HiddenBottom */ 1:
            tmp = true;
            break;
        case /* Hidden */ 2:
            tmp = match$3 !== 1;
            break;
        case /* Visible */ 3:
            tmp = false;
            break;
    }
    else tmp = match$3 !== 1;
    var tmp$1 = {
        config: config,
        product: product,
        productCategory: productCategory,
        settings: settings
    };
    if (quickViewConfig !== undefined) tmp$1.quickViewConfig = $loT9g.valFromOption(quickViewConfig);
    var match$4 = settings.desktopPDPLayout;
    var match$5 = settings.desktopPDPLayout;
    var match$6 = settings.desktopPDPLayout;
    var match$7 = settings.desktopPDPLayout;
    var tmp$2 = {
        product: product,
        variant: variant,
        productCategory: productCategory,
        shouldForceMobile: shouldForceMobile,
        isInsideQuickView: isInsideQuickView,
        scrollableContainerRef: scrollableContainerRef,
        scrollToDetailsRef: scrollToDetailsRef,
        stickyDetailsRef: stickyDetailsRef,
        showHeader: true,
        collapsible: false,
        titleStyle: "normal",
        largeTitleStyle: "medium",
        optionSize: /* Md */ 2,
        optionStyle: /* Border */ 0,
        colorOptionSize: /* Xxl */ 5,
        hideRelatedProductId: product.id,
        showEnhanceContent: settings.desktopPDPLayout === /* Vertical */ 2,
        showRelatedMedia: settings.desktopPDPLayout === /* Vertical */ 2,
        showMoreProducts: $2whNH.getWithDefault(showMoreProducts, settings.desktopPDPLayout === /* Vertical */ 2),
        descriptionLayout: /* Hidden */ 0,
        onCTAButtonVisibilityChange: handleCTAVisibilityChange,
        stickyCTA: false,
        relatedProductsLayout: relatedProductsLayout,
        layout: match$7 >= 2 ? /* TwoColumns */ 1 : /* SingleColumn */ 0,
        separator: false,
        headerSize: /* Large */ 1,
        sections: [
            "promo",
            "detailed",
            "variants",
            "quantity",
            "cta",
            "summary"
        ]
    };
    var tmp$3 = settings.desktopPDPLayout === /* Vertical */ 2 ? undefined : "";
    if (tmp$3 !== undefined) tmp$2.singleColumnHorizontalPadding = $loT9g.valFromOption(tmp$3);
    var match$8 = settings.desktopPDPLayout;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp",
        children: /*#__PURE__*/ $g85JO.createElement($38gYA.make, {
            restorationId: isInsideQuickView ? "qv-pdp" : "nav-pdp",
            scrollToRef: scrollToRef,
            children: null,
            fwdRef: scrollableContainerRef,
            className: $ezf3v.prefix("flex flex-col absolute inset-0 bg-main p-17"),
            rememberScrollPosition: false
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("w-full relative m-auto")
        }, /*#__PURE__*/ $g85JO.createElement($5YnL9.make, {
            product: product,
            variant: variant,
            scrollToDetails: scrollToDetails,
            scrollableContainerRef: scrollableContainerRef,
            position: match$2 !== 1 ? /* FixedBottom */ 2 : /* FixedTop */ 3,
            animateVisibility: tmp,
            shadow: true,
            bg: false,
            image: true,
            showCTA: false,
            promoText: true,
            reviews: true,
            maxWidth: "1400px",
            size: /* Lg */ 1,
            variants: true,
            optionSize: /* Md */ 2,
            optionStyle: /* Dropdown */ 2,
            colorOptionSize: /* Xl */ 4,
            titleStyle: "normal",
            largeTitleStyle: "medium",
            titleSize: "small"
        }), $2whNH.mapWithDefault(renderLauncher, null, function(fn) {
            return $iv6Yc._1(fn, $ezf3v.prefix("-mt-7 mb-7"));
        }), /*#__PURE__*/ $g85JO.createElement($1d3a492b38f7b2d6$var$PDPContentDesktop$StaticHeader, tmp$1)), /*#__PURE__*/ $g85JO.createElement($1d3a492b38f7b2d6$var$PDPContentDesktop$Layout, {
            photos: /*#__PURE__*/ $g85JO.createElement($jFdMp.make, {
                product: product,
                variantId: variant.id,
                productCategory: productCategory,
                medias: allVariantMedia,
                viewport: viewport,
                settings: settings,
                containerWidthAdjustment: match$4 !== 1 ? 0 : -524,
                maxContainerHeight: match$5 !== 1 ? 1000 : 1400,
                maxCount: match$6 !== 1 ? 4 : 3
            }),
            basicInfo: /*#__PURE__*/ $g85JO.createElement($sK0FX.make, tmp$2),
            moreInfo: /*#__PURE__*/ $g85JO.createElement("div", undefined, match$8 !== 0 ? null : /*#__PURE__*/ $g85JO.createElement($lHzh8.DetailedAccordions.make, {
                variant: variant,
                product: product
            }), /*#__PURE__*/ $g85JO.createElement($lHzh8.MoreSections.make, {
                product: product,
                moreSections: moreSections
            }))
        }))
    });
}
$1d3a492b38f7b2d6$var$PDPContentDesktop.displayName = "PDPContentDesktop";
var $1d3a492b38f7b2d6$export$dd44f18ab656f3bb = $1d3a492b38f7b2d6$var$PDPContentDesktop;
 /* react Not a pure module */ 
});
parcelRegister("fN11P", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $b7ec3ad553d7677e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $b7ec3ad553d7677e$var$IconArrowLeft(Props) {
    var className = Props.className;
    var tmp = {
        height: "19",
        width: "21",
        fill: "none",
        viewBox: "0 0 21 19",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M20.9531 9.95336C20.9531 10.6096 20.4375 11.1252 19.8281 11.1252H3.89062L10.125 17.0315C10.5938 17.4534 10.5938 18.2034 10.1719 18.6252C9.75 19.094 9.04688 19.094 8.57812 18.6721L0.328125 10.7971C0.09375 10.5627 0 10.2815 0 9.95336C0 9.67211 0.09375 9.39086 0.328125 9.15648L8.57812 1.28148C9.04688 0.859606 9.75 0.859606 10.1719 1.32836C10.5938 1.75023 10.5938 2.50023 10.125 2.92211L3.89062 8.82836H19.8281C20.4844 8.82836 20.9531 9.34398 20.9531 9.95336Z",
        fill: "currentColor"
    }));
}
$b7ec3ad553d7677e$var$IconArrowLeft.displayName = "IconArrowLeft";
var $b7ec3ad553d7677e$export$dd44f18ab656f3bb = $b7ec3ad553d7677e$var$IconArrowLeft;
 /* react Not a pure module */ 
});

parcelRegister("4qWal", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $33a6b5a3af30c274$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $33a6b5a3af30c274$var$IconArrowRight(Props) {
    var className = Props.className;
    var tmp = {
        height: "16",
        width: "20",
        fill: "none",
        preserveAspectRatio: "xMidYMid slice",
        viewBox: "0 0 20 16",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M12 1L19 8M19 8L12 15M19 8H1",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2"
    }));
}
$33a6b5a3af30c274$var$IconArrowRight.displayName = "IconArrowRight";
var $33a6b5a3af30c274$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($33a6b5a3af30c274$var$IconArrowRight);
 /* make Not a pure module */ 
});

parcelRegister("jFdMp", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e50c8905f9754061$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $i3Bxr = parcelRequire("i3Bxr");

var $8dLtV = parcelRequire("8dLtV");

var $gCzsf = parcelRequire("gCzsf");

var $fdM5o = parcelRequire("fdM5o");

var $1t9ha = parcelRequire("1t9ha");

var $biidj = parcelRequire("biidj");

var $hBcYV = parcelRequire("hBcYV");

var $9JqU1 = parcelRequire("9JqU1");

var $9pMGg = parcelRequire("9pMGg");

var $edu9N = parcelRequire("edu9N");
function $e50c8905f9754061$export$6353f655434817c5(item) {
    var tmp;
    switch(item.TAG | 0){
        case /* Image */ 0:
            var match = item._0;
            tmp = [
                match.width,
                match.height
            ];
            break;
        case /* Video */ 1:
            tmp = $2whNH.map($7KlbQ.getVideoSource(item._0), function(source) {
                return [
                    source.width,
                    source.height
                ];
            });
            break;
        case /* IframeEmbed */ 2:
            tmp = undefined;
            break;
    }
    return $2whNH.map(tmp, function(param) {
        return [
            Math.max(param[0], 1),
            Math.max(param[1], 1)
        ];
    });
}
function $e50c8905f9754061$var$DesktopPhotoGrid(Props) {
    var product = Props.product;
    var variantId = Props.variantId;
    var productCategory = Props.productCategory;
    var medias = Props.medias;
    var viewport = Props.viewport;
    var settings = Props.settings;
    var containerWidthAdjustmentOpt = Props.containerWidthAdjustment;
    var maxContainerHeightOpt = Props.maxContainerHeight;
    var maxCountOpt = Props.maxCount;
    var containerWidthAdjustment = containerWidthAdjustmentOpt !== undefined ? containerWidthAdjustmentOpt : 0;
    var maxContainerHeight = maxContainerHeightOpt !== undefined ? maxContainerHeightOpt : 1000;
    var maxCount = maxCountOpt !== undefined ? maxCountOpt : 4;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var route = match$1.route;
    var shape = settings.productCardShape;
    var ratio = $diVVk.Size.getRatio(shape);
    var shapeWithoutCustom = typeof shape === "number" ? shape : $i3Bxr.CardShape.getClosestCardShapeByAspectRatio(shape._0, shape._1);
    var count = Math.min(medias.length, maxCount);
    var isAsymmetric;
    if (typeof shapeWithoutCustom === "number") switch(shapeWithoutCustom){
        case /* Landscape */ 2:
        case /* Panorama */ 4:
        case /* Wide */ 5:
            isAsymmetric = count === 3;
            break;
        case /* Circle */ 0:
        case /* Square */ 1:
        case /* Portrait */ 3:
        case /* Tall */ 6:
            isAsymmetric = count === maxCount;
            break;
    }
    else isAsymmetric = false;
    var match$2 = isAsymmetric ? count !== 3 ? [
        5,
        2
    ] : [
        3,
        2
    ] : count !== 4 ? [
        count | 0,
        1
    ] : [
        2,
        2
    ];
    var cols = match$2[0];
    var gapCount = cols - 1 | 0;
    var gapWidth = 12 * gapCount;
    var containerWidth = $biidj.useWindowWidth(undefined, undefined, undefined, undefined) + containerWidthAdjustment | 0;
    var itemWidth = (containerWidth - gapWidth) / cols;
    var itemWidth$1 = isAsymmetric ? itemWidth * 2 : itemWidth;
    var containerHeight = itemWidth$1 / ratio | 0;
    var containerHeight$1 = Math.min(containerHeight, maxContainerHeight);
    var itemWidth$2 = containerHeight$1 * ratio;
    var itemWidth$3 = isAsymmetric ? itemWidth$2 / 2 : itemWidth$2;
    var containerWidth$1 = itemWidth$3 * cols + gapWidth;
    var rowHeight = isAsymmetric ? containerHeight$1 / 2 : containerHeight$1;
    var getArea = function getArea(index) {
        var match = (count | 0) - index | 0;
        var match$1 = isAsymmetric && !(match === 2 || match === 1) ? [
            2,
            2
        ] : [
            1,
            1
        ];
        var rowSpan = match$1[1];
        var colSpan = match$1[0];
        return "span " + String(colSpan) + " / span " + String(colSpan) + "" + (" / span " + String(rowSpan) + " / span " + String(rowSpan) + "");
    };
    var onPhotoZoomed = $g85JO.useCallback(function(index) {
        if (typeof route !== "number") switch(route.TAG | 0){
            case /* PDP */ 2:
                var payload = route._0;
                return $iv6Yc._3(goTo, undefined, true, {
                    TAG: /* PDP */ 2,
                    _0: {
                        categoryId: payload.categoryId,
                        productCategoryId: payload.productCategoryId,
                        productId: payload.productId,
                        variantId: payload.variantId,
                        zoomedPhotoIndex: index
                    }
                });
            case /* QuickView */ 3:
                var payload$1 = route._0;
                return $iv6Yc._3(goTo, undefined, undefined, {
                    TAG: /* QuickView */ 3,
                    _0: {
                        mediaId: payload$1.mediaId,
                        mediaParentId: payload$1.mediaParentId,
                        albumId: payload$1.albumId,
                        productId: payload$1.productId,
                        relatedMediaProductIds: payload$1.relatedMediaProductIds,
                        relatedMediaCategoryId: payload$1.relatedMediaCategoryId,
                        variantId: payload$1.variantId,
                        panelClosed: payload$1.panelClosed,
                        zoomedPhotoIndex: index,
                        time: payload$1.time
                    }
                });
            default:
        }
        $iv6Yc._3(goTo, undefined, true, {
            TAG: /* PDP */ 2,
            _0: {
                categoryId: productCategory.id,
                productCategoryId: productCategory.id,
                productId: product.id,
                variantId: variantId,
                zoomedPhotoIndex: index
            }
        });
    }, [
        $hBcYV.toString(route)
    ]);
    var onSlideChange = function onSlideChange(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image scroll",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var onClickThumbnail = function onClickThumbnail(param) {
        $iv6Yc.app(trackEvent, [
            "product details:image select",
            undefined,
            undefined,
            product,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var tmp;
    if (typeof route === "number" || route.TAG !== /* PDP */ 2) tmp = null;
    else {
        var zoomedPhotoIndex = route._0.zoomedPhotoIndex;
        if ($2whNH.isSome(zoomedPhotoIndex)) {
            var tmp$1 = {
                product: product,
                variantId: variantId,
                medias: medias,
                viewport: viewport,
                onSlideChange: onSlideChange,
                onClickThumbnail: onClickThumbnail,
                bgBlur: false,
                thumbnailsPosition: "center",
                onClose: function onClose(param) {
                    $iv6Yc._1(onPhotoZoomed, undefined);
                },
                onPhotoZoomed: onPhotoZoomed
            };
            if (zoomedPhotoIndex !== undefined) tmp$1.selectedIndex = $loT9g.valFromOption(zoomedPhotoIndex);
            tmp = /*#__PURE__*/ $g85JO.createElement($9JqU1.make, tmp$1);
        } else tmp = null;
    }
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "pdp-images",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("w-full flex justify-center mb-14")
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("grid grid-flow-col gap-4"),
            style: {
                width: String(containerWidth$1) + "px",
                gridTemplateColumns: "repeat(" + String(cols) + ", minmax(0, 1fr))",
                gridTemplateRows: "repeat(" + String(match$2[1]) + ", minmax(0, " + String(rowHeight) + "px))"
            }
        }, $i7mYY.mapWithIndex($i7mYY.slice(medias, 0, count | 0), function(idx, item) {
            var tmp;
            switch(item.TAG | 0){
                case /* Video */ 1:
                    tmp = $2whNH.getWithDefault($2whNH.map($7KlbQ.getVideoSource(item._0), function(source) {
                        return source.url;
                    }), String(idx));
                    break;
                case /* Image */ 0:
                case /* IframeEmbed */ 2:
                    tmp = item._0.url;
                    break;
            }
            var tmp$1;
            switch(item.TAG | 0){
                case /* Image */ 0:
                    tmp$1 = /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
                        src: item._0.url,
                        fit: settings.productCardFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
                        alt: product.name,
                        priority: 0
                    });
                    break;
                case /* Video */ 1:
                    var video = item._0;
                    var src = $2whNH.map($7KlbQ.getVideoSource(video), function(source) {
                        return source.url;
                    });
                    if (src !== undefined) {
                        var tmp$2 = {
                            src: src,
                            viewport: viewport,
                            objectFit: settings.productCardFitToContainer ? "contain" : "cover",
                            prioritize: true,
                            autoplay: settings.videoAutoPlay,
                            loop: settings.videoLoop,
                            muted: settings.videoMute,
                            controls: settings.videoControls,
                            key: variantId
                        };
                        if (video.posterUrl !== undefined) tmp$2.poster = video.posterUrl;
                        tmp$1 = /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp$2);
                    } else tmp$1 = null;
                    break;
                case /* IframeEmbed */ 2:
                    tmp$1 = /*#__PURE__*/ $g85JO.createElement($8dLtV.make, {
                        url: item._0.url
                    });
                    break;
            }
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: tmp,
                "aria-label": "Zoom in on product photo",
                className: $ezf3v.prefix("relative col-start-auto	row-start-auto cursor-zoom-in shadow-lg"),
                role: "button",
                style: {
                    backgroundColor: "var(--smartnav-color-placeholder, rgb(229, 231, 235))",
                    gridArea: getArea(idx)
                },
                tabIndex: 0,
                onClick: function onClick(param) {
                    $iv6Yc._1(onPhotoZoomed, idx);
                }
            }, tmp$1, idx === ((count | 0) - 1 | 0) ? /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute bottom-8 right-8 flex gap-4")
            }, /*#__PURE__*/ $g85JO.createElement($fdM5o.make, {
                product: product,
                variantId: variantId
            }), medias.length > (count | 0) ? /*#__PURE__*/ $g85JO.createElement($edu9N.make, {
                size: /* Md */ 2,
                label: "See More Photos",
                onClick: function onClick(param) {
                    $iv6Yc._1(onPhotoZoomed, 0);
                },
                primary: true,
                preventDefault: true
            }) : null) : null);
        })))
    }), tmp);
}
$e50c8905f9754061$var$DesktopPhotoGrid.displayName = "DesktopPhotoGrid";
var $e50c8905f9754061$export$5df9adcb0db95e1e = 12;
var $e50c8905f9754061$export$dd44f18ab656f3bb = $e50c8905f9754061$var$DesktopPhotoGrid;
 /* react Not a pure module */ 
});


parcelRegister("huObo", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cbcc2a40936772ef$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $bbixw = parcelRequire("bbixw");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $cbcc2a40936772ef$var$PDPLoadingStencils$StoriesMobilePDPLoading(Props) {
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-2 bg-primary opacity-10 rounded"),
        style: {
            margin: "10px 18px",
            width: "calc(100% - 36px)"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "18px",
            marginLeft: "18px",
            width: "65%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "6px",
            marginLeft: "18px",
            width: "30%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute right-0 top-0 h-6 w-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "38px",
            marginRight: "18px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute left-1/2 bottom-0 transform -translate-x-1/2 bg-primary opacity-10 rounded"),
        style: {
            height: "42px",
            marginBottom: "38px",
            width: "200px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute left-1/2 bottom-0 transform -translate-x-1/2 bg-primary opacity-10 rounded"),
        style: {
            height: "12px",
            marginBottom: "18px",
            width: "80px"
        }
    }));
}
$cbcc2a40936772ef$var$PDPLoadingStencils$StoriesMobilePDPLoading.displayName = "PDPLoadingStencils.StoriesMobilePDPLoading";
var $cbcc2a40936772ef$export$8e655b16932de33d = {
    make: $cbcc2a40936772ef$var$PDPLoadingStencils$StoriesMobilePDPLoading
};
function $cbcc2a40936772ef$var$PDPLoadingStencils$VerticalDesktopPDPLoading(Props) {
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden p-17")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex w-full")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            width: "80px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            margin: "0 auto",
            width: "120px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            width: "80px"
        }
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex flex-col h-full space-x-13"),
        style: {
            margin: "18px",
            width: "calc(100% - 36px)"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("grid gap-6 grid-cols-2 grid-rows-2 flex-grow"),
        style: {
            height: "80%"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-2 bg-primary opacity-10 rounded")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow"),
        style: {
            marginTop: "36px"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            width: "65%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "10px",
            width: "30%"
        }
    }))));
}
$cbcc2a40936772ef$var$PDPLoadingStencils$VerticalDesktopPDPLoading.displayName = "PDPLoadingStencils.VerticalDesktopPDPLoading";
var $cbcc2a40936772ef$export$e6981fefab4b20d6 = {
    make: $cbcc2a40936772ef$var$PDPLoadingStencils$VerticalDesktopPDPLoading
};
function $cbcc2a40936772ef$var$PDPLoadingStencils$HorizontalDesktopPDPLoading(Props) {
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden p-17")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex w-full")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            width: "80px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            margin: "0 auto",
            width: "120px"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            width: "80px"
        }
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex w-full h-full space-x-13"),
        style: {
            marginTop: "18px"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("grid gap-6 grid-cols-2 grid-rows-2 flex-grow"),
        style: {
            width: "50%"
        }
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-2 bg-primary opacity-10 rounded")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("col-span-1 row-span-1 bg-primary opacity-10 rounded")
    })), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "18px",
            marginLeft: "18px",
            width: "65%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "10px",
            marginLeft: "18px",
            width: "30%"
        }
    }))));
}
$cbcc2a40936772ef$var$PDPLoadingStencils$HorizontalDesktopPDPLoading.displayName = "PDPLoadingStencils.HorizontalDesktopPDPLoading";
var $cbcc2a40936772ef$export$b20e88738227af = {
    make: $cbcc2a40936772ef$var$PDPLoadingStencils$HorizontalDesktopPDPLoading
};
function $cbcc2a40936772ef$var$PDPLoadingStencils$DesktopPDPLoading(Props) {
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute flex top-0 left-0 w-full h-full bg-main overflow-hidden")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-full bg-primary opacity-10 rounded"),
        style: {
            width: "60%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex-grow")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "18px",
            marginLeft: "18px",
            width: "65%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "10px",
            marginLeft: "18px",
            width: "30%"
        }
    })));
}
$cbcc2a40936772ef$var$PDPLoadingStencils$DesktopPDPLoading.displayName = "PDPLoadingStencils.DesktopPDPLoading";
var $cbcc2a40936772ef$export$2f2120126920b6d7 = {
    make: $cbcc2a40936772ef$var$PDPLoadingStencils$DesktopPDPLoading
};
function $cbcc2a40936772ef$var$PDPLoadingStencils$MobilePDPLoading(Props) {
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute top-0 left-0 w-full h-full bg-main overflow-hidden")
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("w-full bg-primary opacity-10 rounded"),
        style: {
            height: "60%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "18px",
            marginLeft: "18px",
            width: "65%"
        }
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("h-6 bg-primary opacity-10 rounded"),
        style: {
            marginTop: "10px",
            marginLeft: "18px",
            width: "30%"
        }
    }));
}
$cbcc2a40936772ef$var$PDPLoadingStencils$MobilePDPLoading.displayName = "PDPLoadingStencils.MobilePDPLoading";
var $cbcc2a40936772ef$export$12e59bd34c987f54 = {
    make: $cbcc2a40936772ef$var$PDPLoadingStencils$MobilePDPLoading
};
function $cbcc2a40936772ef$var$PDPLoadingStencils(Props) {
    var productId = Props.productId;
    var variantId = Props.variantId;
    var isInsideQuickView = Props.isInsideQuickView;
    var match = $9pMGg.use(undefined);
    var onBackClick = match.onBackClick;
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var storeId = match$2.transitiveStoreId;
    var settings = match$2.settings;
    var match$3 = $aSJcu.use(undefined);
    var isMobile = match$3.isMobile;
    var renderStencil = function renderStencil(param) {
        var match = settings.newMobilePDP;
        var match$1 = settings.desktopPDPLayout;
        var exit = 0;
        if (match) {
            if (isMobile) return /*#__PURE__*/ $g85JO.createElement($cbcc2a40936772ef$var$PDPLoadingStencils$StoriesMobilePDPLoading, {});
            exit = 2;
        } else exit = 2;
        if (exit === 2) switch(match$1){
            case /* Old */ 0:
                break;
            case /* Horizontal */ 1:
                if (!isMobile && !isInsideQuickView) return /*#__PURE__*/ $g85JO.createElement($cbcc2a40936772ef$var$PDPLoadingStencils$HorizontalDesktopPDPLoading, {});
                break;
            case /* Vertical */ 2:
                if (!isMobile && !isInsideQuickView) return /*#__PURE__*/ $g85JO.createElement($cbcc2a40936772ef$var$PDPLoadingStencils$VerticalDesktopPDPLoading, {});
                break;
        }
        if (isMobile) return /*#__PURE__*/ $g85JO.createElement($cbcc2a40936772ef$var$PDPLoadingStencils$MobilePDPLoading, {});
        else return /*#__PURE__*/ $g85JO.createElement($cbcc2a40936772ef$var$PDPLoadingStencils$DesktopPDPLoading, {});
    };
    var renderAlert = function renderAlert(param) {
        return /*#__PURE__*/ $g85JO.createElement($2ZaET.Delayed.make, {
            delayMs: 5000,
            children: /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
                error: $4QdUt.makeError(true, "Failed to render PDP: timed out after 5s"),
                extraInfo: {
                    requestedStoreId: storeId,
                    requestedProductId: productId,
                    requestedVariantId: variantId
                },
                redirect: onBackClick
            })
        });
    };
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, renderStencil(undefined), renderAlert(undefined));
}
$cbcc2a40936772ef$var$PDPLoadingStencils.displayName = "PDPLoadingStencils";
var $cbcc2a40936772ef$export$dd44f18ab656f3bb = $cbcc2a40936772ef$var$PDPLoadingStencils;
 /* react Not a pure module */ 
});


})();
//# sourceMappingURL=ProductDetailsPage.bs.2a4da2d6.js.map
